// @ts-nocheck
// Autogenerated code. Do not modify!
// --START:LMLayerWorkerCode--
function LMLayerWorkerCode () {
/*! https://mths.be/codepointat v0.2.0 by @mathias */
if (!String.prototype.codePointAt) {
	(function() {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var codePointAt = function(position) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			var size = string.length;
			// `ToInteger`
			var index = position ? Number(position) : 0;
			if (index != index) { // better `isNaN`
				index = 0;
			}
			// Account for out-of-bounds indices:
			if (index < 0 || index >= size) {
				return undefined;
			}
			// Get the first code unit
			var first = string.charCodeAt(index);
			var second;
			if ( // check if it’s the start of a surrogate pair
				first >= 0xD800 && first <= 0xDBFF && // high surrogate
				size > index + 1 // there is a next code unit
			) {
				second = string.charCodeAt(index + 1);
				if (second >= 0xDC00 && second <= 0xDFFF) { // low surrogate
					// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
					return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
				}
			}
			return first;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'codePointAt', {
				'value': codePointAt,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.codePointAt = codePointAt;
		}
	}());
}
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill
if (!Array.prototype.fill) {
  Object.defineProperty(Array.prototype, 'fill', {
    value: function(value) {

      // Steps 1-2.
      if (this == null) {
        throw new TypeError('this is null or not defined');
      }

      var O = Object(this);

      // Steps 3-5.
      var len = O.length >>> 0;

      // Steps 6-7.
      var start = arguments[1];
      var relativeStart = start >> 0;

      // Step 8.
      var k = relativeStart < 0 ?
        Math.max(len + relativeStart, 0) :
        Math.min(relativeStart, len);

      // Steps 9-10.
      var end = arguments[2];
      var relativeEnd = end === undefined ?
        len : end >> 0;

      // Step 11.
      var finalValue = relativeEnd < 0 ?
        Math.max(len + relativeEnd, 0) :
        Math.min(relativeEnd, len);

      // Step 12.
      while (k < finalValue) {
        O[k] = value;
        k++;
      }

      // Step 13.
      return O;
    }
  });
}/**
 * Array.prototype.findIndex() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
 * @license MIT
 */
 if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      // 1. Let O be ? ToObject(this value).
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    },
    configurable: true,
    writable: true
  });
}
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from
// Any npm-based ones require use of `require`, which won't work for us.

// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method 
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}
// https://stackoverflow.com/questions/53308396/how-to-polyfill-array-prototype-includes-for-ie8
if(!Array.prototype.includes){
  //or use Object.defineProperty
  Array.prototype.includes = function(search){
   return !!~this.indexOf(search);
 }
}
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
  Object.keys = (function() {
    'use strict';
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

    return function(obj) {
      if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [], prop, i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());
}

// Now for Object.values, from https://github.com/tc39/proposal-object-values-entries/blob/master/polyfill.js
// Early Android APIs do not support Reflect, hence the need to 'mesh' them like this.

var reduce = Function.bind.call(Function.call, Array.prototype.reduce);
var isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
var concat = Function.bind.call(Function.call, Array.prototype.concat);
//var keys = Reflect.ownKeys;
var keys = Object.keys;

if (!Object.values) {
	Object.values = function values(O) {
		return reduce(keys(O), function(v, k) { return concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : []) }, []);
	};
}

if (!Object.entries) {
	Object.entries = function entries(O) {
		return reduce(keys(O), function(e, k) { return concat(e, typeof k === 'string' && isEnumerable(O, k) ? [[k, O[k]]] : []) }, []);
	};
}// From https://rousan.io/symbol-es6/, lightly modified to be worker-compatible for Android Lollipop.
!function(global,factory){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=factory(global):factory(global)}("undefined"!=typeof window?window:(self?self:global),function(global){"use strict";var defineProperty=Object.defineProperty,defineProperties=Object.defineProperties,symbolHiddenCounter=0,globalSymbolRegistry=[],slice=Array.prototype.slice,ES6="object"==typeof global.ES6?global.ES6:global.ES6={},isArray=Array.isArray,objectToString=Object.prototype.toString,push=Array.prototype.push,emptyFunction=function(){},simpleFunction=function(arg){return arg},isCallable=function(fn){return"function"==typeof fn},Iterator=function(){},ArrayIterator=function(array,flag){this._array=array,this._flag=flag,this._nextIndex=0},StringIterator=function(string,flag){this._string=string,this._flag=flag,this._nextIndex=0},isObject=function(value){return null!==value&&("object"==typeof value||"function"==typeof value)},setupSymbolInternals=function(symbol,desc){return defineProperties(symbol,{_description:{value:desc},_isSymbol:{value:!0},_id:{value:symbolHiddenCounter++}}),symbol},appendArray=function(array1,array2){if("number"==typeof array1.length&&array1.length>=0&&"number"==typeof array2.length&&array2.length>=0){var length1=Math.floor(array1.length),length2=Math.floor(array2.length),i=0;for(array1.length=length1+length2;i<length2;++i)array2.hasOwnProperty(i)&&(array1[length1+i]=array2[i])}},simpleInheritance=function(child,parent){if("function"!=typeof child||"function"!=typeof parent)throw new TypeError("Child and Parent must be function type");child.prototype=Object.create(parent.prototype),child.prototype.constructor=child},Symbol=function Symbol(desc){if(desc=void 0===desc?"":String(desc),this instanceof Symbol)throw new TypeError("Symbol is not a constructor");return setupSymbolInternals(Object.create(Symbol.prototype),desc)};defineProperties(Symbol,{for:{value:function(key){key=String(key);for(var record,registryLength=globalSymbolRegistry.length,i=0;i<registryLength;++i)if((record=globalSymbolRegistry[i]).key===key)return record.symbol;return record={key:key,symbol:Symbol(key)},globalSymbolRegistry.push(record),record.symbol},writable:!0,configurable:!0},keyFor:{value:function(symbol){if(!ES6.isSymbol(symbol))throw new TypeError(String(symbol)+" is not a symbol");for(var record,registryLength=globalSymbolRegistry.length,i=0;i<registryLength;++i)if((record=globalSymbolRegistry[i]).symbol===symbol)return record.key},writable:!0,configurable:!0},hasInstance:{value:Symbol("Symbol.hasInstance")},isConcatSpreadable:{value:Symbol("Symbol.isConcatSpreadable")},iterator:{value:Symbol("Symbol.iterator")},toStringTag:{value:Symbol("Symbol.toStringTag")}}),Symbol.prototype.toString=function(){return"@@_____"+this._id+"_____"},Symbol.prototype.valueOf=function(){return this},defineProperty(Iterator.prototype,Symbol.iterator.toString(),{value:function(){return this},writable:!0,configurable:!0}),simpleInheritance(ArrayIterator,Iterator),simpleInheritance(StringIterator,Iterator),defineProperty(ArrayIterator.prototype,Symbol.toStringTag.toString(),{value:"Array Iterator",configurable:!0}),defineProperty(StringIterator.prototype,Symbol.toStringTag.toString(),{value:"String Iterator",configurable:!0}),ArrayIterator.prototype.next=function(){if(!(this instanceof ArrayIterator))throw new TypeError("Method Array Iterator.prototype.next called on incompatible receiver "+String(this));var nextValue;return-1===this._nextIndex?{done:!0,value:void 0}:"number"==typeof this._array.length&&this._array.length>=0&&this._nextIndex<Math.floor(this._array.length)?(1===this._flag?nextValue=[this._nextIndex,this._array[this._nextIndex]]:2===this._flag?nextValue=this._array[this._nextIndex]:3===this._flag&&(nextValue=this._nextIndex),this._nextIndex++,{done:!1,value:nextValue}):(this._nextIndex=-1,{done:!0,value:void 0})},StringIterator.prototype.next=function(){if(!(this instanceof StringIterator))throw new TypeError("Method String Iterator.prototype.next called on incompatible receiver "+String(this));var nextValue,stringObject=new String(this._string);return-1===this._nextIndex?{done:!0,value:void 0}:this._nextIndex<stringObject.length?(nextValue=stringObject[this._nextIndex],this._nextIndex++,{done:!1,value:nextValue}):(this._nextIndex=-1,{done:!0,value:void 0})};var SpreadOperatorImpl=function(target,thisArg){this._target=target,this._values=[],this._thisArg=thisArg};SpreadOperatorImpl.prototype.spread=function(){var self=this;return slice.call(arguments).forEach(function(iterable){ES6.forOf(iterable,function(value){self._values.push(value)})}),self},SpreadOperatorImpl.prototype.add=function(){var self=this;return slice.call(arguments).forEach(function(value){self._values.push(value)}),self},SpreadOperatorImpl.prototype.call=function(thisArg){if("function"!=typeof this._target)throw new TypeError("Target is not a function");return thisArg=arguments.length<=0?this._thisArg:thisArg,this._target.apply(thisArg,this._values)},SpreadOperatorImpl.prototype.new=function(){if("function"!=typeof this._target)throw new TypeError("Target is not a constructor");var temp,returnValue;return temp=Object.create(this._target.prototype),returnValue=this._target.apply(temp,this._values),isObject(returnValue)?returnValue:temp},SpreadOperatorImpl.prototype.array=function(){if(!isArray(this._target))throw new TypeError("Target is not a array");return push.apply(this._target,this._values),this._target};return defineProperties(ES6,{isSymbol:{value:function(symbol){return symbol instanceof Symbol&&function(symbol){return!0===symbol._isSymbol&&"number"==typeof symbol._id&&"string"==typeof symbol._description}(symbol)},writable:!0,configurable:!0},instanceOf:{value:function(object,constructor){if(!isObject(constructor))throw new TypeError("Right-hand side of 'instanceof' is not an object");var hasInstanceSymbolProp=constructor[Symbol.hasInstance];if(void 0===hasInstanceSymbolProp)return object instanceof constructor;if("function"!=typeof hasInstanceSymbolProp)throw new TypeError(typeof hasInstanceSymbolProp+" is not a function");return hasInstanceSymbolProp.call(constructor,object)},writable:!0,configurable:!0},forOf:{value:function(iterable,callback,thisArg){if(callback="function"!=typeof callback?emptyFunction:callback,"function"!=typeof iterable[Symbol.iterator])throw new TypeError("Iterable[Symbol.iterator] is not a function");var iterationResult,iterator=iterable[Symbol.iterator]();if("function"!=typeof iterator.next)throw new TypeError(".iterator.next is not a function");for(;;){if(iterationResult=iterator.next(),!isObject(iterationResult))throw new TypeError("Iterator result "+iterationResult+" is not an object");if(iterationResult.done)break;callback.call(thisArg,iterationResult.value)}},writable:!0,configurable:!0},spreadOperator:{value:function(target,thisArg){if("function"!=typeof target&&!isArray(target))throw new TypeError("Spread operator only supports on array and function objects at this moment");return new SpreadOperatorImpl(target,thisArg)},writable:!0,configurable:!0}}),defineProperty(global,"Symbol",{value:Symbol,writable:!0,configurable:!0}),defineProperty(Function.prototype,Symbol.hasInstance.toString(),{value:function(instance){return"function"==typeof this&&instance instanceof this}}),defineProperty(Array.prototype,"concat",{value:function(){if(void 0===this||null===this)throw new TypeError("Array.prototype.concat called on null or undefined");var self=Object(this),targets=slice.call(arguments),outputs=[];return targets.unshift(self),targets.forEach(function(target){isObject(target)?void 0!==target[Symbol.isConcatSpreadable]?target[Symbol.isConcatSpreadable]?appendArray(outputs,target):outputs.push(target):isArray(target)?appendArray(outputs,target):outputs.push(target):outputs.push(target)}),outputs},writable:!0,configurable:!0}),defineProperty(Object.prototype,"toString",{value:function(){return void 0===this||null===this?objectToString.call(this):"string"==typeof this[Symbol.toStringTag]?"[object "+this[Symbol.toStringTag]+"]":objectToString.call(this)},writable:!0,configurable:!0}),defineProperty(Array.prototype,Symbol.iterator.toString(),{value:function(){if(void 0===this||null===this)throw new TypeError("Cannot convert undefined or null to object");var self=Object(this);return new ArrayIterator(self,2)},writable:!0,configurable:!0}),defineProperty(Array,"from",{value:function(arrayLike,mapFn,thisArg){var constructor,length,outputs,i=0;if(constructor=isCallable(this)?this:Array,void 0===arrayLike||null===arrayLike)throw new TypeError("Cannot convert undefined or null to object");if(arrayLike=Object(arrayLike),void 0===mapFn)mapFn=simpleFunction;else if(!isCallable(mapFn))throw new TypeError(mapFn+" is not a function");if(void 0===arrayLike[Symbol.iterator]){if(!("number"==typeof arrayLike.length&&arrayLike.length>=0))return(outputs=new constructor(0)).length=0,outputs;for(length=Math.floor(arrayLike.length),(outputs=new constructor(length)).length=length;i<length;++i)outputs[i]=mapFn.call(thisArg,arrayLike[i])}else(outputs=new constructor).length=0,ES6.forOf(arrayLike,function(value){outputs.length++,outputs[outputs.length-1]=mapFn.call(thisArg,value)});return outputs},writable:!0,configurable:!0}),defineProperty(Array.prototype,"entries",{value:function(){if(void 0===this||null===this)throw new TypeError("Cannot convert undefined or null to object");var self=Object(this);return new ArrayIterator(self,1)},writable:!0,configurable:!0}),defineProperty(Array.prototype,"keys",{value:function(){if(void 0===this||null===this)throw new TypeError("Cannot convert undefined or null to object");var self=Object(this);return new ArrayIterator(self,3)},writable:!0,configurable:!0}),defineProperty(String.prototype,Symbol.iterator.toString(),{value:function(){if(void 0===this||null===this)throw new TypeError("String.prototype[Symbol.iterator] called on null or undefined");return new StringIterator(String(this),0)},writable:!0,configurable:!0}),ES6});
"use strict";
// Generated by common/web/keyman-version/build.sh
var com;
(function (com) {
    var keyman;
    (function (keyman) {
        var KEYMAN_VERSION = /** @class */ (function () {
            function KEYMAN_VERSION() {
            }
            KEYMAN_VERSION.VERSION = "16.0.139";
            KEYMAN_VERSION.VERSION_RELEASE = "16.0";
            KEYMAN_VERSION.VERSION_MAJOR = "16";
            KEYMAN_VERSION.VERSION_MINOR = "0";
            KEYMAN_VERSION.VERSION_PATCH = "139";
            KEYMAN_VERSION.TIER = "stable";
            KEYMAN_VERSION.VERSION_TAG = "";
            KEYMAN_VERSION.VERSION_WITH_TAG = "16.0.139";
            KEYMAN_VERSION.VERSION_ENVIRONMENT = "stable";
            KEYMAN_VERSION.SENTRY_RELEASE = "release-16.0.139";
            return KEYMAN_VERSION;
        }());
        keyman.KEYMAN_VERSION = KEYMAN_VERSION;
    })(keyman = com.keyman || (com.keyman = {}));
})(com || (com = {}));
/// <reference path="./version.inc.ts" />
// Add all namespaces defined here to the global scope:
if (typeof module != 'undefined' && typeof module.exports != 'undefined') {
    module.exports['KEYMAN_VERSION'] = com.keyman.KEYMAN_VERSION;
}
var com;
(function (com) {
    var keyman;
    (function (keyman) {
        var utils;
        (function (utils) {
            /**
             * Function     deepCopy
             * Scope        Private
             * @param       {Object}      p           object to copy
             * @param       {Array=}      c0          array member being copied
             * @return      {Object}                  clone ('deep copy') of object
             * Description  Makes an actual copy (not a reference) of an object, copying simple members,
             *              arrays and member objects but not functions, so use with care!
             */
            function deepCopy(p, c0) {
                var c = c0 || {};
                for (var i in p) {
                    if (typeof p[i] === 'object' && p[i] != null) {
                        c[i] = (p[i].constructor === Array) ? [] : {};
                        deepCopy(p[i], c[i]);
                    }
                    else {
                        c[i] = p[i];
                    }
                }
                return c;
            }
            utils.deepCopy = deepCopy;
        })(utils = keyman.utils || (keyman.utils = {}));
    })(keyman = com.keyman || (com.keyman = {}));
})(com || (com = {}));
var com;
(function (com) {
    var keyman;
    (function (keyman) {
        var utils;
        (function (utils) {
            var Browser;
            (function (Browser) {
                Browser["Chrome"] = "chrome";
                Browser["Edge"] = "edge";
                Browser["Firefox"] = "firefox";
                Browser["Native"] = "native";
                Browser["Opera"] = "opera";
                Browser["Safari"] = "safari";
                Browser["Other"] = "other";
            })(Browser = utils.Browser || (utils.Browser = {}));
            var OperatingSystem;
            (function (OperatingSystem) {
                OperatingSystem["Windows"] = "windows";
                OperatingSystem["macOS"] = "macosx";
                OperatingSystem["Linux"] = "linux";
                OperatingSystem["Android"] = "android";
                OperatingSystem["iOS"] = "ios";
                OperatingSystem["Other"] = "other";
            })(OperatingSystem = utils.OperatingSystem || (utils.OperatingSystem = {}));
            var FormFactor;
            (function (FormFactor) {
                FormFactor["Desktop"] = "desktop";
                FormFactor["Phone"] = "phone";
                FormFactor["Tablet"] = "tablet";
            })(FormFactor = utils.FormFactor || (utils.FormFactor = {}));
            /**
             * This class provides an abstract version of com.keyman.Device that is core-friendly,
             * containing only the information needed by web-core for text processing use, devoid
             * of any direct references to the DOM.
             */
            var DeviceSpec = /** @class */ (function () {
                function DeviceSpec(browser, formFactor, OS, touchable) {
                    switch (browser.toLowerCase()) {
                        case Browser.Chrome:
                        case Browser.Edge:
                        case Browser.Firefox:
                        case Browser.Native:
                        case Browser.Opera:
                        case Browser.Safari:
                            this.browser = browser.toLowerCase();
                            break;
                        default:
                            this.browser = Browser.Other;
                    }
                    switch (formFactor.toLowerCase()) {
                        case FormFactor.Desktop:
                        case FormFactor.Phone:
                        case FormFactor.Tablet:
                            this.formFactor = formFactor.toLowerCase();
                            break;
                        default:
                            throw ("Invalid form factor specified for device: " + formFactor);
                    }
                    switch (OS.toLowerCase()) {
                        case OperatingSystem.Windows.toLowerCase():
                        case OperatingSystem.macOS.toLowerCase():
                        case OperatingSystem.Linux.toLowerCase():
                        case OperatingSystem.Android.toLowerCase():
                        case OperatingSystem.iOS.toLowerCase():
                            this.OS = OS.toLowerCase();
                            break;
                        default:
                            this.OS = OperatingSystem.Other;
                    }
                    this.touchable = touchable;
                }
                return DeviceSpec;
            }());
            utils.DeviceSpec = DeviceSpec;
        })(utils = keyman.utils || (keyman.utils = {}));
    })(keyman = com.keyman || (com.keyman = {}));
})(com || (com = {}));
var com;
(function (com) {
    var keyman;
    (function (keyman) {
        var utils;
        (function (utils) {
            /**
             * Returns the base global object available to the current JS platform.
             * - In browsers, returns `window`.
             * - In WebWorkers, returns `self`.
             * - In Node, returns `global`.
             */
            function getGlobalObject() {
                // Evergreen browsers have started defining 'globalThis'.  
                // Refer to https://devblogs.microsoft.com/typescript/announcing-typescript-3-4/#type-checking-for-globalthis
                // and its referenced polyfill.  Said polyfill is very complex, so we opt for this far leaner variant.
                if (typeof globalThis != 'undefined') {
                    return globalThis; // Not available in IE or older Edge versions
                    // @ts-ignore (TS will throw errors for whatever platform we're not compiling for.)
                }
                else if (typeof window != 'undefined') {
                    // @ts-ignore
                    return window; // The browser-based classic
                    // @ts-ignore
                }
                else if (typeof self != 'undefined') {
                    // @ts-ignore
                    return self; // WebWorker global
                }
                else {
                    // Assumption - if neither of the above exist, we're in Node, for unit-testing.
                    // Node doesn't have as many methods and properties as the other two, but what 
                    // matters for us is that it's the base global.
                    //
                    // Some other headless JS solutions use 'this' instead, but Node's enough for our needs.
                    // @ts-ignore
                    return global;
                }
            }
            utils.getGlobalObject = getGlobalObject;
        })(utils = keyman.utils || (keyman.utils = {}));
    })(keyman = com.keyman || (com.keyman = {}));
})(com || (com = {}));
// Ensure that this class contains no reference into core KMW code - it is referenced
// by components intended to be modular and possible to separate from core KMW.
var com;
(function (com) {
    var keyman;
    (function (keyman) {
        var utils;
        (function (utils) {
            // Dotted-decimal version
            var Version = /** @class */ (function () {
                /**
                 * Parses version information, preparing it for use in comparisons.
                 * @param text Either a string representing a version number (ex: "9.0.0") or an array representing
                 *             its components (ex: [9, 0, 0]).
                 */
                function Version(text) {
                    // If a keyboard doesn't specify a version, use the DEVELOPER_VERSION_FALLBACK values.
                    if (text === undefined || text === null) {
                        this.components = [].concat(Version.DEVELOPER_VERSION_FALLBACK.components);
                        return;
                    }
                    if (Array.isArray(text)) {
                        var components = text;
                        if (components.length < 2) {
                            throw new Error("Version string must have at least a major and minor component!");
                        }
                        else {
                            this.components = [].concat(components);
                            return;
                        }
                    }
                    // else, standard constructor path.
                    var parts = text.split('.');
                    var componentArray = [];
                    if (parts.length < 2) {
                        throw new Error("Version string must have at least a major and minor component!");
                    }
                    for (var i = 0; i < parts.length; i++) {
                        var value = parseInt(parts[i], 10);
                        if (isNaN(value)) {
                            throw new Error("Version string components must be numerical!");
                        }
                        componentArray.push(value);
                    }
                    this.components = componentArray;
                }
                Object.defineProperty(Version.prototype, "major", {
                    get: function () {
                        return this.components[0];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Version.prototype, "minor", {
                    get: function () {
                        return this.components[1];
                    },
                    enumerable: false,
                    configurable: true
                });
                Version.prototype.toString = function () {
                    return this.components.join('.');
                };
                Version.prototype.toJSON = function () {
                    return this.toString();
                };
                Version.prototype.equals = function (other) {
                    return this.compareTo(other) == 0;
                };
                Version.prototype.precedes = function (other) {
                    return this.compareTo(other) < 0;
                };
                Version.prototype.compareTo = function (other) {
                    // If the version info depth differs, we need a flag to indicate which instance is shorter.
                    var isShorter = this.components.length < other.components.length;
                    var maxDepth = (this.components.length < other.components.length) ? this.components.length : other.components.length;
                    var i;
                    for (i = 0; i < maxDepth; i++) {
                        var delta = this.components[i] - other.components[i];
                        if (delta != 0) {
                            return delta;
                        }
                    }
                    var longList = isShorter ? other.components : this.components;
                    do {
                        if (longList[i] > 0) {
                            return isShorter ? -1 : 1;
                        }
                        i++;
                    } while (i < longList.length);
                    // Equal.
                    return 0;
                };
                Version.CURRENT = new Version(com.keyman.KEYMAN_VERSION.VERSION_RELEASE);
                // Represents a default version value for keyboards compiled before this was compiled into keyboards.
                // The exact version is unknown at this point, but the value is "good enough" for what we need.
                Version.DEVELOPER_VERSION_FALLBACK = new Version([9, 0, 0]);
                // For 12.0, the old default behavior of adding missing keycaps to the default layers was removed,
                // as it results in unexpected, bug-like behavior for keyboard designers when it is unwanted.
                Version.NO_DEFAULT_KEYCAPS = new Version([12, 0]);
                Version.MAC_POSSIBLE_IPAD_ALIAS = new Version([10, 15]);
                return Version;
            }());
            utils.Version = Version;
        })(utils = keyman.utils || (keyman.utils = {}));
    })(keyman = com.keyman || (com.keyman = {}));
})(com || (com = {}));
/***
   KeymanWeb 14.0
   Copyright 2020 SIL International
***/
/**
 * Constructs a string from one or more Unicode character codepoint values
 * passed as integer parameters.
 *
 * @param  {number} cp0,...   1 or more Unicode codepoints, e.g. 0x0065, 0x10000
 * @return {string|null}      The new String object.
 */
String.kmwFromCharCode = function (cp0) {
    var chars = [], i;
    for (i = 0; i < arguments.length; i++) {
        var c = Number(arguments[i]);
        if (!isFinite(c) || c < 0 || c > 0x10FFFF || Math.floor(c) !== c) {
            throw new RangeError("Invalid code point " + c);
        }
        if (c < 0x10000) {
            chars.push(c);
        }
        else {
            c -= 0x10000;
            chars.push((c >> 10) + 0xD800);
            chars.push((c % 0x400) + 0xDC00);
        }
    }
    return String.fromCharCode.apply(undefined, chars);
};
/**
 * Returns a number indicating the Unicode value of the character at the given
 * code point index, with support for supplementary plane characters.
 *
 * @param  {number}  codePointIndex  The code point index into the string (not
                                     the code unit index) to return
 * @return {number}                  The Unicode character value
 */
String.prototype.kmwCharCodeAt = function (codePointIndex) {
    var str = String(this);
    var codeUnitIndex = 0;
    if (codePointIndex < 0 || codePointIndex >= str.length) {
        return NaN;
    }
    for (var i = 0; i < codePointIndex; i++) {
        codeUnitIndex = str.kmwNextChar(codeUnitIndex);
        if (codeUnitIndex === null)
            return NaN;
    }
    var first = str.charCodeAt(codeUnitIndex);
    if (first >= 0xD800 && first <= 0xDBFF && str.length > codeUnitIndex + 1) {
        var second = str.charCodeAt(codeUnitIndex + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) {
            return ((first - 0xD800) << 10) + (second - 0xDC00) + 0x10000;
        }
    }
    return first;
};
/**
 * Returns the code point index within the calling String object of the first occurrence
 * of the specified value, or -1 if not found.
 *
 * @param  {string}  searchValue    The value to search for
 * @param  {number}  [fromIndex]    Optional code point index to start searching from
 * @return {number}                 The code point index of the specified search value
 */
String.prototype.kmwIndexOf = function (searchValue, fromIndex) {
    var str = String(this);
    var codeUnitIndex = str.indexOf(searchValue, fromIndex);
    if (codeUnitIndex < 0) {
        return codeUnitIndex;
    }
    var codePointIndex = 0;
    for (var i = 0; i !== null && i < codeUnitIndex; i = str.kmwNextChar(i))
        codePointIndex++;
    return codePointIndex;
};
/**
 * Returns the code point index within the calling String object of the last occurrence
 * of the specified value, or -1 if not found.
 *
 * @param  {string}  searchValue    The value to search for
 * @param  {number}  fromIndex      Optional code point index to start searching from
 * @return {number}                 The code point index of the specified search value
 */
String.prototype.kmwLastIndexOf = function (searchValue, fromIndex) {
    var str = String(this);
    var codeUnitIndex = str.lastIndexOf(searchValue, fromIndex);
    if (codeUnitIndex < 0) {
        return codeUnitIndex;
    }
    var codePointIndex = 0;
    for (var i = 0; i !== null && i < codeUnitIndex; i = str.kmwNextChar(i))
        codePointIndex++;
    return codePointIndex;
};
/**
 * Returns the length of the string in code points, as opposed to code units.
 *
 * @return {number}                 The length of the string in code points
 */
String.prototype.kmwLength = function () {
    var str = String(this);
    if (str.length == 0)
        return 0;
    for (var i = 0, codeUnitIndex = 0; codeUnitIndex !== null; i++)
        codeUnitIndex = str.kmwNextChar(codeUnitIndex);
    return i;
};
/**
 * Extracts a section of a string and returns a new string.
 *
 * @param  {number}  beginSlice    The start code point index in the string to
 *                                 extract from
 * @param  {number}  endSlice      Optional end code point index in the string
 *                                 to extract to
 * @return {string}                The substring as selected by beginSlice and
 *                                 endSlice
 */
String.prototype.kmwSlice = function (beginSlice, endSlice) {
    var str = String(this);
    var beginSliceCodeUnit = str.kmwCodePointToCodeUnit(beginSlice);
    var endSliceCodeUnit = str.kmwCodePointToCodeUnit(endSlice);
    if (beginSliceCodeUnit === null || endSliceCodeUnit === null)
        return '';
    else
        return str.slice(beginSliceCodeUnit, endSliceCodeUnit);
};
/**
 * Returns the characters in a string beginning at the specified location through
 * the specified number of characters.
 *
 * @param  {number}  start         The start code point index in the string to
 *                                 extract from
 * @param  {number=}  length        Optional length to extract
 * @return {string}                The substring as selected by start and length
 */
String.prototype.kmwSubstr = function (start, length) {
    var str = String(this);
    if (start < 0) {
        start = str.kmwLength() + start;
    }
    if (start < 0)
        start = 0;
    var startCodeUnit = str.kmwCodePointToCodeUnit(start);
    var endCodeUnit = startCodeUnit;
    if (startCodeUnit === null)
        return '';
    if (arguments.length < 2) {
        endCodeUnit = str.length;
    }
    else {
        for (var i = 0; i < length; i++)
            endCodeUnit = str.kmwNextChar(endCodeUnit);
    }
    if (endCodeUnit === null)
        return str.substring(startCodeUnit);
    else
        return str.substring(startCodeUnit, endCodeUnit);
};
/**
 * Returns the characters in a string between two indexes into the string.
 *
 * @param  {number}  indexA        The start code point index in the string to
 *                                 extract from
 * @param  {number}  indexB        The end code point index in the string to
 *                                 extract to
 * @return {string}                The substring as selected by indexA and indexB
 */
String.prototype.kmwSubstring = function (indexA, indexB) {
    var str = String(this), indexACodeUnit, indexBCodeUnit;
    if (typeof (indexB) == 'undefined') {
        indexACodeUnit = str.kmwCodePointToCodeUnit(indexA);
        indexBCodeUnit = str.length;
    }
    else {
        if (indexA > indexB) {
            var c = indexA;
            indexA = indexB;
            indexB = c;
        }
        indexACodeUnit = str.kmwCodePointToCodeUnit(indexA);
        indexBCodeUnit = str.kmwCodePointToCodeUnit(indexB);
    }
    if (isNaN(indexACodeUnit) || indexACodeUnit === null)
        indexACodeUnit = 0;
    if (isNaN(indexBCodeUnit) || indexBCodeUnit === null)
        indexBCodeUnit = str.length;
    return str.substring(indexACodeUnit, indexBCodeUnit);
};
/*
  Helper functions
*/
/**
 * Returns the code unit index for the next code point in the string, accounting for
 * supplementary pairs
 *
 * @param  {number|null}  codeUnitIndex  The code unit position to increment
 * @return {number|null}                 The index of the next code point in the string,
 *                                       in code units
 */
String.prototype.kmwNextChar = function (codeUnitIndex) {
    var str = String(this);
    if (codeUnitIndex === null || codeUnitIndex < 0 || codeUnitIndex >= str.length - 1) {
        return null;
    }
    var first = str.charCodeAt(codeUnitIndex);
    if (first >= 0xD800 && first <= 0xDBFF && str.length > codeUnitIndex + 1) {
        var second = str.charCodeAt(codeUnitIndex + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) {
            if (codeUnitIndex == str.length - 2) {
                return null;
            }
            return codeUnitIndex + 2;
        }
    }
    return codeUnitIndex + 1;
};
/**
 * Returns the code unit index for the previous code point in the string, accounting
 * for supplementary pairs
 *
 * @param  {number|null}  codeUnitIndex  The code unit position to decrement
 * @return {number|null}                 The index of the previous code point in the
 *                                       string, in code units
*/
String.prototype.kmwPrevChar = function (codeUnitIndex) {
    var str = String(this);
    if (codeUnitIndex == null || codeUnitIndex <= 0 || codeUnitIndex > str.length) {
        return null;
    }
    var second = str.charCodeAt(codeUnitIndex - 1);
    if (second >= 0xDC00 && second <= 0xDFFF && codeUnitIndex > 1) {
        var first = str.charCodeAt(codeUnitIndex - 2);
        if (first >= 0xD800 && first <= 0xDBFF) {
            return codeUnitIndex - 2;
        }
    }
    return codeUnitIndex - 1;
};
/**
 * Returns the corresponding code unit index to the code point index passed
 *
 * @param  {number|null} codePointIndex  A code point index in the string
 * @return {number|null}                 The corresponding code unit index
 */
String.prototype.kmwCodePointToCodeUnit = function (codePointIndex) {
    if (codePointIndex === null)
        return null;
    var str = String(this);
    var codeUnitIndex = 0;
    if (codePointIndex < 0) {
        codeUnitIndex = str.length;
        for (var i = 0; i > codePointIndex; i--)
            codeUnitIndex = str.kmwPrevChar(codeUnitIndex);
        return codeUnitIndex;
    }
    if (codePointIndex == str.kmwLength())
        return str.length;
    for (var i = 0; i < codePointIndex; i++)
        codeUnitIndex = str.kmwNextChar(codeUnitIndex);
    return codeUnitIndex;
};
/**
 * Returns the corresponding code point index to the code unit index passed
 *
 * @param  {number|null}  codeUnitIndex  A code unit index in the string
 * @return {number|null}                 The corresponding code point index
 */
String.prototype.kmwCodeUnitToCodePoint = function (codeUnitIndex) {
    var str = String(this);
    if (codeUnitIndex === null)
        return null;
    else if (codeUnitIndex == 0)
        return 0;
    else if (codeUnitIndex < 0)
        return str.substr(codeUnitIndex).kmwLength();
    else
        return str.substr(0, codeUnitIndex).kmwLength();
};
/**
 * Returns the character at a the code point index passed
 *
 * @param  {number}  codePointIndex  A code point index in the string
 * @return {string}                  The corresponding character
 */
String.prototype.kmwCharAt = function (codePointIndex) {
    var str = String(this);
    if (codePointIndex >= 0)
        return str.kmwSubstr(codePointIndex, 1);
    else
        return '';
};
/**
 * String prototype library extensions for basic plane characters,
 * to simplify enabling or disabling supplementary plane functionality (I3319)
 */
/**
 * Returns the code unit index for the next code point in the string
 *
 * @param  {number}  codeUnitIndex    A code point index in the string
 * @return {number|null}                   The corresponding character
 */
String.prototype.kmwBMPNextChar = function (codeUnitIndex) {
    var str = String(this);
    if (codeUnitIndex < 0 || codeUnitIndex >= str.length - 1) {
        return null;
    }
    return codeUnitIndex + 1;
};
/**
 * Returns the code unit index for the previous code point in the string
 *
 * @param  {number}  codeUnitIndex    A code unit index in the string
 * @return {number|null}                   The corresponding character
 */
String.prototype.kmwBMPPrevChar = function (codeUnitIndex) {
    var str = String(this);
    if (codeUnitIndex <= 0 || codeUnitIndex > str.length) {
        return null;
    }
    return codeUnitIndex - 1;
};
/**
 * Returns the code unit index for a code point index
 *
 * @param  {number}  codePointIndex   A code point index in the string
 * @return {number}                   The corresponding character
 */
String.prototype.kmwBMPCodePointToCodeUnit = function (codePointIndex) {
    return codePointIndex;
};
/**
 * Returns the code point index for a code unit index
 *
 * @param  {number}  codeUnitIndex    A code point index in the string
 * @return {number}                   The corresponding character
 */
String.prototype.kmwBMPCodeUnitToCodePoint = function (codeUnitIndex) {
    return codeUnitIndex;
};
/**
 * Returns the length of a BMP string
 *
 * @return {number}                   The length in code points
 */
String.prototype.kmwBMPLength = function () {
    var str = String(this);
    return str.length;
};
/**
 * Returns a substring
 *
 * @param  {number}  n
 * @param  {number=}  ln
 * @return {string}
 */
String.prototype.kmwBMPSubstr = function (n, ln) {
    var str = String(this);
    if (n > -1)
        return str.substr(n, ln);
    else
        return str.substr(str.length + n, -n);
};
/**
 * Enable or disable supplementary plane string handling
 *
 * @param  {boolean}  bEnable
 */
String.kmwEnableSupplementaryPlane = function (bEnable) {
    var p = String.prototype;
    String._kmwFromCharCode = bEnable ? String.kmwFromCharCode : String.fromCharCode;
    p._kmwCharAt = bEnable ? p.kmwCharAt : p.charAt;
    p._kmwCharCodeAt = bEnable ? p.kmwCharCodeAt : p.charCodeAt;
    p._kmwIndexOf = bEnable ? p.kmwIndexOf : p.indexOf;
    p._kmwLastIndexOf = bEnable ? p.kmwLastIndexOf : p.lastIndexOf;
    p._kmwSlice = bEnable ? p.kmwSlice : p.slice;
    p._kmwSubstring = bEnable ? p.kmwSubstring : p.substring;
    p._kmwSubstr = bEnable ? p.kmwSubstr : p.kmwBMPSubstr;
    p._kmwLength = bEnable ? p.kmwLength : p.kmwBMPLength;
    p._kmwNextChar = bEnable ? p.kmwNextChar : p.kmwBMPNextChar;
    p._kmwPrevChar = bEnable ? p.kmwPrevChar : p.kmwBMPPrevChar;
    p._kmwCodePointToCodeUnit = bEnable ? p.kmwCodePointToCodeUnit : p.kmwBMPCodePointToCodeUnit;
    p._kmwCodeUnitToCodePoint = bEnable ? p.kmwCodeUnitToCodePoint : p.kmwBMPCodeUnitToCodePoint;
};
// References all utility includes from a single file, making import/export simple.
///<reference path="deepCopy.ts" />
///<reference path="globalObject.ts" />
///<reference path="version.ts" />
///<reference path="kmwstring.ts" />
///<reference path="deviceSpec.ts" />
var models;
(function (models) {
    models.SENTINEL_CODE_UNIT = '\uFDD0';
    function applyTransform(transform, context) {
        // First, get the current context
        var fullLeftContext = context.left || '';
        var lLen = fullLeftContext.kmwLength();
        var lDel = lLen < transform.deleteLeft ? lLen : transform.deleteLeft;
        var leftContext = fullLeftContext.kmwSubstr(0, lLen - lDel) + (transform.insert || '');
        var fullRightContext = context.right || '';
        var rLen = fullRightContext.kmwLength();
        var rDel = rLen < transform.deleteRight ? rLen : transform.deleteRight;
        var rightContext = fullRightContext.kmwSubstr(rDel);
        return {
            left: leftContext,
            right: rightContext,
            startOfBuffer: context.startOfBuffer,
            endOfBuffer: context.endOfBuffer,
            casingForm: context.casingForm
        };
    }
    models.applyTransform = applyTransform;
    /**
     * Merges two Transforms as if they were applied to a `Context` successively.
     * @param first
     * @param second
     */
    function buildMergedTransform(first, second) {
        // These exist to avoid parameter mutation.
        var mergedFirstInsert = first.insert;
        var mergedSecondDelete = second.deleteLeft;
        // The 'fun' case:  the second Transform wants to delete something from the first.
        if (second.deleteLeft) {
            var firstLength = first.insert.kmwLength();
            if (firstLength <= second.deleteLeft) {
                mergedFirstInsert = '';
                mergedSecondDelete = second.deleteLeft - firstLength;
            }
            else {
                mergedFirstInsert = first.insert.kmwSubstr(0, firstLength - second.deleteLeft);
                mergedSecondDelete = 0;
            }
        }
        return {
            insert: mergedFirstInsert + second.insert,
            deleteLeft: first.deleteLeft + mergedSecondDelete,
            // As `first` would affect the context before `second` could take effect,
            // this is the correct way to merge `deleteRight`.
            deleteRight: (first.deleteRight || 0) + (second.deleteRight || 0)
        };
    }
    models.buildMergedTransform = buildMergedTransform;
    function isHighSurrogate(codeUnit) {
        if (typeof codeUnit == 'string') {
            codeUnit = codeUnit.charCodeAt(0);
        }
        return codeUnit >= 0xD800 && codeUnit <= 0xDBFF;
    }
    models.isHighSurrogate = isHighSurrogate;
    function isLowSurrogate(codeUnit) {
        if (typeof codeUnit == 'string') {
            codeUnit = codeUnit.charCodeAt(0);
        }
        return codeUnit >= 0xDC00 && codeUnit <= 0xDFFF;
    }
    models.isLowSurrogate = isLowSurrogate;
    function isSentinel(char) {
        return char == models.SENTINEL_CODE_UNIT;
    }
    models.isSentinel = isSentinel;
    function transformToSuggestion(transform, p) {
        var suggestion = {
            transform: transform,
            transformId: transform.id,
            displayAs: transform.insert
        };
        if (p === 0 || p) {
            suggestion.p = p;
        }
        return suggestion;
    }
    models.transformToSuggestion = transformToSuggestion;
    function defaultApplyCasing(casing, text) {
        switch (casing) {
            case 'lower':
                return text.toLowerCase();
            case 'upper':
                return text.toUpperCase();
            case 'initial':
                // The length of the first code unit, as measured in code points.
                var headUnitLength = 1;
                // Is the first character a high surrogate, indicating possible use of UTF-16
                // surrogate pairs?  Also, is the string long enough for there to BE a pair?
                if (text.length > 1 && isHighSurrogate(text.charAt(0))) {
                    // It's possible, so now we check for low surrogates.
                    if (isLowSurrogate(text.charCodeAt(1))) {
                        // We have a surrogate pair; this pair is the 'first' character.
                        headUnitLength = 2;
                    }
                }
                // Capitalizes the first code unit of the string, leaving the rest intact.
                return text.substring(0, headUnitLength).toUpperCase().concat(text.substring(headUnitLength));
        }
    }
    models.defaultApplyCasing = defaultApplyCasing;
})(models || (models = {}));
/**
 * @file priority-queue.ts
 *
 * Defines a mildly abstracted priority queue implementation.
 */
var models;
(function (models) {
    var PriorityQueue = /** @class */ (function () {
        /**
         * Constructs an empty priority queue.
         * @param comparator A `Comparator` returning negative values when and only when
         * the first parameter should precede the second parameter.
         */
        function PriorityQueue(comparator, initialEntries) {
            if (initialEntries === void 0) { initialEntries = []; }
            // TODO: We may wish to allow options specifying a limit or threshold for adding
            // items to the priority queue.  Possibly both.
            //
            // When that time comes, consider a min-max heap.
            // https://en.wikipedia.org/wiki/Min-max_heap
            this.comparator = comparator;
            this.heap = Array.from(initialEntries);
            this.heapify();
        }
        PriorityQueue.leftChildIndex = function (index) {
            return index * 2 + 1;
        };
        PriorityQueue.rightChildIndex = function (index) {
            return index * 2 + 2;
        };
        PriorityQueue.parentIndex = function (index) {
            return Math.floor((index - 1) / 2);
        };
        PriorityQueue.prototype.heapify = function (start, end) {
            if (start == undefined || end == undefined) {
                this.heapify(0, this.count - 1);
            }
            // Use of 'indices' here is a bit of a customization.
            // At the cost of (temporary) extra storage space, we can more efficiently enqueue
            // multiple elements simultaneously.
            var queuedIndices = [];
            var lastParent = -1;
            for (var i = end; i >= start; i--) {
                var parent = PriorityQueue.parentIndex(i);
                if (this.siftDown(i) && parent < start && lastParent != parent) {
                    // We only need to queue examination for a heap node if its children have changed
                    // and it isn't already being examined.
                    queuedIndices.push(parent);
                    lastParent = parent;
                }
            }
            lastParent = -1;
            while (queuedIndices.length > 0) {
                var index = queuedIndices.shift();
                var parent = PriorityQueue.parentIndex(index);
                if (this.siftDown(index) && parent >= 0 && lastParent != parent) {
                    // We only need to queue examination for a heap node if its children have changed.
                    queuedIndices.push(parent);
                    lastParent = parent;
                }
            }
        };
        Object.defineProperty(PriorityQueue.prototype, "count", {
            /**
             * Returns the number of elements currently held by the priority queue.
             */
            get: function () {
                return this.heap.length;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * Returns the highest-priority item within the priority queue.
         * <p>
         * Is O(1).
         */
        PriorityQueue.prototype.peek = function () {
            return this.heap[0]; // undefined if it doesn't exist... which is completely correct.
        };
        /**
         * Inserts a new element into the priority queue, placing it in order.
         * <p>
         * Is O(log N), where N = # of items in the priority queue.
         * @param element
         */
        PriorityQueue.prototype.enqueue = function (element) {
            var index = this.heap.length;
            this.heap.push(element);
            var parent = PriorityQueue.parentIndex;
            var parentIndex = parent(index);
            while (index !== 0 && this.comparator(this.heap[index], this.heap[parentIndex]) < 0) {
                var a = this.heap[index];
                this.heap[index] = this.heap[parentIndex];
                this.heap[parentIndex] = a;
                index = parentIndex;
                parentIndex = parent(index);
            }
        };
        /**
         * Efficiently batch-enqueues multiple elements.
         * Worst-case is the _better_ of the following:
         * - O(`elements.count` + `heap.count`) - large element counts will trigger in-place
         * heap reconstruction.
         * - O(`elements.count` * log(`heap.count`)) - logarithmic when elements.count << heap.count
         * @param elements A group of elements to enqueue simultaneously.
         */
        PriorityQueue.prototype.enqueueAll = function (elements) {
            if (elements.length == 0) {
                return;
            }
            var firstIndex = this.count;
            this.heap = this.heap.concat(elements);
            var firstParent = PriorityQueue.parentIndex(firstIndex);
            // The 'parent' of index 0 will return -1, which is illegal.
            this.heapify(firstParent >= 0 ? firstParent : 0, PriorityQueue.parentIndex(this.count - 1));
        };
        /**
         * Removes the highest-priority element from the queue, returning it.
         * <p>
         * Is O(log N), where N = number of items in the priority queue.
         */
        PriorityQueue.prototype.dequeue = function () {
            if (this.count == 0) {
                return undefined;
            }
            var root = this.heap[0];
            var tail = this.heap.pop();
            if (this.heap.length > 0) {
                this.heap[0] = tail;
                this.siftDown(0);
            }
            return root;
        };
        /**
         * Compares the entry at the specified index against its children,
         * propagating it downward within the heap until heap requirements are specified.
         * <p>
         * Is O(log N), where N = number of items in the priority queue.
         *
         * @param index The index of the top-most node that must be examined
         * for repositioning.
         * @returns `true` if a swap occurred, `false` otherwise.
         */
        PriorityQueue.prototype.siftDown = function (index) {
            var leftIndex = PriorityQueue.leftChildIndex(index);
            var rightIndex = PriorityQueue.rightChildIndex(index);
            var topMostIndex = index;
            if (leftIndex < this.heap.length && this.comparator(this.heap[leftIndex], this.heap[topMostIndex]) < 0) {
                topMostIndex = leftIndex;
            }
            if (rightIndex < this.heap.length && this.comparator(this.heap[rightIndex], this.heap[topMostIndex]) < 0) {
                topMostIndex = rightIndex;
            }
            if (topMostIndex != index) {
                var a = this.heap[index];
                this.heap[index] = this.heap[topMostIndex];
                this.heap[topMostIndex] = a;
                this.siftDown(topMostIndex);
                return true;
            }
            else {
                return false;
            }
        };
        /**
         * Returns an array containing all entries of the priority queue.
         * Altering the returned array will not affect the queue, but mutating
         * the array's elements can cause unintended side effects.
         *
         * This function makes no guarantees on the ordering of the returned elements;
         * they will almost certainly be unsorted.
         */
        PriorityQueue.prototype.toArray = function () {
            return Array.from(this.heap);
        };
        return PriorityQueue;
    }());
    models.PriorityQueue = PriorityQueue;
})(models || (models = {}));
// While we _could_ define this within @keymanapp/models-wordbreakers instead, it's probably
// better to leave that package as _just_ the wordbreakers.  
var models;
(function (models) {
    function tokenize(wordBreaker, context) {
        context = context || {
            left: undefined,
            startOfBuffer: undefined,
            endOfBuffer: undefined
        };
        var leftSpans = wordBreaker(context.left || '') || [];
        var rightSpans = wordBreaker(context.right || '') || [];
        var leftTail;
        if (leftSpans.length > 0) {
            leftTail = leftSpans[leftSpans.length - 1];
        }
        // Handle any desired special handling for directly-pre-caret scenarios - where for this 
        // _specific_ context, we should not make a token division where one normally would exist otherwise.
        //
        // One notable example:  word-final apostrophe is tokenized separate from preceding text, but
        // word-internal apostrophe is treated as part of the same word (i.e, English contractions).
        // But, if the user is editing text and the caret is directly after a caret, there's a notable
        // chance they may in the middle of typing a contraction. Refer to 
        // https://github.com/keymanapp/keyman/issues/6572.
        if (leftSpans.length > 1) {
            var leftTailBase = leftSpans[leftSpans.length - 2];
            // If the final two pre-caret spans are adjacent - without intervening whitespace...
            if (leftTailBase.end == leftTail.start) {
                // Ideal:  if(leftTailBase is standard-char-class && leftTail is single-quote-class)
                // But we don't have character class access here; it's all wordbreaker-function internal.
                // Upon inspection of the wordbreaker data definitions... the single-quote-class is ONLY "'".
                // So... we'll just be lazy for now and append the `'`.
                if (leftTail.text == "'") {
                    var mergedSpan = {
                        text: leftTailBase.text + leftTail.text,
                        start: leftTailBase.start,
                        end: leftTail.end,
                        length: leftTailBase.length + leftTail.length
                    };
                    leftSpans.pop(); // leftTail
                    leftSpans.pop(); // leftTailBase
                    leftSpans.push(mergedSpan);
                    leftTail = mergedSpan; // don't forget to update the `leftTail` Span!
                }
            }
        }
        // With any 'detokenization' cases already handled, we may now begin to build the return object.
        var tokenization = {
            left: leftSpans.map(function (span) { return span.text; }),
            right: rightSpans.map(function (span) { return span.text; }),
            // A default initialization of the value.
            caretSplitsToken: false
        };
        // Now the hard part - determining whether or not the caret caused a token split.
        if (leftSpans.length > 0 && rightSpans.length > 0) {
            var rightHead = rightSpans[0];
            // If tokenization includes all characters on each side of the caret,
            // we have a good candidate for a caret-splitting scenario.
            var leftSuffixWordbreak = leftTail.end != context.left.length;
            var rightPrefixWordbreak = rightHead.start != 0;
            if (leftSuffixWordbreak || rightPrefixWordbreak) {
                // Bypass the final test, as we already know the caret didn't split a token.
                // (The tokenization process already removed characters between the two.)
                return tokenization;
            }
            // Worth note - some languages don't use wordbreaking characters.  So, a final check:
            //
            // Does the wordbreaker split a merge of the 'two center' tokens?
            // If not, then the caret is responsible for the split.
            if (wordBreaker(leftTail.text + rightHead.text).length == 1) {
                tokenization.caretSplitsToken = true;
            }
        }
        return tokenization;
    }
    models.tokenize = tokenize;
    /**
     * Get the last word of the phrase before the caret or nothing.
     * @param fullLeftContext the entire left context of the string.
     */
    function getLastPreCaretToken(wordBreaker, context) {
        var tokenization = tokenize(wordBreaker, context);
        if (tokenization.left.length > 0) {
            return tokenization.left.pop();
        }
        return '';
    }
    models.getLastPreCaretToken = getLastPreCaretToken;
    // While it is currently identical to getLastWord, this may change in the future.
    // It's best not to write ourselves into a corner on this one, as disambiguating later
    // would likely be pretty painful.
    function wordbreak(wordBreaker, context) {
        return getLastPreCaretToken(wordBreaker, context);
    }
    models.wordbreak = wordbreak;
})(models || (models = {}));
/*
 * Copyright (c) 2019 National Research Council Canada (author: Eddie A. Santos)
 * Copyright (c) 2019 SIL International
 * Copyright (c) 2015–2017 Conrad Irwin
 * Copyright (c) 2011–2015 Marc Campbell
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Worth noting:  we're starting to get quite a 'library' of common model/LMLayer functionality.
// Should probably make a 'lm-utils' submodule.
/// <reference path="common.ts" />
/// <reference path="priority-queue.ts" />
/// <reference path="tokenization.ts" />
/// <reference types="@keymanapp/models-types" />
/**
 * @file trie-model.ts
 *
 * Defines a simple word list (unigram) model.
 */
var models;
(function (models) {
    /** Upper bound on the amount of suggestions to generate. */
    var MAX_SUGGESTIONS = 12;
    /**
     * @class TrieModel
     *
     * Defines a trie-backed word list model, or the unigram model.
     * Unigram models throw away all preceding words, and search
     * for the next word exclusively. As such, they can perform simple
     * prefix searches within words, however they are not very good
     * at predicting the next word.
     */
    var TrieModel = /** @class */ (function () {
        function TrieModel(trieData, options) {
            if (options === void 0) { options = {}; }
            this.languageUsesCasing = options.languageUsesCasing;
            this.applyCasing = options.applyCasing;
            this._trie = new Trie(trieData['root'], trieData['totalWeight'], options.searchTermToKey || defaultSearchTermToKey);
            this.breakWords = options.wordBreaker || getDefaultWordBreaker();
            this.punctuation = options.punctuation;
        }
        TrieModel.prototype.configure = function (capabilities) {
            return this.configuration = {
                leftContextCodePoints: capabilities.maxLeftContextCodePoints,
                rightContextCodePoints: capabilities.maxRightContextCodePoints
            };
        };
        TrieModel.prototype.toKey = function (text) {
            return this._trie.toKey(text);
        };
        TrieModel.prototype.predict = function (transform, context) {
            // Special-case the empty buffer/transform: return the top suggestions.
            if (!transform.insert && !context.left && !context.right && context.startOfBuffer && context.endOfBuffer) {
                return makeDistribution(this._trie.firstN(MAX_SUGGESTIONS).map(function (_a) {
                    var text = _a.text, p = _a.p;
                    return ({
                        transform: {
                            insert: text,
                            deleteLeft: 0
                        },
                        displayAs: text,
                        p: p
                    });
                }));
            }
            // Compute the results of the keystroke:
            var newContext = models.applyTransform(transform, context);
            // Computes the different in word length after applying the transform above.
            var leftDelOffset = transform.deleteLeft - transform.insert.kmwLength();
            // All text to the left of the cursor INCLUDING anything that has
            // just been typed.
            var prefix = models.getLastPreCaretToken(this.breakWords, newContext);
            // Return suggestions from the trie.
            return makeDistribution(this._trie.lookup(prefix).map(function (_a) {
                var text = _a.text, p = _a.p;
                return models.transformToSuggestion({
                    insert: text,
                    // Delete whatever the prefix that the user wrote.
                    deleteLeft: leftDelOffset + prefix.kmwLength()
                    // Note: a separate capitalization/orthography engine can take this
                    // result and transform it as needed.
                }, p);
            }));
            /* Helper */
            function makeDistribution(suggestions) {
                var distribution = [];
                for (var _i = 0, suggestions_1 = suggestions; _i < suggestions_1.length; _i++) {
                    var s = suggestions_1[_i];
                    distribution.push({ sample: s, p: s.p });
                }
                return distribution;
            }
        };
        Object.defineProperty(TrieModel.prototype, "wordbreaker", {
            get: function () {
                return this.breakWords;
            },
            enumerable: false,
            configurable: true
        });
        TrieModel.prototype.traverseFromRoot = function () {
            return new TrieModel.Traversal(this._trie['root'], '');
        };
        TrieModel.Traversal = /** @class */ (function () {
            function class_1(root, prefix) {
                this.root = root;
                this.prefix = prefix;
            }
            class_1.prototype.children = function () {
                var root, _loop_1, this_1, _i, _a, entry, prefix_1, children, _loop_2, _b, children_1, key;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            root = this.root;
                            if (!(root.type == 'internal')) return [3 /*break*/, 5];
                            _loop_1 = function (entry) {
                                var entryNode, internalNode_1, _loop_3, _d, _e, lowSurrogate, fullText, prefix_2, prefix_3;
                                return __generator(this, function (_f) {
                                    switch (_f.label) {
                                        case 0:
                                            entryNode = root.children[entry];
                                            if (!models.isHighSurrogate(entry)) return [3 /*break*/, 8];
                                            if (!(entryNode.type == 'internal')) return [3 /*break*/, 5];
                                            internalNode_1 = entryNode;
                                            _loop_3 = function (lowSurrogate) {
                                                var prefix;
                                                return __generator(this, function (_g) {
                                                    switch (_g.label) {
                                                        case 0:
                                                            prefix = this_1.prefix + entry + lowSurrogate;
                                                            return [4 /*yield*/, {
                                                                    char: entry + lowSurrogate,
                                                                    traversal: function () { return new TrieModel.Traversal(internalNode_1.children[lowSurrogate], prefix); }
                                                                }];
                                                        case 1:
                                                            _g.sent();
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            };
                                            _d = 0, _e = internalNode_1.values;
                                            _f.label = 1;
                                        case 1:
                                            if (!(_d < _e.length)) return [3 /*break*/, 4];
                                            lowSurrogate = _e[_d];
                                            return [5 /*yield**/, _loop_3(lowSurrogate)];
                                        case 2:
                                            _f.sent();
                                            _f.label = 3;
                                        case 3:
                                            _d++;
                                            return [3 /*break*/, 1];
                                        case 4: return [3 /*break*/, 7];
                                        case 5:
                                            fullText = entryNode.entries[0].key;
                                            entry = entry + fullText[this_1.prefix.length + 1]; // The other half of the non-BMP char.
                                            prefix_2 = this_1.prefix + entry;
                                            return [4 /*yield*/, {
                                                    char: entry,
                                                    traversal: function () { return new TrieModel.Traversal(entryNode, prefix_2); }
                                                }];
                                        case 6:
                                            _f.sent();
                                            _f.label = 7;
                                        case 7: return [3 /*break*/, 12];
                                        case 8:
                                            if (!models.isSentinel(entry)) return [3 /*break*/, 9];
                                            return [2 /*return*/, "continue"];
                                        case 9:
                                            if (!!entry) return [3 /*break*/, 10];
                                            return [2 /*return*/, "continue"];
                                        case 10:
                                            prefix_3 = this_1.prefix + entry;
                                            return [4 /*yield*/, {
                                                    char: entry,
                                                    traversal: function () { return new TrieModel.Traversal(entryNode, prefix_3); }
                                                }];
                                        case 11:
                                            _f.sent();
                                            _f.label = 12;
                                        case 12: return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = root.values;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            entry = _a[_i];
                            return [5 /*yield**/, _loop_1(entry)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                        case 5:
                            prefix_1 = this.prefix;
                            children = root.entries.filter(function (entry) {
                                return entry.key != prefix_1 && prefix_1.length < entry.key.length;
                            });
                            _loop_2 = function (key) {
                                var nodeKey;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            nodeKey = key[prefix_1.length];
                                            if (models.isHighSurrogate(nodeKey)) {
                                                // Merge the other half of an SMP char in!
                                                nodeKey = nodeKey + key[prefix_1.length + 1];
                                            }
                                            return [4 /*yield*/, {
                                                    char: nodeKey,
                                                    traversal: function () { return new TrieModel.Traversal(root, prefix_1 + nodeKey); }
                                                }];
                                        case 1:
                                            _h.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            _b = 0, children_1 = children;
                            _c.label = 6;
                        case 6:
                            if (!(_b < children_1.length)) return [3 /*break*/, 9];
                            key = children_1[_b].key;
                            return [5 /*yield**/, _loop_2(key)];
                        case 7:
                            _c.sent();
                            _c.label = 8;
                        case 8:
                            _b++;
                            return [3 /*break*/, 6];
                        case 9:
                            ;
                            return [2 /*return*/];
                    }
                });
            };
            Object.defineProperty(class_1.prototype, "entries", {
                get: function () {
                    if (this.root.type == 'leaf') {
                        var prefix_4 = this.prefix;
                        var matches = this.root.entries.filter(function (entry) {
                            return entry.key == prefix_4;
                        });
                        return matches.map(function (value) { return value.content; });
                    }
                    else {
                        var matchingLeaf = this.root.children[models.SENTINEL_CODE_UNIT];
                        if (matchingLeaf && matchingLeaf.type == 'leaf') {
                            return matchingLeaf.entries.map(function (value) { return value.content; });
                        }
                        else {
                            return [];
                        }
                    }
                },
                enumerable: false,
                configurable: true
            });
            return class_1;
        }());
        return TrieModel;
    }());
    models.TrieModel = TrieModel;
    ;
    /**
     * Wrapper class for the trie and its nodes.
     */
    var Trie = /** @class */ (function () {
        function Trie(root, totalWeight, wordform2key) {
            this.root = root;
            this.toKey = wordform2key;
            this.totalWeight = totalWeight;
        }
        /**
         * Lookups an arbitrary prefix (a query) in the trie. Returns the top 3
         * results in sorted order.
         *
         * @param prefix
         */
        Trie.prototype.lookup = function (prefix) {
            var searchKey = this.toKey(prefix);
            var lowestCommonNode = findPrefix(this.root, searchKey);
            if (lowestCommonNode === null) {
                return [];
            }
            return getSortedResults(lowestCommonNode, searchKey, this.totalWeight);
        };
        /**
         * Returns the top N suggestions from the trie.
         * @param n How many suggestions, maximum, to return.
         */
        Trie.prototype.firstN = function (n) {
            return getSortedResults(this.root, '', this.totalWeight, n);
        };
        return Trie;
    }());
    /**
     * Finds the deepest descendent in the trie with the given prefix key.
     *
     * This means that a search in the trie for a given prefix has a best-case
     * complexity of O(m) where m is the length of the prefix.
     *
     * @param key The prefix to search for.
     * @param index The index in the prefix. Initially 0.
     */
    function findPrefix(node, key, index) {
        if (index === void 0) { index = 0; }
        // An important note - the Trie itself is built on a per-JS-character basis,
        // not on a UTF-8 character-code basis.
        if (node.type === 'leaf' || index === key.length) {
            return node;
        }
        // So, for SMP models, we need to match each char of the supplementary pair
        // in sequence.  Each has its own node in the Trie.
        var char = key[index];
        if (node.children[char]) {
            return findPrefix(node.children[char], key, index + 1);
        }
        return null;
    }
    /**
     * Returns all entries matching the given prefix, in descending order of
     * weight.
     *
     * @param prefix  the prefix to match.
     * @param results the current results
     * @param queue
     */
    function getSortedResults(node, prefix, N, limit) {
        if (limit === void 0) { limit = MAX_SUGGESTIONS; }
        var queue = new models.PriorityQueue(function (a, b) {
            // In case of Trie compilation issues that emit `null` or `undefined`
            return (b ? b.weight : 0) - (a ? a.weight : 0);
        });
        var results = [];
        if (node.type === 'leaf') {
            // Assuming the values are sorted, we can just add all of the values in the
            // leaf, until we reach the limit.
            for (var _i = 0, _a = node.entries; _i < _a.length; _i++) {
                var item = _a[_i];
                // String.startsWith is not supported on certain Android (5.0) devices we wish to support.
                // Requires a minimum of Chrome 36, as opposed to 5.0's default of 35.
                if (item.key.indexOf(prefix) == 0) {
                    var content = item.content, weight = item.weight;
                    results.push({
                        text: content,
                        p: weight / N
                    });
                    if (results.length >= limit) {
                        return results;
                    }
                }
            }
        }
        else {
            queue.enqueue(node);
            var next = void 0;
            var _loop_4 = function () {
                if (isNode(next)) {
                    // When a node is next up in the queue, that means that next least
                    // likely suggestion is among its decsendants.
                    // So we search all of its descendants!
                    if (next.type === 'leaf') {
                        queue.enqueueAll(next.entries);
                    }
                    else {
                        // XXX: alias `next` so that TypeScript can be SURE that internal is
                        // in fact an internal node. Because of the callback binding to the
                        // original definition of node (i.e., a Node | Entry), this will not
                        // type-check otherwise.
                        var internal_1 = next;
                        queue.enqueueAll(next.values.map(function (char) {
                            return internal_1.children[char];
                        }));
                    }
                }
                else {
                    // When an entry is up next in the queue, we just add its contents to
                    // the results!
                    results.push({
                        text: next.content,
                        p: next.weight / N
                    });
                    if (results.length >= limit) {
                        return { value: results };
                    }
                }
            };
            while (next = queue.dequeue()) {
                var state_1 = _loop_4();
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        return results;
    }
    /** TypeScript type guard that returns whether the thing is a Node. */
    function isNode(x) {
        return 'type' in x;
    }
    /**
     * Converts wordforms into an indexable form. It does this by
     * normalizing into NFD, removing diacritics, and then converting
     * the result to lowercase.
     *
     * This is a very naïve implementation, that I only think will work on
     * some languages that use the Latin script. As of 2020-04-08, only
     * 4 out of 11 (36%) of published language models use the Latin script,
     * so this might not actually be a great default.
     *
     * This uses String.prototype.normalize() to convert normalize into NFD.
     * NFD is an easy way to separate a Latin character from its diacritics;
     * Even then, some Latin-based orthographies use code points that,
     * under NFD normalization, do NOT decompose into an ASCII letter and a
     * combining diacritical mark (e.g., SENĆOŦEN).
     *
     * Use this only in early iterations of the model. For a production lexical
     * model, you SHOULD write/generate your own key function, tailored to your
     * language.
     */
    function defaultSearchTermToKey(wordform) {
        /**
         * N.B.: this is (slightly) DIFFERENT than the version in
         * keymanapp/lexical-model-compiler/build-trie
         * as this is for compatibility for models built
         * BEFORE the searchTermToKey function was bundled with
         * all models.
         *
         * This compatibility version lowercases AFTER removing diacritics;
         * the new version (bundled in future models) lowercases,
         * NFD normalizes, THEN removes diacritics.
         */
        return wordform
            .normalize('NFD')
            // Remove all combining diacritics (if input is in NFD)
            // common to Latin-orthographies.
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }
    function getDefaultWordBreaker() {
        var namespace;
        // @ts-ignore
        if (typeof wordBreakers !== 'undefined') {
            // @ts-ignore
            namespace = wordBreakers;
        }
        else {
            namespace = require('@keymanapp/models-wordBreakers').wordBreakers;
        }
        return namespace['default'];
    }
})(models || (models = {}));
var models;
(function (models) {
    var QuoteBehavior;
    (function (QuoteBehavior) {
        QuoteBehavior["noQuotes"] = "no-quotes";
        QuoteBehavior["useQuotes"] = "use-quotes";
        QuoteBehavior["default"] = "default-quotes";
    })(QuoteBehavior = models.QuoteBehavior || (models.QuoteBehavior = {}));
    // For an "enum/namespace merge".  See https://www.typescriptlang.org/docs/handbook/declaration-merging.html#merging-namespaces-with-classes
    (function (QuoteBehavior) {
        /**
         * Applies the specified quote behavior to the provided `Transform`, mutating it as appropriate.
         * @param transform    The Transform to be mutated
         * @param punctuation  The active `LexicalModelPunctuation` settings
         * @param defaultTo    The default quote behavior to use (in case the current value is `.default`)
         */
        function apply(behavior, text, punctuation, defaultTo) {
            if (defaultTo == QuoteBehavior.default || !defaultTo) {
                throw "Specified quote behavior may be ambiguous - default behavior not specified (may not be .default)";
            }
            if (behavior == QuoteBehavior.default) {
                behavior = defaultTo;
            }
            switch (behavior) {
                case QuoteBehavior.noQuotes:
                    return text;
                case QuoteBehavior.useQuotes:
                    var _a = punctuation.quotesForKeepSuggestion, open = _a.open, close = _a.close;
                    // This part's simple enough, at least.
                    return open + text + close;
                default:
                    throw "Unsupported quote behavior state detected; implementation missing!";
            }
        }
        QuoteBehavior.apply = apply;
    })(QuoteBehavior = models.QuoteBehavior || (models.QuoteBehavior = {}));
})(models || (models = {}));
/// <reference path="./trie-model.ts" />
/// <reference path="./quote-behavior.ts" />
// Add all namespaces defined here to the global scope:
if (typeof module != 'undefined' && typeof module.exports != 'undefined') {
    module.exports['models'] = models;
}
///<reference types="@keymanapp/models-types" />
var wordBreakers;
(function (wordBreakers) {
    /**
     * Splits ASCII words.
     *
     * @param phrase
     */
    function ascii(phrase) {
        var matchWord = /[A-Za-z0-9']+/g;
        var words = [];
        var match;
        while ((match = matchWord.exec(phrase)) !== null) {
            words.push(new RegExpDerivedSpan(match[0], match.index));
        }
        return words;
    }
    wordBreakers.ascii = ascii;
    /**
     * A concrete span class that derives its properties from the result of
     * RegExp.exec() array.
     */
    var RegExpDerivedSpan = /** @class */ (function () {
        function RegExpDerivedSpan(text, start) {
            this.text = text;
            this.start = start;
        }
        Object.defineProperty(RegExpDerivedSpan.prototype, "length", {
            get: function () {
                return this.text.length;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(RegExpDerivedSpan.prototype, "end", {
            get: function () {
                return this.start + this.text.length;
            },
            enumerable: false,
            configurable: true
        });
        return RegExpDerivedSpan;
    }());
})(wordBreakers || (wordBreakers = {}));
var wordBreakers;
(function (wordBreakers) {
    var data;
    (function (data) {
        ;
        // Not currently built by the auto-generator tool, but it easily could be.
        // If and when we import the data.ts rebuilder, we can add this in.
        data.propertyMap = [
            "Other",
            "LF",
            "Newline",
            "CR",
            "WSegSpace",
            "Double_Quote",
            "Single_Quote",
            "MidNum",
            "MidNumLet",
            "Numeric",
            "MidLetter",
            "ALetter",
            "ExtendNumLet",
            "Format",
            "Extend",
            "Hebrew_Letter",
            "ZWJ",
            "Katakana",
            "Regional_Indicator",
            "sot",
            "eot"
        ];
        data.WORD_BREAK_PROPERTY = [
            [/*start*/ 0x0, 0 /* Other */],
            [/*start*/ 0xA, 1 /* LF */],
            [/*start*/ 0xB, 2 /* Newline */],
            [/*start*/ 0xD, 3 /* CR */],
            [/*start*/ 0xE, 0 /* Other */],
            [/*start*/ 0x20, 4 /* WSegSpace */],
            [/*start*/ 0x21, 0 /* Other */],
            [/*start*/ 0x22, 5 /* Double_Quote */],
            [/*start*/ 0x23, 0 /* Other */],
            [/*start*/ 0x27, 6 /* Single_Quote */],
            [/*start*/ 0x28, 0 /* Other */],
            [/*start*/ 0x2C, 7 /* MidNum */],
            [/*start*/ 0x2D, 0 /* Other */],
            [/*start*/ 0x2E, 8 /* MidNumLet */],
            [/*start*/ 0x2F, 0 /* Other */],
            [/*start*/ 0x30, 9 /* Numeric */],
            [/*start*/ 0x3A, 10 /* MidLetter */],
            [/*start*/ 0x3B, 7 /* MidNum */],
            [/*start*/ 0x3C, 0 /* Other */],
            [/*start*/ 0x41, 11 /* ALetter */],
            [/*start*/ 0x5B, 0 /* Other */],
            [/*start*/ 0x5F, 12 /* ExtendNumLet */],
            [/*start*/ 0x60, 0 /* Other */],
            [/*start*/ 0x61, 11 /* ALetter */],
            [/*start*/ 0x7B, 0 /* Other */],
            [/*start*/ 0x85, 2 /* Newline */],
            [/*start*/ 0x86, 0 /* Other */],
            [/*start*/ 0xAA, 11 /* ALetter */],
            [/*start*/ 0xAB, 0 /* Other */],
            [/*start*/ 0xAD, 13 /* Format */],
            [/*start*/ 0xAE, 0 /* Other */],
            [/*start*/ 0xB5, 11 /* ALetter */],
            [/*start*/ 0xB6, 0 /* Other */],
            [/*start*/ 0xB7, 10 /* MidLetter */],
            [/*start*/ 0xB8, 0 /* Other */],
            [/*start*/ 0xBA, 11 /* ALetter */],
            [/*start*/ 0xBB, 0 /* Other */],
            [/*start*/ 0xC0, 11 /* ALetter */],
            [/*start*/ 0xD7, 0 /* Other */],
            [/*start*/ 0xD8, 11 /* ALetter */],
            [/*start*/ 0xF7, 0 /* Other */],
            [/*start*/ 0xF8, 11 /* ALetter */],
            [/*start*/ 0x2D8, 0 /* Other */],
            [/*start*/ 0x2DE, 11 /* ALetter */],
            [/*start*/ 0x300, 14 /* Extend */],
            [/*start*/ 0x370, 11 /* ALetter */],
            [/*start*/ 0x375, 0 /* Other */],
            [/*start*/ 0x376, 11 /* ALetter */],
            [/*start*/ 0x378, 0 /* Other */],
            [/*start*/ 0x37A, 11 /* ALetter */],
            [/*start*/ 0x37E, 7 /* MidNum */],
            [/*start*/ 0x37F, 11 /* ALetter */],
            [/*start*/ 0x380, 0 /* Other */],
            [/*start*/ 0x386, 11 /* ALetter */],
            [/*start*/ 0x387, 10 /* MidLetter */],
            [/*start*/ 0x388, 11 /* ALetter */],
            [/*start*/ 0x38B, 0 /* Other */],
            [/*start*/ 0x38C, 11 /* ALetter */],
            [/*start*/ 0x38D, 0 /* Other */],
            [/*start*/ 0x38E, 11 /* ALetter */],
            [/*start*/ 0x3A2, 0 /* Other */],
            [/*start*/ 0x3A3, 11 /* ALetter */],
            [/*start*/ 0x3F6, 0 /* Other */],
            [/*start*/ 0x3F7, 11 /* ALetter */],
            [/*start*/ 0x482, 0 /* Other */],
            [/*start*/ 0x483, 14 /* Extend */],
            [/*start*/ 0x48A, 11 /* ALetter */],
            [/*start*/ 0x530, 0 /* Other */],
            [/*start*/ 0x531, 11 /* ALetter */],
            [/*start*/ 0x557, 0 /* Other */],
            [/*start*/ 0x559, 11 /* ALetter */],
            [/*start*/ 0x55D, 0 /* Other */],
            [/*start*/ 0x55E, 11 /* ALetter */],
            [/*start*/ 0x55F, 10 /* MidLetter */],
            [/*start*/ 0x560, 11 /* ALetter */],
            [/*start*/ 0x589, 7 /* MidNum */],
            [/*start*/ 0x58A, 11 /* ALetter */],
            [/*start*/ 0x58B, 0 /* Other */],
            [/*start*/ 0x591, 14 /* Extend */],
            [/*start*/ 0x5BE, 0 /* Other */],
            [/*start*/ 0x5BF, 14 /* Extend */],
            [/*start*/ 0x5C0, 0 /* Other */],
            [/*start*/ 0x5C1, 14 /* Extend */],
            [/*start*/ 0x5C3, 0 /* Other */],
            [/*start*/ 0x5C4, 14 /* Extend */],
            [/*start*/ 0x5C6, 0 /* Other */],
            [/*start*/ 0x5C7, 14 /* Extend */],
            [/*start*/ 0x5C8, 0 /* Other */],
            [/*start*/ 0x5D0, 15 /* Hebrew_Letter */],
            [/*start*/ 0x5EB, 0 /* Other */],
            [/*start*/ 0x5EF, 15 /* Hebrew_Letter */],
            [/*start*/ 0x5F3, 11 /* ALetter */],
            [/*start*/ 0x5F4, 10 /* MidLetter */],
            [/*start*/ 0x5F5, 0 /* Other */],
            [/*start*/ 0x600, 13 /* Format */],
            [/*start*/ 0x606, 0 /* Other */],
            [/*start*/ 0x60C, 7 /* MidNum */],
            [/*start*/ 0x60E, 0 /* Other */],
            [/*start*/ 0x610, 14 /* Extend */],
            [/*start*/ 0x61B, 0 /* Other */],
            [/*start*/ 0x61C, 13 /* Format */],
            [/*start*/ 0x61D, 0 /* Other */],
            [/*start*/ 0x620, 11 /* ALetter */],
            [/*start*/ 0x64B, 14 /* Extend */],
            [/*start*/ 0x660, 9 /* Numeric */],
            [/*start*/ 0x66A, 0 /* Other */],
            [/*start*/ 0x66B, 9 /* Numeric */],
            [/*start*/ 0x66C, 7 /* MidNum */],
            [/*start*/ 0x66D, 0 /* Other */],
            [/*start*/ 0x66E, 11 /* ALetter */],
            [/*start*/ 0x670, 14 /* Extend */],
            [/*start*/ 0x671, 11 /* ALetter */],
            [/*start*/ 0x6D4, 0 /* Other */],
            [/*start*/ 0x6D5, 11 /* ALetter */],
            [/*start*/ 0x6D6, 14 /* Extend */],
            [/*start*/ 0x6DD, 13 /* Format */],
            [/*start*/ 0x6DE, 0 /* Other */],
            [/*start*/ 0x6DF, 14 /* Extend */],
            [/*start*/ 0x6E5, 11 /* ALetter */],
            [/*start*/ 0x6E7, 14 /* Extend */],
            [/*start*/ 0x6E9, 0 /* Other */],
            [/*start*/ 0x6EA, 14 /* Extend */],
            [/*start*/ 0x6EE, 11 /* ALetter */],
            [/*start*/ 0x6F0, 9 /* Numeric */],
            [/*start*/ 0x6FA, 11 /* ALetter */],
            [/*start*/ 0x6FD, 0 /* Other */],
            [/*start*/ 0x6FF, 11 /* ALetter */],
            [/*start*/ 0x700, 0 /* Other */],
            [/*start*/ 0x70F, 13 /* Format */],
            [/*start*/ 0x710, 11 /* ALetter */],
            [/*start*/ 0x711, 14 /* Extend */],
            [/*start*/ 0x712, 11 /* ALetter */],
            [/*start*/ 0x730, 14 /* Extend */],
            [/*start*/ 0x74B, 0 /* Other */],
            [/*start*/ 0x74D, 11 /* ALetter */],
            [/*start*/ 0x7A6, 14 /* Extend */],
            [/*start*/ 0x7B1, 11 /* ALetter */],
            [/*start*/ 0x7B2, 0 /* Other */],
            [/*start*/ 0x7C0, 9 /* Numeric */],
            [/*start*/ 0x7CA, 11 /* ALetter */],
            [/*start*/ 0x7EB, 14 /* Extend */],
            [/*start*/ 0x7F4, 11 /* ALetter */],
            [/*start*/ 0x7F6, 0 /* Other */],
            [/*start*/ 0x7F8, 7 /* MidNum */],
            [/*start*/ 0x7F9, 0 /* Other */],
            [/*start*/ 0x7FA, 11 /* ALetter */],
            [/*start*/ 0x7FB, 0 /* Other */],
            [/*start*/ 0x7FD, 14 /* Extend */],
            [/*start*/ 0x7FE, 0 /* Other */],
            [/*start*/ 0x800, 11 /* ALetter */],
            [/*start*/ 0x816, 14 /* Extend */],
            [/*start*/ 0x81A, 11 /* ALetter */],
            [/*start*/ 0x81B, 14 /* Extend */],
            [/*start*/ 0x824, 11 /* ALetter */],
            [/*start*/ 0x825, 14 /* Extend */],
            [/*start*/ 0x828, 11 /* ALetter */],
            [/*start*/ 0x829, 14 /* Extend */],
            [/*start*/ 0x82E, 0 /* Other */],
            [/*start*/ 0x840, 11 /* ALetter */],
            [/*start*/ 0x859, 14 /* Extend */],
            [/*start*/ 0x85C, 0 /* Other */],
            [/*start*/ 0x860, 11 /* ALetter */],
            [/*start*/ 0x86B, 0 /* Other */],
            [/*start*/ 0x8A0, 11 /* ALetter */],
            [/*start*/ 0x8B5, 0 /* Other */],
            [/*start*/ 0x8B6, 11 /* ALetter */],
            [/*start*/ 0x8C8, 0 /* Other */],
            [/*start*/ 0x8D3, 14 /* Extend */],
            [/*start*/ 0x8E2, 13 /* Format */],
            [/*start*/ 0x8E3, 14 /* Extend */],
            [/*start*/ 0x904, 11 /* ALetter */],
            [/*start*/ 0x93A, 14 /* Extend */],
            [/*start*/ 0x93D, 11 /* ALetter */],
            [/*start*/ 0x93E, 14 /* Extend */],
            [/*start*/ 0x950, 11 /* ALetter */],
            [/*start*/ 0x951, 14 /* Extend */],
            [/*start*/ 0x958, 11 /* ALetter */],
            [/*start*/ 0x962, 14 /* Extend */],
            [/*start*/ 0x964, 0 /* Other */],
            [/*start*/ 0x966, 9 /* Numeric */],
            [/*start*/ 0x970, 0 /* Other */],
            [/*start*/ 0x971, 11 /* ALetter */],
            [/*start*/ 0x981, 14 /* Extend */],
            [/*start*/ 0x984, 0 /* Other */],
            [/*start*/ 0x985, 11 /* ALetter */],
            [/*start*/ 0x98D, 0 /* Other */],
            [/*start*/ 0x98F, 11 /* ALetter */],
            [/*start*/ 0x991, 0 /* Other */],
            [/*start*/ 0x993, 11 /* ALetter */],
            [/*start*/ 0x9A9, 0 /* Other */],
            [/*start*/ 0x9AA, 11 /* ALetter */],
            [/*start*/ 0x9B1, 0 /* Other */],
            [/*start*/ 0x9B2, 11 /* ALetter */],
            [/*start*/ 0x9B3, 0 /* Other */],
            [/*start*/ 0x9B6, 11 /* ALetter */],
            [/*start*/ 0x9BA, 0 /* Other */],
            [/*start*/ 0x9BC, 14 /* Extend */],
            [/*start*/ 0x9BD, 11 /* ALetter */],
            [/*start*/ 0x9BE, 14 /* Extend */],
            [/*start*/ 0x9C5, 0 /* Other */],
            [/*start*/ 0x9C7, 14 /* Extend */],
            [/*start*/ 0x9C9, 0 /* Other */],
            [/*start*/ 0x9CB, 14 /* Extend */],
            [/*start*/ 0x9CE, 11 /* ALetter */],
            [/*start*/ 0x9CF, 0 /* Other */],
            [/*start*/ 0x9D7, 14 /* Extend */],
            [/*start*/ 0x9D8, 0 /* Other */],
            [/*start*/ 0x9DC, 11 /* ALetter */],
            [/*start*/ 0x9DE, 0 /* Other */],
            [/*start*/ 0x9DF, 11 /* ALetter */],
            [/*start*/ 0x9E2, 14 /* Extend */],
            [/*start*/ 0x9E4, 0 /* Other */],
            [/*start*/ 0x9E6, 9 /* Numeric */],
            [/*start*/ 0x9F0, 11 /* ALetter */],
            [/*start*/ 0x9F2, 0 /* Other */],
            [/*start*/ 0x9FC, 11 /* ALetter */],
            [/*start*/ 0x9FD, 0 /* Other */],
            [/*start*/ 0x9FE, 14 /* Extend */],
            [/*start*/ 0x9FF, 0 /* Other */],
            [/*start*/ 0xA01, 14 /* Extend */],
            [/*start*/ 0xA04, 0 /* Other */],
            [/*start*/ 0xA05, 11 /* ALetter */],
            [/*start*/ 0xA0B, 0 /* Other */],
            [/*start*/ 0xA0F, 11 /* ALetter */],
            [/*start*/ 0xA11, 0 /* Other */],
            [/*start*/ 0xA13, 11 /* ALetter */],
            [/*start*/ 0xA29, 0 /* Other */],
            [/*start*/ 0xA2A, 11 /* ALetter */],
            [/*start*/ 0xA31, 0 /* Other */],
            [/*start*/ 0xA32, 11 /* ALetter */],
            [/*start*/ 0xA34, 0 /* Other */],
            [/*start*/ 0xA35, 11 /* ALetter */],
            [/*start*/ 0xA37, 0 /* Other */],
            [/*start*/ 0xA38, 11 /* ALetter */],
            [/*start*/ 0xA3A, 0 /* Other */],
            [/*start*/ 0xA3C, 14 /* Extend */],
            [/*start*/ 0xA3D, 0 /* Other */],
            [/*start*/ 0xA3E, 14 /* Extend */],
            [/*start*/ 0xA43, 0 /* Other */],
            [/*start*/ 0xA47, 14 /* Extend */],
            [/*start*/ 0xA49, 0 /* Other */],
            [/*start*/ 0xA4B, 14 /* Extend */],
            [/*start*/ 0xA4E, 0 /* Other */],
            [/*start*/ 0xA51, 14 /* Extend */],
            [/*start*/ 0xA52, 0 /* Other */],
            [/*start*/ 0xA59, 11 /* ALetter */],
            [/*start*/ 0xA5D, 0 /* Other */],
            [/*start*/ 0xA5E, 11 /* ALetter */],
            [/*start*/ 0xA5F, 0 /* Other */],
            [/*start*/ 0xA66, 9 /* Numeric */],
            [/*start*/ 0xA70, 14 /* Extend */],
            [/*start*/ 0xA72, 11 /* ALetter */],
            [/*start*/ 0xA75, 14 /* Extend */],
            [/*start*/ 0xA76, 0 /* Other */],
            [/*start*/ 0xA81, 14 /* Extend */],
            [/*start*/ 0xA84, 0 /* Other */],
            [/*start*/ 0xA85, 11 /* ALetter */],
            [/*start*/ 0xA8E, 0 /* Other */],
            [/*start*/ 0xA8F, 11 /* ALetter */],
            [/*start*/ 0xA92, 0 /* Other */],
            [/*start*/ 0xA93, 11 /* ALetter */],
            [/*start*/ 0xAA9, 0 /* Other */],
            [/*start*/ 0xAAA, 11 /* ALetter */],
            [/*start*/ 0xAB1, 0 /* Other */],
            [/*start*/ 0xAB2, 11 /* ALetter */],
            [/*start*/ 0xAB4, 0 /* Other */],
            [/*start*/ 0xAB5, 11 /* ALetter */],
            [/*start*/ 0xABA, 0 /* Other */],
            [/*start*/ 0xABC, 14 /* Extend */],
            [/*start*/ 0xABD, 11 /* ALetter */],
            [/*start*/ 0xABE, 14 /* Extend */],
            [/*start*/ 0xAC6, 0 /* Other */],
            [/*start*/ 0xAC7, 14 /* Extend */],
            [/*start*/ 0xACA, 0 /* Other */],
            [/*start*/ 0xACB, 14 /* Extend */],
            [/*start*/ 0xACE, 0 /* Other */],
            [/*start*/ 0xAD0, 11 /* ALetter */],
            [/*start*/ 0xAD1, 0 /* Other */],
            [/*start*/ 0xAE0, 11 /* ALetter */],
            [/*start*/ 0xAE2, 14 /* Extend */],
            [/*start*/ 0xAE4, 0 /* Other */],
            [/*start*/ 0xAE6, 9 /* Numeric */],
            [/*start*/ 0xAF0, 0 /* Other */],
            [/*start*/ 0xAF9, 11 /* ALetter */],
            [/*start*/ 0xAFA, 14 /* Extend */],
            [/*start*/ 0xB00, 0 /* Other */],
            [/*start*/ 0xB01, 14 /* Extend */],
            [/*start*/ 0xB04, 0 /* Other */],
            [/*start*/ 0xB05, 11 /* ALetter */],
            [/*start*/ 0xB0D, 0 /* Other */],
            [/*start*/ 0xB0F, 11 /* ALetter */],
            [/*start*/ 0xB11, 0 /* Other */],
            [/*start*/ 0xB13, 11 /* ALetter */],
            [/*start*/ 0xB29, 0 /* Other */],
            [/*start*/ 0xB2A, 11 /* ALetter */],
            [/*start*/ 0xB31, 0 /* Other */],
            [/*start*/ 0xB32, 11 /* ALetter */],
            [/*start*/ 0xB34, 0 /* Other */],
            [/*start*/ 0xB35, 11 /* ALetter */],
            [/*start*/ 0xB3A, 0 /* Other */],
            [/*start*/ 0xB3C, 14 /* Extend */],
            [/*start*/ 0xB3D, 11 /* ALetter */],
            [/*start*/ 0xB3E, 14 /* Extend */],
            [/*start*/ 0xB45, 0 /* Other */],
            [/*start*/ 0xB47, 14 /* Extend */],
            [/*start*/ 0xB49, 0 /* Other */],
            [/*start*/ 0xB4B, 14 /* Extend */],
            [/*start*/ 0xB4E, 0 /* Other */],
            [/*start*/ 0xB55, 14 /* Extend */],
            [/*start*/ 0xB58, 0 /* Other */],
            [/*start*/ 0xB5C, 11 /* ALetter */],
            [/*start*/ 0xB5E, 0 /* Other */],
            [/*start*/ 0xB5F, 11 /* ALetter */],
            [/*start*/ 0xB62, 14 /* Extend */],
            [/*start*/ 0xB64, 0 /* Other */],
            [/*start*/ 0xB66, 9 /* Numeric */],
            [/*start*/ 0xB70, 0 /* Other */],
            [/*start*/ 0xB71, 11 /* ALetter */],
            [/*start*/ 0xB72, 0 /* Other */],
            [/*start*/ 0xB82, 14 /* Extend */],
            [/*start*/ 0xB83, 11 /* ALetter */],
            [/*start*/ 0xB84, 0 /* Other */],
            [/*start*/ 0xB85, 11 /* ALetter */],
            [/*start*/ 0xB8B, 0 /* Other */],
            [/*start*/ 0xB8E, 11 /* ALetter */],
            [/*start*/ 0xB91, 0 /* Other */],
            [/*start*/ 0xB92, 11 /* ALetter */],
            [/*start*/ 0xB96, 0 /* Other */],
            [/*start*/ 0xB99, 11 /* ALetter */],
            [/*start*/ 0xB9B, 0 /* Other */],
            [/*start*/ 0xB9C, 11 /* ALetter */],
            [/*start*/ 0xB9D, 0 /* Other */],
            [/*start*/ 0xB9E, 11 /* ALetter */],
            [/*start*/ 0xBA0, 0 /* Other */],
            [/*start*/ 0xBA3, 11 /* ALetter */],
            [/*start*/ 0xBA5, 0 /* Other */],
            [/*start*/ 0xBA8, 11 /* ALetter */],
            [/*start*/ 0xBAB, 0 /* Other */],
            [/*start*/ 0xBAE, 11 /* ALetter */],
            [/*start*/ 0xBBA, 0 /* Other */],
            [/*start*/ 0xBBE, 14 /* Extend */],
            [/*start*/ 0xBC3, 0 /* Other */],
            [/*start*/ 0xBC6, 14 /* Extend */],
            [/*start*/ 0xBC9, 0 /* Other */],
            [/*start*/ 0xBCA, 14 /* Extend */],
            [/*start*/ 0xBCE, 0 /* Other */],
            [/*start*/ 0xBD0, 11 /* ALetter */],
            [/*start*/ 0xBD1, 0 /* Other */],
            [/*start*/ 0xBD7, 14 /* Extend */],
            [/*start*/ 0xBD8, 0 /* Other */],
            [/*start*/ 0xBE6, 9 /* Numeric */],
            [/*start*/ 0xBF0, 0 /* Other */],
            [/*start*/ 0xC00, 14 /* Extend */],
            [/*start*/ 0xC05, 11 /* ALetter */],
            [/*start*/ 0xC0D, 0 /* Other */],
            [/*start*/ 0xC0E, 11 /* ALetter */],
            [/*start*/ 0xC11, 0 /* Other */],
            [/*start*/ 0xC12, 11 /* ALetter */],
            [/*start*/ 0xC29, 0 /* Other */],
            [/*start*/ 0xC2A, 11 /* ALetter */],
            [/*start*/ 0xC3A, 0 /* Other */],
            [/*start*/ 0xC3D, 11 /* ALetter */],
            [/*start*/ 0xC3E, 14 /* Extend */],
            [/*start*/ 0xC45, 0 /* Other */],
            [/*start*/ 0xC46, 14 /* Extend */],
            [/*start*/ 0xC49, 0 /* Other */],
            [/*start*/ 0xC4A, 14 /* Extend */],
            [/*start*/ 0xC4E, 0 /* Other */],
            [/*start*/ 0xC55, 14 /* Extend */],
            [/*start*/ 0xC57, 0 /* Other */],
            [/*start*/ 0xC58, 11 /* ALetter */],
            [/*start*/ 0xC5B, 0 /* Other */],
            [/*start*/ 0xC60, 11 /* ALetter */],
            [/*start*/ 0xC62, 14 /* Extend */],
            [/*start*/ 0xC64, 0 /* Other */],
            [/*start*/ 0xC66, 9 /* Numeric */],
            [/*start*/ 0xC70, 0 /* Other */],
            [/*start*/ 0xC80, 11 /* ALetter */],
            [/*start*/ 0xC81, 14 /* Extend */],
            [/*start*/ 0xC84, 0 /* Other */],
            [/*start*/ 0xC85, 11 /* ALetter */],
            [/*start*/ 0xC8D, 0 /* Other */],
            [/*start*/ 0xC8E, 11 /* ALetter */],
            [/*start*/ 0xC91, 0 /* Other */],
            [/*start*/ 0xC92, 11 /* ALetter */],
            [/*start*/ 0xCA9, 0 /* Other */],
            [/*start*/ 0xCAA, 11 /* ALetter */],
            [/*start*/ 0xCB4, 0 /* Other */],
            [/*start*/ 0xCB5, 11 /* ALetter */],
            [/*start*/ 0xCBA, 0 /* Other */],
            [/*start*/ 0xCBC, 14 /* Extend */],
            [/*start*/ 0xCBD, 11 /* ALetter */],
            [/*start*/ 0xCBE, 14 /* Extend */],
            [/*start*/ 0xCC5, 0 /* Other */],
            [/*start*/ 0xCC6, 14 /* Extend */],
            [/*start*/ 0xCC9, 0 /* Other */],
            [/*start*/ 0xCCA, 14 /* Extend */],
            [/*start*/ 0xCCE, 0 /* Other */],
            [/*start*/ 0xCD5, 14 /* Extend */],
            [/*start*/ 0xCD7, 0 /* Other */],
            [/*start*/ 0xCDE, 11 /* ALetter */],
            [/*start*/ 0xCDF, 0 /* Other */],
            [/*start*/ 0xCE0, 11 /* ALetter */],
            [/*start*/ 0xCE2, 14 /* Extend */],
            [/*start*/ 0xCE4, 0 /* Other */],
            [/*start*/ 0xCE6, 9 /* Numeric */],
            [/*start*/ 0xCF0, 0 /* Other */],
            [/*start*/ 0xCF1, 11 /* ALetter */],
            [/*start*/ 0xCF3, 0 /* Other */],
            [/*start*/ 0xD00, 14 /* Extend */],
            [/*start*/ 0xD04, 11 /* ALetter */],
            [/*start*/ 0xD0D, 0 /* Other */],
            [/*start*/ 0xD0E, 11 /* ALetter */],
            [/*start*/ 0xD11, 0 /* Other */],
            [/*start*/ 0xD12, 11 /* ALetter */],
            [/*start*/ 0xD3B, 14 /* Extend */],
            [/*start*/ 0xD3D, 11 /* ALetter */],
            [/*start*/ 0xD3E, 14 /* Extend */],
            [/*start*/ 0xD45, 0 /* Other */],
            [/*start*/ 0xD46, 14 /* Extend */],
            [/*start*/ 0xD49, 0 /* Other */],
            [/*start*/ 0xD4A, 14 /* Extend */],
            [/*start*/ 0xD4E, 11 /* ALetter */],
            [/*start*/ 0xD4F, 0 /* Other */],
            [/*start*/ 0xD54, 11 /* ALetter */],
            [/*start*/ 0xD57, 14 /* Extend */],
            [/*start*/ 0xD58, 0 /* Other */],
            [/*start*/ 0xD5F, 11 /* ALetter */],
            [/*start*/ 0xD62, 14 /* Extend */],
            [/*start*/ 0xD64, 0 /* Other */],
            [/*start*/ 0xD66, 9 /* Numeric */],
            [/*start*/ 0xD70, 0 /* Other */],
            [/*start*/ 0xD7A, 11 /* ALetter */],
            [/*start*/ 0xD80, 0 /* Other */],
            [/*start*/ 0xD81, 14 /* Extend */],
            [/*start*/ 0xD84, 0 /* Other */],
            [/*start*/ 0xD85, 11 /* ALetter */],
            [/*start*/ 0xD97, 0 /* Other */],
            [/*start*/ 0xD9A, 11 /* ALetter */],
            [/*start*/ 0xDB2, 0 /* Other */],
            [/*start*/ 0xDB3, 11 /* ALetter */],
            [/*start*/ 0xDBC, 0 /* Other */],
            [/*start*/ 0xDBD, 11 /* ALetter */],
            [/*start*/ 0xDBE, 0 /* Other */],
            [/*start*/ 0xDC0, 11 /* ALetter */],
            [/*start*/ 0xDC7, 0 /* Other */],
            [/*start*/ 0xDCA, 14 /* Extend */],
            [/*start*/ 0xDCB, 0 /* Other */],
            [/*start*/ 0xDCF, 14 /* Extend */],
            [/*start*/ 0xDD5, 0 /* Other */],
            [/*start*/ 0xDD6, 14 /* Extend */],
            [/*start*/ 0xDD7, 0 /* Other */],
            [/*start*/ 0xDD8, 14 /* Extend */],
            [/*start*/ 0xDE0, 0 /* Other */],
            [/*start*/ 0xDE6, 9 /* Numeric */],
            [/*start*/ 0xDF0, 0 /* Other */],
            [/*start*/ 0xDF2, 14 /* Extend */],
            [/*start*/ 0xDF4, 0 /* Other */],
            [/*start*/ 0xE31, 14 /* Extend */],
            [/*start*/ 0xE32, 0 /* Other */],
            [/*start*/ 0xE34, 14 /* Extend */],
            [/*start*/ 0xE3B, 0 /* Other */],
            [/*start*/ 0xE47, 14 /* Extend */],
            [/*start*/ 0xE4F, 0 /* Other */],
            [/*start*/ 0xE50, 9 /* Numeric */],
            [/*start*/ 0xE5A, 0 /* Other */],
            [/*start*/ 0xEB1, 14 /* Extend */],
            [/*start*/ 0xEB2, 0 /* Other */],
            [/*start*/ 0xEB4, 14 /* Extend */],
            [/*start*/ 0xEBD, 0 /* Other */],
            [/*start*/ 0xEC8, 14 /* Extend */],
            [/*start*/ 0xECE, 0 /* Other */],
            [/*start*/ 0xED0, 9 /* Numeric */],
            [/*start*/ 0xEDA, 0 /* Other */],
            [/*start*/ 0xF00, 11 /* ALetter */],
            [/*start*/ 0xF01, 0 /* Other */],
            [/*start*/ 0xF18, 14 /* Extend */],
            [/*start*/ 0xF1A, 0 /* Other */],
            [/*start*/ 0xF20, 9 /* Numeric */],
            [/*start*/ 0xF2A, 0 /* Other */],
            [/*start*/ 0xF35, 14 /* Extend */],
            [/*start*/ 0xF36, 0 /* Other */],
            [/*start*/ 0xF37, 14 /* Extend */],
            [/*start*/ 0xF38, 0 /* Other */],
            [/*start*/ 0xF39, 14 /* Extend */],
            [/*start*/ 0xF3A, 0 /* Other */],
            [/*start*/ 0xF3E, 14 /* Extend */],
            [/*start*/ 0xF40, 11 /* ALetter */],
            [/*start*/ 0xF48, 0 /* Other */],
            [/*start*/ 0xF49, 11 /* ALetter */],
            [/*start*/ 0xF6D, 0 /* Other */],
            [/*start*/ 0xF71, 14 /* Extend */],
            [/*start*/ 0xF85, 0 /* Other */],
            [/*start*/ 0xF86, 14 /* Extend */],
            [/*start*/ 0xF88, 11 /* ALetter */],
            [/*start*/ 0xF8D, 14 /* Extend */],
            [/*start*/ 0xF98, 0 /* Other */],
            [/*start*/ 0xF99, 14 /* Extend */],
            [/*start*/ 0xFBD, 0 /* Other */],
            [/*start*/ 0xFC6, 14 /* Extend */],
            [/*start*/ 0xFC7, 0 /* Other */],
            [/*start*/ 0x102B, 14 /* Extend */],
            [/*start*/ 0x103F, 0 /* Other */],
            [/*start*/ 0x1040, 9 /* Numeric */],
            [/*start*/ 0x104A, 0 /* Other */],
            [/*start*/ 0x1056, 14 /* Extend */],
            [/*start*/ 0x105A, 0 /* Other */],
            [/*start*/ 0x105E, 14 /* Extend */],
            [/*start*/ 0x1061, 0 /* Other */],
            [/*start*/ 0x1062, 14 /* Extend */],
            [/*start*/ 0x1065, 0 /* Other */],
            [/*start*/ 0x1067, 14 /* Extend */],
            [/*start*/ 0x106E, 0 /* Other */],
            [/*start*/ 0x1071, 14 /* Extend */],
            [/*start*/ 0x1075, 0 /* Other */],
            [/*start*/ 0x1082, 14 /* Extend */],
            [/*start*/ 0x108E, 0 /* Other */],
            [/*start*/ 0x108F, 14 /* Extend */],
            [/*start*/ 0x1090, 9 /* Numeric */],
            [/*start*/ 0x109A, 14 /* Extend */],
            [/*start*/ 0x109E, 0 /* Other */],
            [/*start*/ 0x10A0, 11 /* ALetter */],
            [/*start*/ 0x10C6, 0 /* Other */],
            [/*start*/ 0x10C7, 11 /* ALetter */],
            [/*start*/ 0x10C8, 0 /* Other */],
            [/*start*/ 0x10CD, 11 /* ALetter */],
            [/*start*/ 0x10CE, 0 /* Other */],
            [/*start*/ 0x10D0, 11 /* ALetter */],
            [/*start*/ 0x10FB, 0 /* Other */],
            [/*start*/ 0x10FC, 11 /* ALetter */],
            [/*start*/ 0x1249, 0 /* Other */],
            [/*start*/ 0x124A, 11 /* ALetter */],
            [/*start*/ 0x124E, 0 /* Other */],
            [/*start*/ 0x1250, 11 /* ALetter */],
            [/*start*/ 0x1257, 0 /* Other */],
            [/*start*/ 0x1258, 11 /* ALetter */],
            [/*start*/ 0x1259, 0 /* Other */],
            [/*start*/ 0x125A, 11 /* ALetter */],
            [/*start*/ 0x125E, 0 /* Other */],
            [/*start*/ 0x1260, 11 /* ALetter */],
            [/*start*/ 0x1289, 0 /* Other */],
            [/*start*/ 0x128A, 11 /* ALetter */],
            [/*start*/ 0x128E, 0 /* Other */],
            [/*start*/ 0x1290, 11 /* ALetter */],
            [/*start*/ 0x12B1, 0 /* Other */],
            [/*start*/ 0x12B2, 11 /* ALetter */],
            [/*start*/ 0x12B6, 0 /* Other */],
            [/*start*/ 0x12B8, 11 /* ALetter */],
            [/*start*/ 0x12BF, 0 /* Other */],
            [/*start*/ 0x12C0, 11 /* ALetter */],
            [/*start*/ 0x12C1, 0 /* Other */],
            [/*start*/ 0x12C2, 11 /* ALetter */],
            [/*start*/ 0x12C6, 0 /* Other */],
            [/*start*/ 0x12C8, 11 /* ALetter */],
            [/*start*/ 0x12D7, 0 /* Other */],
            [/*start*/ 0x12D8, 11 /* ALetter */],
            [/*start*/ 0x1311, 0 /* Other */],
            [/*start*/ 0x1312, 11 /* ALetter */],
            [/*start*/ 0x1316, 0 /* Other */],
            [/*start*/ 0x1318, 11 /* ALetter */],
            [/*start*/ 0x135B, 0 /* Other */],
            [/*start*/ 0x135D, 14 /* Extend */],
            [/*start*/ 0x1360, 0 /* Other */],
            [/*start*/ 0x1380, 11 /* ALetter */],
            [/*start*/ 0x1390, 0 /* Other */],
            [/*start*/ 0x13A0, 11 /* ALetter */],
            [/*start*/ 0x13F6, 0 /* Other */],
            [/*start*/ 0x13F8, 11 /* ALetter */],
            [/*start*/ 0x13FE, 0 /* Other */],
            [/*start*/ 0x1401, 11 /* ALetter */],
            [/*start*/ 0x166D, 0 /* Other */],
            [/*start*/ 0x166F, 11 /* ALetter */],
            [/*start*/ 0x1680, 4 /* WSegSpace */],
            [/*start*/ 0x1681, 11 /* ALetter */],
            [/*start*/ 0x169B, 0 /* Other */],
            [/*start*/ 0x16A0, 11 /* ALetter */],
            [/*start*/ 0x16EB, 0 /* Other */],
            [/*start*/ 0x16EE, 11 /* ALetter */],
            [/*start*/ 0x16F9, 0 /* Other */],
            [/*start*/ 0x1700, 11 /* ALetter */],
            [/*start*/ 0x170D, 0 /* Other */],
            [/*start*/ 0x170E, 11 /* ALetter */],
            [/*start*/ 0x1712, 14 /* Extend */],
            [/*start*/ 0x1715, 0 /* Other */],
            [/*start*/ 0x1720, 11 /* ALetter */],
            [/*start*/ 0x1732, 14 /* Extend */],
            [/*start*/ 0x1735, 0 /* Other */],
            [/*start*/ 0x1740, 11 /* ALetter */],
            [/*start*/ 0x1752, 14 /* Extend */],
            [/*start*/ 0x1754, 0 /* Other */],
            [/*start*/ 0x1760, 11 /* ALetter */],
            [/*start*/ 0x176D, 0 /* Other */],
            [/*start*/ 0x176E, 11 /* ALetter */],
            [/*start*/ 0x1771, 0 /* Other */],
            [/*start*/ 0x1772, 14 /* Extend */],
            [/*start*/ 0x1774, 0 /* Other */],
            [/*start*/ 0x17B4, 14 /* Extend */],
            [/*start*/ 0x17D4, 0 /* Other */],
            [/*start*/ 0x17DD, 14 /* Extend */],
            [/*start*/ 0x17DE, 0 /* Other */],
            [/*start*/ 0x17E0, 9 /* Numeric */],
            [/*start*/ 0x17EA, 0 /* Other */],
            [/*start*/ 0x180B, 14 /* Extend */],
            [/*start*/ 0x180E, 13 /* Format */],
            [/*start*/ 0x180F, 0 /* Other */],
            [/*start*/ 0x1810, 9 /* Numeric */],
            [/*start*/ 0x181A, 0 /* Other */],
            [/*start*/ 0x1820, 11 /* ALetter */],
            [/*start*/ 0x1879, 0 /* Other */],
            [/*start*/ 0x1880, 11 /* ALetter */],
            [/*start*/ 0x1885, 14 /* Extend */],
            [/*start*/ 0x1887, 11 /* ALetter */],
            [/*start*/ 0x18A9, 14 /* Extend */],
            [/*start*/ 0x18AA, 11 /* ALetter */],
            [/*start*/ 0x18AB, 0 /* Other */],
            [/*start*/ 0x18B0, 11 /* ALetter */],
            [/*start*/ 0x18F6, 0 /* Other */],
            [/*start*/ 0x1900, 11 /* ALetter */],
            [/*start*/ 0x191F, 0 /* Other */],
            [/*start*/ 0x1920, 14 /* Extend */],
            [/*start*/ 0x192C, 0 /* Other */],
            [/*start*/ 0x1930, 14 /* Extend */],
            [/*start*/ 0x193C, 0 /* Other */],
            [/*start*/ 0x1946, 9 /* Numeric */],
            [/*start*/ 0x1950, 0 /* Other */],
            [/*start*/ 0x19D0, 9 /* Numeric */],
            [/*start*/ 0x19DA, 0 /* Other */],
            [/*start*/ 0x1A00, 11 /* ALetter */],
            [/*start*/ 0x1A17, 14 /* Extend */],
            [/*start*/ 0x1A1C, 0 /* Other */],
            [/*start*/ 0x1A55, 14 /* Extend */],
            [/*start*/ 0x1A5F, 0 /* Other */],
            [/*start*/ 0x1A60, 14 /* Extend */],
            [/*start*/ 0x1A7D, 0 /* Other */],
            [/*start*/ 0x1A7F, 14 /* Extend */],
            [/*start*/ 0x1A80, 9 /* Numeric */],
            [/*start*/ 0x1A8A, 0 /* Other */],
            [/*start*/ 0x1A90, 9 /* Numeric */],
            [/*start*/ 0x1A9A, 0 /* Other */],
            [/*start*/ 0x1AB0, 14 /* Extend */],
            [/*start*/ 0x1AC1, 0 /* Other */],
            [/*start*/ 0x1B00, 14 /* Extend */],
            [/*start*/ 0x1B05, 11 /* ALetter */],
            [/*start*/ 0x1B34, 14 /* Extend */],
            [/*start*/ 0x1B45, 11 /* ALetter */],
            [/*start*/ 0x1B4C, 0 /* Other */],
            [/*start*/ 0x1B50, 9 /* Numeric */],
            [/*start*/ 0x1B5A, 0 /* Other */],
            [/*start*/ 0x1B6B, 14 /* Extend */],
            [/*start*/ 0x1B74, 0 /* Other */],
            [/*start*/ 0x1B80, 14 /* Extend */],
            [/*start*/ 0x1B83, 11 /* ALetter */],
            [/*start*/ 0x1BA1, 14 /* Extend */],
            [/*start*/ 0x1BAE, 11 /* ALetter */],
            [/*start*/ 0x1BB0, 9 /* Numeric */],
            [/*start*/ 0x1BBA, 11 /* ALetter */],
            [/*start*/ 0x1BE6, 14 /* Extend */],
            [/*start*/ 0x1BF4, 0 /* Other */],
            [/*start*/ 0x1C00, 11 /* ALetter */],
            [/*start*/ 0x1C24, 14 /* Extend */],
            [/*start*/ 0x1C38, 0 /* Other */],
            [/*start*/ 0x1C40, 9 /* Numeric */],
            [/*start*/ 0x1C4A, 0 /* Other */],
            [/*start*/ 0x1C4D, 11 /* ALetter */],
            [/*start*/ 0x1C50, 9 /* Numeric */],
            [/*start*/ 0x1C5A, 11 /* ALetter */],
            [/*start*/ 0x1C7E, 0 /* Other */],
            [/*start*/ 0x1C80, 11 /* ALetter */],
            [/*start*/ 0x1C89, 0 /* Other */],
            [/*start*/ 0x1C90, 11 /* ALetter */],
            [/*start*/ 0x1CBB, 0 /* Other */],
            [/*start*/ 0x1CBD, 11 /* ALetter */],
            [/*start*/ 0x1CC0, 0 /* Other */],
            [/*start*/ 0x1CD0, 14 /* Extend */],
            [/*start*/ 0x1CD3, 0 /* Other */],
            [/*start*/ 0x1CD4, 14 /* Extend */],
            [/*start*/ 0x1CE9, 11 /* ALetter */],
            [/*start*/ 0x1CED, 14 /* Extend */],
            [/*start*/ 0x1CEE, 11 /* ALetter */],
            [/*start*/ 0x1CF4, 14 /* Extend */],
            [/*start*/ 0x1CF5, 11 /* ALetter */],
            [/*start*/ 0x1CF7, 14 /* Extend */],
            [/*start*/ 0x1CFA, 11 /* ALetter */],
            [/*start*/ 0x1CFB, 0 /* Other */],
            [/*start*/ 0x1D00, 11 /* ALetter */],
            [/*start*/ 0x1DC0, 14 /* Extend */],
            [/*start*/ 0x1DFA, 0 /* Other */],
            [/*start*/ 0x1DFB, 14 /* Extend */],
            [/*start*/ 0x1E00, 11 /* ALetter */],
            [/*start*/ 0x1F16, 0 /* Other */],
            [/*start*/ 0x1F18, 11 /* ALetter */],
            [/*start*/ 0x1F1E, 0 /* Other */],
            [/*start*/ 0x1F20, 11 /* ALetter */],
            [/*start*/ 0x1F46, 0 /* Other */],
            [/*start*/ 0x1F48, 11 /* ALetter */],
            [/*start*/ 0x1F4E, 0 /* Other */],
            [/*start*/ 0x1F50, 11 /* ALetter */],
            [/*start*/ 0x1F58, 0 /* Other */],
            [/*start*/ 0x1F59, 11 /* ALetter */],
            [/*start*/ 0x1F5A, 0 /* Other */],
            [/*start*/ 0x1F5B, 11 /* ALetter */],
            [/*start*/ 0x1F5C, 0 /* Other */],
            [/*start*/ 0x1F5D, 11 /* ALetter */],
            [/*start*/ 0x1F5E, 0 /* Other */],
            [/*start*/ 0x1F5F, 11 /* ALetter */],
            [/*start*/ 0x1F7E, 0 /* Other */],
            [/*start*/ 0x1F80, 11 /* ALetter */],
            [/*start*/ 0x1FB5, 0 /* Other */],
            [/*start*/ 0x1FB6, 11 /* ALetter */],
            [/*start*/ 0x1FBD, 0 /* Other */],
            [/*start*/ 0x1FBE, 11 /* ALetter */],
            [/*start*/ 0x1FBF, 0 /* Other */],
            [/*start*/ 0x1FC2, 11 /* ALetter */],
            [/*start*/ 0x1FC5, 0 /* Other */],
            [/*start*/ 0x1FC6, 11 /* ALetter */],
            [/*start*/ 0x1FCD, 0 /* Other */],
            [/*start*/ 0x1FD0, 11 /* ALetter */],
            [/*start*/ 0x1FD4, 0 /* Other */],
            [/*start*/ 0x1FD6, 11 /* ALetter */],
            [/*start*/ 0x1FDC, 0 /* Other */],
            [/*start*/ 0x1FE0, 11 /* ALetter */],
            [/*start*/ 0x1FED, 0 /* Other */],
            [/*start*/ 0x1FF2, 11 /* ALetter */],
            [/*start*/ 0x1FF5, 0 /* Other */],
            [/*start*/ 0x1FF6, 11 /* ALetter */],
            [/*start*/ 0x1FFD, 0 /* Other */],
            [/*start*/ 0x2000, 4 /* WSegSpace */],
            [/*start*/ 0x2007, 0 /* Other */],
            [/*start*/ 0x2008, 4 /* WSegSpace */],
            [/*start*/ 0x200B, 0 /* Other */],
            [/*start*/ 0x200C, 14 /* Extend */],
            [/*start*/ 0x200D, 16 /* ZWJ */],
            [/*start*/ 0x200E, 13 /* Format */],
            [/*start*/ 0x2010, 0 /* Other */],
            [/*start*/ 0x2018, 8 /* MidNumLet */],
            [/*start*/ 0x201A, 0 /* Other */],
            [/*start*/ 0x2024, 8 /* MidNumLet */],
            [/*start*/ 0x2025, 0 /* Other */],
            [/*start*/ 0x2027, 10 /* MidLetter */],
            [/*start*/ 0x2028, 2 /* Newline */],
            [/*start*/ 0x202A, 13 /* Format */],
            [/*start*/ 0x202F, 12 /* ExtendNumLet */],
            [/*start*/ 0x2030, 0 /* Other */],
            [/*start*/ 0x203F, 12 /* ExtendNumLet */],
            [/*start*/ 0x2041, 0 /* Other */],
            [/*start*/ 0x2044, 7 /* MidNum */],
            [/*start*/ 0x2045, 0 /* Other */],
            [/*start*/ 0x2054, 12 /* ExtendNumLet */],
            [/*start*/ 0x2055, 0 /* Other */],
            [/*start*/ 0x205F, 4 /* WSegSpace */],
            [/*start*/ 0x2060, 13 /* Format */],
            [/*start*/ 0x2065, 0 /* Other */],
            [/*start*/ 0x2066, 13 /* Format */],
            [/*start*/ 0x2070, 0 /* Other */],
            [/*start*/ 0x2071, 11 /* ALetter */],
            [/*start*/ 0x2072, 0 /* Other */],
            [/*start*/ 0x207F, 11 /* ALetter */],
            [/*start*/ 0x2080, 0 /* Other */],
            [/*start*/ 0x2090, 11 /* ALetter */],
            [/*start*/ 0x209D, 0 /* Other */],
            [/*start*/ 0x20D0, 14 /* Extend */],
            [/*start*/ 0x20F1, 0 /* Other */],
            [/*start*/ 0x2102, 11 /* ALetter */],
            [/*start*/ 0x2103, 0 /* Other */],
            [/*start*/ 0x2107, 11 /* ALetter */],
            [/*start*/ 0x2108, 0 /* Other */],
            [/*start*/ 0x210A, 11 /* ALetter */],
            [/*start*/ 0x2114, 0 /* Other */],
            [/*start*/ 0x2115, 11 /* ALetter */],
            [/*start*/ 0x2116, 0 /* Other */],
            [/*start*/ 0x2119, 11 /* ALetter */],
            [/*start*/ 0x211E, 0 /* Other */],
            [/*start*/ 0x2124, 11 /* ALetter */],
            [/*start*/ 0x2125, 0 /* Other */],
            [/*start*/ 0x2126, 11 /* ALetter */],
            [/*start*/ 0x2127, 0 /* Other */],
            [/*start*/ 0x2128, 11 /* ALetter */],
            [/*start*/ 0x2129, 0 /* Other */],
            [/*start*/ 0x212A, 11 /* ALetter */],
            [/*start*/ 0x212E, 0 /* Other */],
            [/*start*/ 0x212F, 11 /* ALetter */],
            [/*start*/ 0x213A, 0 /* Other */],
            [/*start*/ 0x213C, 11 /* ALetter */],
            [/*start*/ 0x2140, 0 /* Other */],
            [/*start*/ 0x2145, 11 /* ALetter */],
            [/*start*/ 0x214A, 0 /* Other */],
            [/*start*/ 0x214E, 11 /* ALetter */],
            [/*start*/ 0x214F, 0 /* Other */],
            [/*start*/ 0x2160, 11 /* ALetter */],
            [/*start*/ 0x2189, 0 /* Other */],
            [/*start*/ 0x24B6, 11 /* ALetter */],
            [/*start*/ 0x24EA, 0 /* Other */],
            [/*start*/ 0x2C00, 11 /* ALetter */],
            [/*start*/ 0x2C2F, 0 /* Other */],
            [/*start*/ 0x2C30, 11 /* ALetter */],
            [/*start*/ 0x2C5F, 0 /* Other */],
            [/*start*/ 0x2C60, 11 /* ALetter */],
            [/*start*/ 0x2CE5, 0 /* Other */],
            [/*start*/ 0x2CEB, 11 /* ALetter */],
            [/*start*/ 0x2CEF, 14 /* Extend */],
            [/*start*/ 0x2CF2, 11 /* ALetter */],
            [/*start*/ 0x2CF4, 0 /* Other */],
            [/*start*/ 0x2D00, 11 /* ALetter */],
            [/*start*/ 0x2D26, 0 /* Other */],
            [/*start*/ 0x2D27, 11 /* ALetter */],
            [/*start*/ 0x2D28, 0 /* Other */],
            [/*start*/ 0x2D2D, 11 /* ALetter */],
            [/*start*/ 0x2D2E, 0 /* Other */],
            [/*start*/ 0x2D30, 11 /* ALetter */],
            [/*start*/ 0x2D68, 0 /* Other */],
            [/*start*/ 0x2D6F, 11 /* ALetter */],
            [/*start*/ 0x2D70, 0 /* Other */],
            [/*start*/ 0x2D7F, 14 /* Extend */],
            [/*start*/ 0x2D80, 11 /* ALetter */],
            [/*start*/ 0x2D97, 0 /* Other */],
            [/*start*/ 0x2DA0, 11 /* ALetter */],
            [/*start*/ 0x2DA7, 0 /* Other */],
            [/*start*/ 0x2DA8, 11 /* ALetter */],
            [/*start*/ 0x2DAF, 0 /* Other */],
            [/*start*/ 0x2DB0, 11 /* ALetter */],
            [/*start*/ 0x2DB7, 0 /* Other */],
            [/*start*/ 0x2DB8, 11 /* ALetter */],
            [/*start*/ 0x2DBF, 0 /* Other */],
            [/*start*/ 0x2DC0, 11 /* ALetter */],
            [/*start*/ 0x2DC7, 0 /* Other */],
            [/*start*/ 0x2DC8, 11 /* ALetter */],
            [/*start*/ 0x2DCF, 0 /* Other */],
            [/*start*/ 0x2DD0, 11 /* ALetter */],
            [/*start*/ 0x2DD7, 0 /* Other */],
            [/*start*/ 0x2DD8, 11 /* ALetter */],
            [/*start*/ 0x2DDF, 0 /* Other */],
            [/*start*/ 0x2DE0, 14 /* Extend */],
            [/*start*/ 0x2E00, 0 /* Other */],
            [/*start*/ 0x2E2F, 11 /* ALetter */],
            [/*start*/ 0x2E30, 0 /* Other */],
            [/*start*/ 0x3000, 4 /* WSegSpace */],
            [/*start*/ 0x3001, 0 /* Other */],
            [/*start*/ 0x3005, 11 /* ALetter */],
            [/*start*/ 0x3006, 0 /* Other */],
            [/*start*/ 0x302A, 14 /* Extend */],
            [/*start*/ 0x3030, 0 /* Other */],
            [/*start*/ 0x3031, 17 /* Katakana */],
            [/*start*/ 0x3036, 0 /* Other */],
            [/*start*/ 0x303B, 11 /* ALetter */],
            [/*start*/ 0x303D, 0 /* Other */],
            [/*start*/ 0x3099, 14 /* Extend */],
            [/*start*/ 0x309B, 17 /* Katakana */],
            [/*start*/ 0x309D, 0 /* Other */],
            [/*start*/ 0x30A0, 17 /* Katakana */],
            [/*start*/ 0x30FB, 0 /* Other */],
            [/*start*/ 0x30FC, 17 /* Katakana */],
            [/*start*/ 0x3100, 0 /* Other */],
            [/*start*/ 0x3105, 11 /* ALetter */],
            [/*start*/ 0x3130, 0 /* Other */],
            [/*start*/ 0x3131, 11 /* ALetter */],
            [/*start*/ 0x318F, 0 /* Other */],
            [/*start*/ 0x31A0, 11 /* ALetter */],
            [/*start*/ 0x31C0, 0 /* Other */],
            [/*start*/ 0x31F0, 17 /* Katakana */],
            [/*start*/ 0x3200, 0 /* Other */],
            [/*start*/ 0x32D0, 17 /* Katakana */],
            [/*start*/ 0x32FF, 0 /* Other */],
            [/*start*/ 0x3300, 17 /* Katakana */],
            [/*start*/ 0x3358, 0 /* Other */],
            [/*start*/ 0xA000, 11 /* ALetter */],
            [/*start*/ 0xA48D, 0 /* Other */],
            [/*start*/ 0xA4D0, 11 /* ALetter */],
            [/*start*/ 0xA4FE, 0 /* Other */],
            [/*start*/ 0xA500, 11 /* ALetter */],
            [/*start*/ 0xA60D, 0 /* Other */],
            [/*start*/ 0xA610, 11 /* ALetter */],
            [/*start*/ 0xA620, 9 /* Numeric */],
            [/*start*/ 0xA62A, 11 /* ALetter */],
            [/*start*/ 0xA62C, 0 /* Other */],
            [/*start*/ 0xA640, 11 /* ALetter */],
            [/*start*/ 0xA66F, 14 /* Extend */],
            [/*start*/ 0xA673, 0 /* Other */],
            [/*start*/ 0xA674, 14 /* Extend */],
            [/*start*/ 0xA67E, 0 /* Other */],
            [/*start*/ 0xA67F, 11 /* ALetter */],
            [/*start*/ 0xA69E, 14 /* Extend */],
            [/*start*/ 0xA6A0, 11 /* ALetter */],
            [/*start*/ 0xA6F0, 14 /* Extend */],
            [/*start*/ 0xA6F2, 0 /* Other */],
            [/*start*/ 0xA708, 11 /* ALetter */],
            [/*start*/ 0xA7C0, 0 /* Other */],
            [/*start*/ 0xA7C2, 11 /* ALetter */],
            [/*start*/ 0xA7CB, 0 /* Other */],
            [/*start*/ 0xA7F5, 11 /* ALetter */],
            [/*start*/ 0xA802, 14 /* Extend */],
            [/*start*/ 0xA803, 11 /* ALetter */],
            [/*start*/ 0xA806, 14 /* Extend */],
            [/*start*/ 0xA807, 11 /* ALetter */],
            [/*start*/ 0xA80B, 14 /* Extend */],
            [/*start*/ 0xA80C, 11 /* ALetter */],
            [/*start*/ 0xA823, 14 /* Extend */],
            [/*start*/ 0xA828, 0 /* Other */],
            [/*start*/ 0xA82C, 14 /* Extend */],
            [/*start*/ 0xA82D, 0 /* Other */],
            [/*start*/ 0xA840, 11 /* ALetter */],
            [/*start*/ 0xA874, 0 /* Other */],
            [/*start*/ 0xA880, 14 /* Extend */],
            [/*start*/ 0xA882, 11 /* ALetter */],
            [/*start*/ 0xA8B4, 14 /* Extend */],
            [/*start*/ 0xA8C6, 0 /* Other */],
            [/*start*/ 0xA8D0, 9 /* Numeric */],
            [/*start*/ 0xA8DA, 0 /* Other */],
            [/*start*/ 0xA8E0, 14 /* Extend */],
            [/*start*/ 0xA8F2, 11 /* ALetter */],
            [/*start*/ 0xA8F8, 0 /* Other */],
            [/*start*/ 0xA8FB, 11 /* ALetter */],
            [/*start*/ 0xA8FC, 0 /* Other */],
            [/*start*/ 0xA8FD, 11 /* ALetter */],
            [/*start*/ 0xA8FF, 14 /* Extend */],
            [/*start*/ 0xA900, 9 /* Numeric */],
            [/*start*/ 0xA90A, 11 /* ALetter */],
            [/*start*/ 0xA926, 14 /* Extend */],
            [/*start*/ 0xA92E, 0 /* Other */],
            [/*start*/ 0xA930, 11 /* ALetter */],
            [/*start*/ 0xA947, 14 /* Extend */],
            [/*start*/ 0xA954, 0 /* Other */],
            [/*start*/ 0xA960, 11 /* ALetter */],
            [/*start*/ 0xA97D, 0 /* Other */],
            [/*start*/ 0xA980, 14 /* Extend */],
            [/*start*/ 0xA984, 11 /* ALetter */],
            [/*start*/ 0xA9B3, 14 /* Extend */],
            [/*start*/ 0xA9C1, 0 /* Other */],
            [/*start*/ 0xA9CF, 11 /* ALetter */],
            [/*start*/ 0xA9D0, 9 /* Numeric */],
            [/*start*/ 0xA9DA, 0 /* Other */],
            [/*start*/ 0xA9E5, 14 /* Extend */],
            [/*start*/ 0xA9E6, 0 /* Other */],
            [/*start*/ 0xA9F0, 9 /* Numeric */],
            [/*start*/ 0xA9FA, 0 /* Other */],
            [/*start*/ 0xAA00, 11 /* ALetter */],
            [/*start*/ 0xAA29, 14 /* Extend */],
            [/*start*/ 0xAA37, 0 /* Other */],
            [/*start*/ 0xAA40, 11 /* ALetter */],
            [/*start*/ 0xAA43, 14 /* Extend */],
            [/*start*/ 0xAA44, 11 /* ALetter */],
            [/*start*/ 0xAA4C, 14 /* Extend */],
            [/*start*/ 0xAA4E, 0 /* Other */],
            [/*start*/ 0xAA50, 9 /* Numeric */],
            [/*start*/ 0xAA5A, 0 /* Other */],
            [/*start*/ 0xAA7B, 14 /* Extend */],
            [/*start*/ 0xAA7E, 0 /* Other */],
            [/*start*/ 0xAAB0, 14 /* Extend */],
            [/*start*/ 0xAAB1, 0 /* Other */],
            [/*start*/ 0xAAB2, 14 /* Extend */],
            [/*start*/ 0xAAB5, 0 /* Other */],
            [/*start*/ 0xAAB7, 14 /* Extend */],
            [/*start*/ 0xAAB9, 0 /* Other */],
            [/*start*/ 0xAABE, 14 /* Extend */],
            [/*start*/ 0xAAC0, 0 /* Other */],
            [/*start*/ 0xAAC1, 14 /* Extend */],
            [/*start*/ 0xAAC2, 0 /* Other */],
            [/*start*/ 0xAAE0, 11 /* ALetter */],
            [/*start*/ 0xAAEB, 14 /* Extend */],
            [/*start*/ 0xAAF0, 0 /* Other */],
            [/*start*/ 0xAAF2, 11 /* ALetter */],
            [/*start*/ 0xAAF5, 14 /* Extend */],
            [/*start*/ 0xAAF7, 0 /* Other */],
            [/*start*/ 0xAB01, 11 /* ALetter */],
            [/*start*/ 0xAB07, 0 /* Other */],
            [/*start*/ 0xAB09, 11 /* ALetter */],
            [/*start*/ 0xAB0F, 0 /* Other */],
            [/*start*/ 0xAB11, 11 /* ALetter */],
            [/*start*/ 0xAB17, 0 /* Other */],
            [/*start*/ 0xAB20, 11 /* ALetter */],
            [/*start*/ 0xAB27, 0 /* Other */],
            [/*start*/ 0xAB28, 11 /* ALetter */],
            [/*start*/ 0xAB2F, 0 /* Other */],
            [/*start*/ 0xAB30, 11 /* ALetter */],
            [/*start*/ 0xAB6A, 0 /* Other */],
            [/*start*/ 0xAB70, 11 /* ALetter */],
            [/*start*/ 0xABE3, 14 /* Extend */],
            [/*start*/ 0xABEB, 0 /* Other */],
            [/*start*/ 0xABEC, 14 /* Extend */],
            [/*start*/ 0xABEE, 0 /* Other */],
            [/*start*/ 0xABF0, 9 /* Numeric */],
            [/*start*/ 0xABFA, 0 /* Other */],
            [/*start*/ 0xAC00, 11 /* ALetter */],
            [/*start*/ 0xD7A4, 0 /* Other */],
            [/*start*/ 0xD7B0, 11 /* ALetter */],
            [/*start*/ 0xD7C7, 0 /* Other */],
            [/*start*/ 0xD7CB, 11 /* ALetter */],
            [/*start*/ 0xD7FC, 0 /* Other */],
            [/*start*/ 0xFB00, 11 /* ALetter */],
            [/*start*/ 0xFB07, 0 /* Other */],
            [/*start*/ 0xFB13, 11 /* ALetter */],
            [/*start*/ 0xFB18, 0 /* Other */],
            [/*start*/ 0xFB1D, 15 /* Hebrew_Letter */],
            [/*start*/ 0xFB1E, 14 /* Extend */],
            [/*start*/ 0xFB1F, 15 /* Hebrew_Letter */],
            [/*start*/ 0xFB29, 0 /* Other */],
            [/*start*/ 0xFB2A, 15 /* Hebrew_Letter */],
            [/*start*/ 0xFB37, 0 /* Other */],
            [/*start*/ 0xFB38, 15 /* Hebrew_Letter */],
            [/*start*/ 0xFB3D, 0 /* Other */],
            [/*start*/ 0xFB3E, 15 /* Hebrew_Letter */],
            [/*start*/ 0xFB3F, 0 /* Other */],
            [/*start*/ 0xFB40, 15 /* Hebrew_Letter */],
            [/*start*/ 0xFB42, 0 /* Other */],
            [/*start*/ 0xFB43, 15 /* Hebrew_Letter */],
            [/*start*/ 0xFB45, 0 /* Other */],
            [/*start*/ 0xFB46, 15 /* Hebrew_Letter */],
            [/*start*/ 0xFB50, 11 /* ALetter */],
            [/*start*/ 0xFBB2, 0 /* Other */],
            [/*start*/ 0xFBD3, 11 /* ALetter */],
            [/*start*/ 0xFD3E, 0 /* Other */],
            [/*start*/ 0xFD50, 11 /* ALetter */],
            [/*start*/ 0xFD90, 0 /* Other */],
            [/*start*/ 0xFD92, 11 /* ALetter */],
            [/*start*/ 0xFDC8, 0 /* Other */],
            [/*start*/ 0xFDF0, 11 /* ALetter */],
            [/*start*/ 0xFDFC, 0 /* Other */],
            [/*start*/ 0xFE00, 14 /* Extend */],
            [/*start*/ 0xFE10, 7 /* MidNum */],
            [/*start*/ 0xFE11, 0 /* Other */],
            [/*start*/ 0xFE13, 10 /* MidLetter */],
            [/*start*/ 0xFE14, 7 /* MidNum */],
            [/*start*/ 0xFE15, 0 /* Other */],
            [/*start*/ 0xFE20, 14 /* Extend */],
            [/*start*/ 0xFE30, 0 /* Other */],
            [/*start*/ 0xFE33, 12 /* ExtendNumLet */],
            [/*start*/ 0xFE35, 0 /* Other */],
            [/*start*/ 0xFE4D, 12 /* ExtendNumLet */],
            [/*start*/ 0xFE50, 7 /* MidNum */],
            [/*start*/ 0xFE51, 0 /* Other */],
            [/*start*/ 0xFE52, 8 /* MidNumLet */],
            [/*start*/ 0xFE53, 0 /* Other */],
            [/*start*/ 0xFE54, 7 /* MidNum */],
            [/*start*/ 0xFE55, 10 /* MidLetter */],
            [/*start*/ 0xFE56, 0 /* Other */],
            [/*start*/ 0xFE70, 11 /* ALetter */],
            [/*start*/ 0xFE75, 0 /* Other */],
            [/*start*/ 0xFE76, 11 /* ALetter */],
            [/*start*/ 0xFEFD, 0 /* Other */],
            [/*start*/ 0xFEFF, 13 /* Format */],
            [/*start*/ 0xFF00, 0 /* Other */],
            [/*start*/ 0xFF07, 8 /* MidNumLet */],
            [/*start*/ 0xFF08, 0 /* Other */],
            [/*start*/ 0xFF0C, 7 /* MidNum */],
            [/*start*/ 0xFF0D, 0 /* Other */],
            [/*start*/ 0xFF0E, 8 /* MidNumLet */],
            [/*start*/ 0xFF0F, 0 /* Other */],
            [/*start*/ 0xFF10, 9 /* Numeric */],
            [/*start*/ 0xFF1A, 10 /* MidLetter */],
            [/*start*/ 0xFF1B, 7 /* MidNum */],
            [/*start*/ 0xFF1C, 0 /* Other */],
            [/*start*/ 0xFF21, 11 /* ALetter */],
            [/*start*/ 0xFF3B, 0 /* Other */],
            [/*start*/ 0xFF3F, 12 /* ExtendNumLet */],
            [/*start*/ 0xFF40, 0 /* Other */],
            [/*start*/ 0xFF41, 11 /* ALetter */],
            [/*start*/ 0xFF5B, 0 /* Other */],
            [/*start*/ 0xFF66, 17 /* Katakana */],
            [/*start*/ 0xFF9E, 14 /* Extend */],
            [/*start*/ 0xFFA0, 11 /* ALetter */],
            [/*start*/ 0xFFBF, 0 /* Other */],
            [/*start*/ 0xFFC2, 11 /* ALetter */],
            [/*start*/ 0xFFC8, 0 /* Other */],
            [/*start*/ 0xFFCA, 11 /* ALetter */],
            [/*start*/ 0xFFD0, 0 /* Other */],
            [/*start*/ 0xFFD2, 11 /* ALetter */],
            [/*start*/ 0xFFD8, 0 /* Other */],
            [/*start*/ 0xFFDA, 11 /* ALetter */],
            [/*start*/ 0xFFDD, 0 /* Other */],
            [/*start*/ 0xFFF9, 13 /* Format */],
            [/*start*/ 0xFFFC, 0 /* Other */],
            [/*start*/ 0x10000, 11 /* ALetter */],
            [/*start*/ 0x1000C, 0 /* Other */],
            [/*start*/ 0x1000D, 11 /* ALetter */],
            [/*start*/ 0x10027, 0 /* Other */],
            [/*start*/ 0x10028, 11 /* ALetter */],
            [/*start*/ 0x1003B, 0 /* Other */],
            [/*start*/ 0x1003C, 11 /* ALetter */],
            [/*start*/ 0x1003E, 0 /* Other */],
            [/*start*/ 0x1003F, 11 /* ALetter */],
            [/*start*/ 0x1004E, 0 /* Other */],
            [/*start*/ 0x10050, 11 /* ALetter */],
            [/*start*/ 0x1005E, 0 /* Other */],
            [/*start*/ 0x10080, 11 /* ALetter */],
            [/*start*/ 0x100FB, 0 /* Other */],
            [/*start*/ 0x10140, 11 /* ALetter */],
            [/*start*/ 0x10175, 0 /* Other */],
            [/*start*/ 0x101FD, 14 /* Extend */],
            [/*start*/ 0x101FE, 0 /* Other */],
            [/*start*/ 0x10280, 11 /* ALetter */],
            [/*start*/ 0x1029D, 0 /* Other */],
            [/*start*/ 0x102A0, 11 /* ALetter */],
            [/*start*/ 0x102D1, 0 /* Other */],
            [/*start*/ 0x102E0, 14 /* Extend */],
            [/*start*/ 0x102E1, 0 /* Other */],
            [/*start*/ 0x10300, 11 /* ALetter */],
            [/*start*/ 0x10320, 0 /* Other */],
            [/*start*/ 0x1032D, 11 /* ALetter */],
            [/*start*/ 0x1034B, 0 /* Other */],
            [/*start*/ 0x10350, 11 /* ALetter */],
            [/*start*/ 0x10376, 14 /* Extend */],
            [/*start*/ 0x1037B, 0 /* Other */],
            [/*start*/ 0x10380, 11 /* ALetter */],
            [/*start*/ 0x1039E, 0 /* Other */],
            [/*start*/ 0x103A0, 11 /* ALetter */],
            [/*start*/ 0x103C4, 0 /* Other */],
            [/*start*/ 0x103C8, 11 /* ALetter */],
            [/*start*/ 0x103D0, 0 /* Other */],
            [/*start*/ 0x103D1, 11 /* ALetter */],
            [/*start*/ 0x103D6, 0 /* Other */],
            [/*start*/ 0x10400, 11 /* ALetter */],
            [/*start*/ 0x1049E, 0 /* Other */],
            [/*start*/ 0x104A0, 9 /* Numeric */],
            [/*start*/ 0x104AA, 0 /* Other */],
            [/*start*/ 0x104B0, 11 /* ALetter */],
            [/*start*/ 0x104D4, 0 /* Other */],
            [/*start*/ 0x104D8, 11 /* ALetter */],
            [/*start*/ 0x104FC, 0 /* Other */],
            [/*start*/ 0x10500, 11 /* ALetter */],
            [/*start*/ 0x10528, 0 /* Other */],
            [/*start*/ 0x10530, 11 /* ALetter */],
            [/*start*/ 0x10564, 0 /* Other */],
            [/*start*/ 0x10600, 11 /* ALetter */],
            [/*start*/ 0x10737, 0 /* Other */],
            [/*start*/ 0x10740, 11 /* ALetter */],
            [/*start*/ 0x10756, 0 /* Other */],
            [/*start*/ 0x10760, 11 /* ALetter */],
            [/*start*/ 0x10768, 0 /* Other */],
            [/*start*/ 0x10800, 11 /* ALetter */],
            [/*start*/ 0x10806, 0 /* Other */],
            [/*start*/ 0x10808, 11 /* ALetter */],
            [/*start*/ 0x10809, 0 /* Other */],
            [/*start*/ 0x1080A, 11 /* ALetter */],
            [/*start*/ 0x10836, 0 /* Other */],
            [/*start*/ 0x10837, 11 /* ALetter */],
            [/*start*/ 0x10839, 0 /* Other */],
            [/*start*/ 0x1083C, 11 /* ALetter */],
            [/*start*/ 0x1083D, 0 /* Other */],
            [/*start*/ 0x1083F, 11 /* ALetter */],
            [/*start*/ 0x10856, 0 /* Other */],
            [/*start*/ 0x10860, 11 /* ALetter */],
            [/*start*/ 0x10877, 0 /* Other */],
            [/*start*/ 0x10880, 11 /* ALetter */],
            [/*start*/ 0x1089F, 0 /* Other */],
            [/*start*/ 0x108E0, 11 /* ALetter */],
            [/*start*/ 0x108F3, 0 /* Other */],
            [/*start*/ 0x108F4, 11 /* ALetter */],
            [/*start*/ 0x108F6, 0 /* Other */],
            [/*start*/ 0x10900, 11 /* ALetter */],
            [/*start*/ 0x10916, 0 /* Other */],
            [/*start*/ 0x10920, 11 /* ALetter */],
            [/*start*/ 0x1093A, 0 /* Other */],
            [/*start*/ 0x10980, 11 /* ALetter */],
            [/*start*/ 0x109B8, 0 /* Other */],
            [/*start*/ 0x109BE, 11 /* ALetter */],
            [/*start*/ 0x109C0, 0 /* Other */],
            [/*start*/ 0x10A00, 11 /* ALetter */],
            [/*start*/ 0x10A01, 14 /* Extend */],
            [/*start*/ 0x10A04, 0 /* Other */],
            [/*start*/ 0x10A05, 14 /* Extend */],
            [/*start*/ 0x10A07, 0 /* Other */],
            [/*start*/ 0x10A0C, 14 /* Extend */],
            [/*start*/ 0x10A10, 11 /* ALetter */],
            [/*start*/ 0x10A14, 0 /* Other */],
            [/*start*/ 0x10A15, 11 /* ALetter */],
            [/*start*/ 0x10A18, 0 /* Other */],
            [/*start*/ 0x10A19, 11 /* ALetter */],
            [/*start*/ 0x10A36, 0 /* Other */],
            [/*start*/ 0x10A38, 14 /* Extend */],
            [/*start*/ 0x10A3B, 0 /* Other */],
            [/*start*/ 0x10A3F, 14 /* Extend */],
            [/*start*/ 0x10A40, 0 /* Other */],
            [/*start*/ 0x10A60, 11 /* ALetter */],
            [/*start*/ 0x10A7D, 0 /* Other */],
            [/*start*/ 0x10A80, 11 /* ALetter */],
            [/*start*/ 0x10A9D, 0 /* Other */],
            [/*start*/ 0x10AC0, 11 /* ALetter */],
            [/*start*/ 0x10AC8, 0 /* Other */],
            [/*start*/ 0x10AC9, 11 /* ALetter */],
            [/*start*/ 0x10AE5, 14 /* Extend */],
            [/*start*/ 0x10AE7, 0 /* Other */],
            [/*start*/ 0x10B00, 11 /* ALetter */],
            [/*start*/ 0x10B36, 0 /* Other */],
            [/*start*/ 0x10B40, 11 /* ALetter */],
            [/*start*/ 0x10B56, 0 /* Other */],
            [/*start*/ 0x10B60, 11 /* ALetter */],
            [/*start*/ 0x10B73, 0 /* Other */],
            [/*start*/ 0x10B80, 11 /* ALetter */],
            [/*start*/ 0x10B92, 0 /* Other */],
            [/*start*/ 0x10C00, 11 /* ALetter */],
            [/*start*/ 0x10C49, 0 /* Other */],
            [/*start*/ 0x10C80, 11 /* ALetter */],
            [/*start*/ 0x10CB3, 0 /* Other */],
            [/*start*/ 0x10CC0, 11 /* ALetter */],
            [/*start*/ 0x10CF3, 0 /* Other */],
            [/*start*/ 0x10D00, 11 /* ALetter */],
            [/*start*/ 0x10D24, 14 /* Extend */],
            [/*start*/ 0x10D28, 0 /* Other */],
            [/*start*/ 0x10D30, 9 /* Numeric */],
            [/*start*/ 0x10D3A, 0 /* Other */],
            [/*start*/ 0x10E80, 11 /* ALetter */],
            [/*start*/ 0x10EAA, 0 /* Other */],
            [/*start*/ 0x10EAB, 14 /* Extend */],
            [/*start*/ 0x10EAD, 0 /* Other */],
            [/*start*/ 0x10EB0, 11 /* ALetter */],
            [/*start*/ 0x10EB2, 0 /* Other */],
            [/*start*/ 0x10F00, 11 /* ALetter */],
            [/*start*/ 0x10F1D, 0 /* Other */],
            [/*start*/ 0x10F27, 11 /* ALetter */],
            [/*start*/ 0x10F28, 0 /* Other */],
            [/*start*/ 0x10F30, 11 /* ALetter */],
            [/*start*/ 0x10F46, 14 /* Extend */],
            [/*start*/ 0x10F51, 0 /* Other */],
            [/*start*/ 0x10FB0, 11 /* ALetter */],
            [/*start*/ 0x10FC5, 0 /* Other */],
            [/*start*/ 0x10FE0, 11 /* ALetter */],
            [/*start*/ 0x10FF7, 0 /* Other */],
            [/*start*/ 0x11000, 14 /* Extend */],
            [/*start*/ 0x11003, 11 /* ALetter */],
            [/*start*/ 0x11038, 14 /* Extend */],
            [/*start*/ 0x11047, 0 /* Other */],
            [/*start*/ 0x11066, 9 /* Numeric */],
            [/*start*/ 0x11070, 0 /* Other */],
            [/*start*/ 0x1107F, 14 /* Extend */],
            [/*start*/ 0x11083, 11 /* ALetter */],
            [/*start*/ 0x110B0, 14 /* Extend */],
            [/*start*/ 0x110BB, 0 /* Other */],
            [/*start*/ 0x110BD, 13 /* Format */],
            [/*start*/ 0x110BE, 0 /* Other */],
            [/*start*/ 0x110CD, 13 /* Format */],
            [/*start*/ 0x110CE, 0 /* Other */],
            [/*start*/ 0x110D0, 11 /* ALetter */],
            [/*start*/ 0x110E9, 0 /* Other */],
            [/*start*/ 0x110F0, 9 /* Numeric */],
            [/*start*/ 0x110FA, 0 /* Other */],
            [/*start*/ 0x11100, 14 /* Extend */],
            [/*start*/ 0x11103, 11 /* ALetter */],
            [/*start*/ 0x11127, 14 /* Extend */],
            [/*start*/ 0x11135, 0 /* Other */],
            [/*start*/ 0x11136, 9 /* Numeric */],
            [/*start*/ 0x11140, 0 /* Other */],
            [/*start*/ 0x11144, 11 /* ALetter */],
            [/*start*/ 0x11145, 14 /* Extend */],
            [/*start*/ 0x11147, 11 /* ALetter */],
            [/*start*/ 0x11148, 0 /* Other */],
            [/*start*/ 0x11150, 11 /* ALetter */],
            [/*start*/ 0x11173, 14 /* Extend */],
            [/*start*/ 0x11174, 0 /* Other */],
            [/*start*/ 0x11176, 11 /* ALetter */],
            [/*start*/ 0x11177, 0 /* Other */],
            [/*start*/ 0x11180, 14 /* Extend */],
            [/*start*/ 0x11183, 11 /* ALetter */],
            [/*start*/ 0x111B3, 14 /* Extend */],
            [/*start*/ 0x111C1, 11 /* ALetter */],
            [/*start*/ 0x111C5, 0 /* Other */],
            [/*start*/ 0x111C9, 14 /* Extend */],
            [/*start*/ 0x111CD, 0 /* Other */],
            [/*start*/ 0x111CE, 14 /* Extend */],
            [/*start*/ 0x111D0, 9 /* Numeric */],
            [/*start*/ 0x111DA, 11 /* ALetter */],
            [/*start*/ 0x111DB, 0 /* Other */],
            [/*start*/ 0x111DC, 11 /* ALetter */],
            [/*start*/ 0x111DD, 0 /* Other */],
            [/*start*/ 0x11200, 11 /* ALetter */],
            [/*start*/ 0x11212, 0 /* Other */],
            [/*start*/ 0x11213, 11 /* ALetter */],
            [/*start*/ 0x1122C, 14 /* Extend */],
            [/*start*/ 0x11238, 0 /* Other */],
            [/*start*/ 0x1123E, 14 /* Extend */],
            [/*start*/ 0x1123F, 0 /* Other */],
            [/*start*/ 0x11280, 11 /* ALetter */],
            [/*start*/ 0x11287, 0 /* Other */],
            [/*start*/ 0x11288, 11 /* ALetter */],
            [/*start*/ 0x11289, 0 /* Other */],
            [/*start*/ 0x1128A, 11 /* ALetter */],
            [/*start*/ 0x1128E, 0 /* Other */],
            [/*start*/ 0x1128F, 11 /* ALetter */],
            [/*start*/ 0x1129E, 0 /* Other */],
            [/*start*/ 0x1129F, 11 /* ALetter */],
            [/*start*/ 0x112A9, 0 /* Other */],
            [/*start*/ 0x112B0, 11 /* ALetter */],
            [/*start*/ 0x112DF, 14 /* Extend */],
            [/*start*/ 0x112EB, 0 /* Other */],
            [/*start*/ 0x112F0, 9 /* Numeric */],
            [/*start*/ 0x112FA, 0 /* Other */],
            [/*start*/ 0x11300, 14 /* Extend */],
            [/*start*/ 0x11304, 0 /* Other */],
            [/*start*/ 0x11305, 11 /* ALetter */],
            [/*start*/ 0x1130D, 0 /* Other */],
            [/*start*/ 0x1130F, 11 /* ALetter */],
            [/*start*/ 0x11311, 0 /* Other */],
            [/*start*/ 0x11313, 11 /* ALetter */],
            [/*start*/ 0x11329, 0 /* Other */],
            [/*start*/ 0x1132A, 11 /* ALetter */],
            [/*start*/ 0x11331, 0 /* Other */],
            [/*start*/ 0x11332, 11 /* ALetter */],
            [/*start*/ 0x11334, 0 /* Other */],
            [/*start*/ 0x11335, 11 /* ALetter */],
            [/*start*/ 0x1133A, 0 /* Other */],
            [/*start*/ 0x1133B, 14 /* Extend */],
            [/*start*/ 0x1133D, 11 /* ALetter */],
            [/*start*/ 0x1133E, 14 /* Extend */],
            [/*start*/ 0x11345, 0 /* Other */],
            [/*start*/ 0x11347, 14 /* Extend */],
            [/*start*/ 0x11349, 0 /* Other */],
            [/*start*/ 0x1134B, 14 /* Extend */],
            [/*start*/ 0x1134E, 0 /* Other */],
            [/*start*/ 0x11350, 11 /* ALetter */],
            [/*start*/ 0x11351, 0 /* Other */],
            [/*start*/ 0x11357, 14 /* Extend */],
            [/*start*/ 0x11358, 0 /* Other */],
            [/*start*/ 0x1135D, 11 /* ALetter */],
            [/*start*/ 0x11362, 14 /* Extend */],
            [/*start*/ 0x11364, 0 /* Other */],
            [/*start*/ 0x11366, 14 /* Extend */],
            [/*start*/ 0x1136D, 0 /* Other */],
            [/*start*/ 0x11370, 14 /* Extend */],
            [/*start*/ 0x11375, 0 /* Other */],
            [/*start*/ 0x11400, 11 /* ALetter */],
            [/*start*/ 0x11435, 14 /* Extend */],
            [/*start*/ 0x11447, 11 /* ALetter */],
            [/*start*/ 0x1144B, 0 /* Other */],
            [/*start*/ 0x11450, 9 /* Numeric */],
            [/*start*/ 0x1145A, 0 /* Other */],
            [/*start*/ 0x1145E, 14 /* Extend */],
            [/*start*/ 0x1145F, 11 /* ALetter */],
            [/*start*/ 0x11462, 0 /* Other */],
            [/*start*/ 0x11480, 11 /* ALetter */],
            [/*start*/ 0x114B0, 14 /* Extend */],
            [/*start*/ 0x114C4, 11 /* ALetter */],
            [/*start*/ 0x114C6, 0 /* Other */],
            [/*start*/ 0x114C7, 11 /* ALetter */],
            [/*start*/ 0x114C8, 0 /* Other */],
            [/*start*/ 0x114D0, 9 /* Numeric */],
            [/*start*/ 0x114DA, 0 /* Other */],
            [/*start*/ 0x11580, 11 /* ALetter */],
            [/*start*/ 0x115AF, 14 /* Extend */],
            [/*start*/ 0x115B6, 0 /* Other */],
            [/*start*/ 0x115B8, 14 /* Extend */],
            [/*start*/ 0x115C1, 0 /* Other */],
            [/*start*/ 0x115D8, 11 /* ALetter */],
            [/*start*/ 0x115DC, 14 /* Extend */],
            [/*start*/ 0x115DE, 0 /* Other */],
            [/*start*/ 0x11600, 11 /* ALetter */],
            [/*start*/ 0x11630, 14 /* Extend */],
            [/*start*/ 0x11641, 0 /* Other */],
            [/*start*/ 0x11644, 11 /* ALetter */],
            [/*start*/ 0x11645, 0 /* Other */],
            [/*start*/ 0x11650, 9 /* Numeric */],
            [/*start*/ 0x1165A, 0 /* Other */],
            [/*start*/ 0x11680, 11 /* ALetter */],
            [/*start*/ 0x116AB, 14 /* Extend */],
            [/*start*/ 0x116B8, 11 /* ALetter */],
            [/*start*/ 0x116B9, 0 /* Other */],
            [/*start*/ 0x116C0, 9 /* Numeric */],
            [/*start*/ 0x116CA, 0 /* Other */],
            [/*start*/ 0x1171D, 14 /* Extend */],
            [/*start*/ 0x1172C, 0 /* Other */],
            [/*start*/ 0x11730, 9 /* Numeric */],
            [/*start*/ 0x1173A, 0 /* Other */],
            [/*start*/ 0x11800, 11 /* ALetter */],
            [/*start*/ 0x1182C, 14 /* Extend */],
            [/*start*/ 0x1183B, 0 /* Other */],
            [/*start*/ 0x118A0, 11 /* ALetter */],
            [/*start*/ 0x118E0, 9 /* Numeric */],
            [/*start*/ 0x118EA, 0 /* Other */],
            [/*start*/ 0x118FF, 11 /* ALetter */],
            [/*start*/ 0x11907, 0 /* Other */],
            [/*start*/ 0x11909, 11 /* ALetter */],
            [/*start*/ 0x1190A, 0 /* Other */],
            [/*start*/ 0x1190C, 11 /* ALetter */],
            [/*start*/ 0x11914, 0 /* Other */],
            [/*start*/ 0x11915, 11 /* ALetter */],
            [/*start*/ 0x11917, 0 /* Other */],
            [/*start*/ 0x11918, 11 /* ALetter */],
            [/*start*/ 0x11930, 14 /* Extend */],
            [/*start*/ 0x11936, 0 /* Other */],
            [/*start*/ 0x11937, 14 /* Extend */],
            [/*start*/ 0x11939, 0 /* Other */],
            [/*start*/ 0x1193B, 14 /* Extend */],
            [/*start*/ 0x1193F, 11 /* ALetter */],
            [/*start*/ 0x11940, 14 /* Extend */],
            [/*start*/ 0x11941, 11 /* ALetter */],
            [/*start*/ 0x11942, 14 /* Extend */],
            [/*start*/ 0x11944, 0 /* Other */],
            [/*start*/ 0x11950, 9 /* Numeric */],
            [/*start*/ 0x1195A, 0 /* Other */],
            [/*start*/ 0x119A0, 11 /* ALetter */],
            [/*start*/ 0x119A8, 0 /* Other */],
            [/*start*/ 0x119AA, 11 /* ALetter */],
            [/*start*/ 0x119D1, 14 /* Extend */],
            [/*start*/ 0x119D8, 0 /* Other */],
            [/*start*/ 0x119DA, 14 /* Extend */],
            [/*start*/ 0x119E1, 11 /* ALetter */],
            [/*start*/ 0x119E2, 0 /* Other */],
            [/*start*/ 0x119E3, 11 /* ALetter */],
            [/*start*/ 0x119E4, 14 /* Extend */],
            [/*start*/ 0x119E5, 0 /* Other */],
            [/*start*/ 0x11A00, 11 /* ALetter */],
            [/*start*/ 0x11A01, 14 /* Extend */],
            [/*start*/ 0x11A0B, 11 /* ALetter */],
            [/*start*/ 0x11A33, 14 /* Extend */],
            [/*start*/ 0x11A3A, 11 /* ALetter */],
            [/*start*/ 0x11A3B, 14 /* Extend */],
            [/*start*/ 0x11A3F, 0 /* Other */],
            [/*start*/ 0x11A47, 14 /* Extend */],
            [/*start*/ 0x11A48, 0 /* Other */],
            [/*start*/ 0x11A50, 11 /* ALetter */],
            [/*start*/ 0x11A51, 14 /* Extend */],
            [/*start*/ 0x11A5C, 11 /* ALetter */],
            [/*start*/ 0x11A8A, 14 /* Extend */],
            [/*start*/ 0x11A9A, 0 /* Other */],
            [/*start*/ 0x11A9D, 11 /* ALetter */],
            [/*start*/ 0x11A9E, 0 /* Other */],
            [/*start*/ 0x11AC0, 11 /* ALetter */],
            [/*start*/ 0x11AF9, 0 /* Other */],
            [/*start*/ 0x11C00, 11 /* ALetter */],
            [/*start*/ 0x11C09, 0 /* Other */],
            [/*start*/ 0x11C0A, 11 /* ALetter */],
            [/*start*/ 0x11C2F, 14 /* Extend */],
            [/*start*/ 0x11C37, 0 /* Other */],
            [/*start*/ 0x11C38, 14 /* Extend */],
            [/*start*/ 0x11C40, 11 /* ALetter */],
            [/*start*/ 0x11C41, 0 /* Other */],
            [/*start*/ 0x11C50, 9 /* Numeric */],
            [/*start*/ 0x11C5A, 0 /* Other */],
            [/*start*/ 0x11C72, 11 /* ALetter */],
            [/*start*/ 0x11C90, 0 /* Other */],
            [/*start*/ 0x11C92, 14 /* Extend */],
            [/*start*/ 0x11CA8, 0 /* Other */],
            [/*start*/ 0x11CA9, 14 /* Extend */],
            [/*start*/ 0x11CB7, 0 /* Other */],
            [/*start*/ 0x11D00, 11 /* ALetter */],
            [/*start*/ 0x11D07, 0 /* Other */],
            [/*start*/ 0x11D08, 11 /* ALetter */],
            [/*start*/ 0x11D0A, 0 /* Other */],
            [/*start*/ 0x11D0B, 11 /* ALetter */],
            [/*start*/ 0x11D31, 14 /* Extend */],
            [/*start*/ 0x11D37, 0 /* Other */],
            [/*start*/ 0x11D3A, 14 /* Extend */],
            [/*start*/ 0x11D3B, 0 /* Other */],
            [/*start*/ 0x11D3C, 14 /* Extend */],
            [/*start*/ 0x11D3E, 0 /* Other */],
            [/*start*/ 0x11D3F, 14 /* Extend */],
            [/*start*/ 0x11D46, 11 /* ALetter */],
            [/*start*/ 0x11D47, 14 /* Extend */],
            [/*start*/ 0x11D48, 0 /* Other */],
            [/*start*/ 0x11D50, 9 /* Numeric */],
            [/*start*/ 0x11D5A, 0 /* Other */],
            [/*start*/ 0x11D60, 11 /* ALetter */],
            [/*start*/ 0x11D66, 0 /* Other */],
            [/*start*/ 0x11D67, 11 /* ALetter */],
            [/*start*/ 0x11D69, 0 /* Other */],
            [/*start*/ 0x11D6A, 11 /* ALetter */],
            [/*start*/ 0x11D8A, 14 /* Extend */],
            [/*start*/ 0x11D8F, 0 /* Other */],
            [/*start*/ 0x11D90, 14 /* Extend */],
            [/*start*/ 0x11D92, 0 /* Other */],
            [/*start*/ 0x11D93, 14 /* Extend */],
            [/*start*/ 0x11D98, 11 /* ALetter */],
            [/*start*/ 0x11D99, 0 /* Other */],
            [/*start*/ 0x11DA0, 9 /* Numeric */],
            [/*start*/ 0x11DAA, 0 /* Other */],
            [/*start*/ 0x11EE0, 11 /* ALetter */],
            [/*start*/ 0x11EF3, 14 /* Extend */],
            [/*start*/ 0x11EF7, 0 /* Other */],
            [/*start*/ 0x11FB0, 11 /* ALetter */],
            [/*start*/ 0x11FB1, 0 /* Other */],
            [/*start*/ 0x12000, 11 /* ALetter */],
            [/*start*/ 0x1239A, 0 /* Other */],
            [/*start*/ 0x12400, 11 /* ALetter */],
            [/*start*/ 0x1246F, 0 /* Other */],
            [/*start*/ 0x12480, 11 /* ALetter */],
            [/*start*/ 0x12544, 0 /* Other */],
            [/*start*/ 0x13000, 11 /* ALetter */],
            [/*start*/ 0x1342F, 0 /* Other */],
            [/*start*/ 0x13430, 13 /* Format */],
            [/*start*/ 0x13439, 0 /* Other */],
            [/*start*/ 0x14400, 11 /* ALetter */],
            [/*start*/ 0x14647, 0 /* Other */],
            [/*start*/ 0x16800, 11 /* ALetter */],
            [/*start*/ 0x16A39, 0 /* Other */],
            [/*start*/ 0x16A40, 11 /* ALetter */],
            [/*start*/ 0x16A5F, 0 /* Other */],
            [/*start*/ 0x16A60, 9 /* Numeric */],
            [/*start*/ 0x16A6A, 0 /* Other */],
            [/*start*/ 0x16AD0, 11 /* ALetter */],
            [/*start*/ 0x16AEE, 0 /* Other */],
            [/*start*/ 0x16AF0, 14 /* Extend */],
            [/*start*/ 0x16AF5, 0 /* Other */],
            [/*start*/ 0x16B00, 11 /* ALetter */],
            [/*start*/ 0x16B30, 14 /* Extend */],
            [/*start*/ 0x16B37, 0 /* Other */],
            [/*start*/ 0x16B40, 11 /* ALetter */],
            [/*start*/ 0x16B44, 0 /* Other */],
            [/*start*/ 0x16B50, 9 /* Numeric */],
            [/*start*/ 0x16B5A, 0 /* Other */],
            [/*start*/ 0x16B63, 11 /* ALetter */],
            [/*start*/ 0x16B78, 0 /* Other */],
            [/*start*/ 0x16B7D, 11 /* ALetter */],
            [/*start*/ 0x16B90, 0 /* Other */],
            [/*start*/ 0x16E40, 11 /* ALetter */],
            [/*start*/ 0x16E80, 0 /* Other */],
            [/*start*/ 0x16F00, 11 /* ALetter */],
            [/*start*/ 0x16F4B, 0 /* Other */],
            [/*start*/ 0x16F4F, 14 /* Extend */],
            [/*start*/ 0x16F50, 11 /* ALetter */],
            [/*start*/ 0x16F51, 14 /* Extend */],
            [/*start*/ 0x16F88, 0 /* Other */],
            [/*start*/ 0x16F8F, 14 /* Extend */],
            [/*start*/ 0x16F93, 11 /* ALetter */],
            [/*start*/ 0x16FA0, 0 /* Other */],
            [/*start*/ 0x16FE0, 11 /* ALetter */],
            [/*start*/ 0x16FE2, 0 /* Other */],
            [/*start*/ 0x16FE3, 11 /* ALetter */],
            [/*start*/ 0x16FE4, 14 /* Extend */],
            [/*start*/ 0x16FE5, 0 /* Other */],
            [/*start*/ 0x16FF0, 14 /* Extend */],
            [/*start*/ 0x16FF2, 0 /* Other */],
            [/*start*/ 0x1B000, 17 /* Katakana */],
            [/*start*/ 0x1B001, 0 /* Other */],
            [/*start*/ 0x1B164, 17 /* Katakana */],
            [/*start*/ 0x1B168, 0 /* Other */],
            [/*start*/ 0x1BC00, 11 /* ALetter */],
            [/*start*/ 0x1BC6B, 0 /* Other */],
            [/*start*/ 0x1BC70, 11 /* ALetter */],
            [/*start*/ 0x1BC7D, 0 /* Other */],
            [/*start*/ 0x1BC80, 11 /* ALetter */],
            [/*start*/ 0x1BC89, 0 /* Other */],
            [/*start*/ 0x1BC90, 11 /* ALetter */],
            [/*start*/ 0x1BC9A, 0 /* Other */],
            [/*start*/ 0x1BC9D, 14 /* Extend */],
            [/*start*/ 0x1BC9F, 0 /* Other */],
            [/*start*/ 0x1BCA0, 13 /* Format */],
            [/*start*/ 0x1BCA4, 0 /* Other */],
            [/*start*/ 0x1D165, 14 /* Extend */],
            [/*start*/ 0x1D16A, 0 /* Other */],
            [/*start*/ 0x1D16D, 14 /* Extend */],
            [/*start*/ 0x1D173, 13 /* Format */],
            [/*start*/ 0x1D17B, 14 /* Extend */],
            [/*start*/ 0x1D183, 0 /* Other */],
            [/*start*/ 0x1D185, 14 /* Extend */],
            [/*start*/ 0x1D18C, 0 /* Other */],
            [/*start*/ 0x1D1AA, 14 /* Extend */],
            [/*start*/ 0x1D1AE, 0 /* Other */],
            [/*start*/ 0x1D242, 14 /* Extend */],
            [/*start*/ 0x1D245, 0 /* Other */],
            [/*start*/ 0x1D400, 11 /* ALetter */],
            [/*start*/ 0x1D455, 0 /* Other */],
            [/*start*/ 0x1D456, 11 /* ALetter */],
            [/*start*/ 0x1D49D, 0 /* Other */],
            [/*start*/ 0x1D49E, 11 /* ALetter */],
            [/*start*/ 0x1D4A0, 0 /* Other */],
            [/*start*/ 0x1D4A2, 11 /* ALetter */],
            [/*start*/ 0x1D4A3, 0 /* Other */],
            [/*start*/ 0x1D4A5, 11 /* ALetter */],
            [/*start*/ 0x1D4A7, 0 /* Other */],
            [/*start*/ 0x1D4A9, 11 /* ALetter */],
            [/*start*/ 0x1D4AD, 0 /* Other */],
            [/*start*/ 0x1D4AE, 11 /* ALetter */],
            [/*start*/ 0x1D4BA, 0 /* Other */],
            [/*start*/ 0x1D4BB, 11 /* ALetter */],
            [/*start*/ 0x1D4BC, 0 /* Other */],
            [/*start*/ 0x1D4BD, 11 /* ALetter */],
            [/*start*/ 0x1D4C4, 0 /* Other */],
            [/*start*/ 0x1D4C5, 11 /* ALetter */],
            [/*start*/ 0x1D506, 0 /* Other */],
            [/*start*/ 0x1D507, 11 /* ALetter */],
            [/*start*/ 0x1D50B, 0 /* Other */],
            [/*start*/ 0x1D50D, 11 /* ALetter */],
            [/*start*/ 0x1D515, 0 /* Other */],
            [/*start*/ 0x1D516, 11 /* ALetter */],
            [/*start*/ 0x1D51D, 0 /* Other */],
            [/*start*/ 0x1D51E, 11 /* ALetter */],
            [/*start*/ 0x1D53A, 0 /* Other */],
            [/*start*/ 0x1D53B, 11 /* ALetter */],
            [/*start*/ 0x1D53F, 0 /* Other */],
            [/*start*/ 0x1D540, 11 /* ALetter */],
            [/*start*/ 0x1D545, 0 /* Other */],
            [/*start*/ 0x1D546, 11 /* ALetter */],
            [/*start*/ 0x1D547, 0 /* Other */],
            [/*start*/ 0x1D54A, 11 /* ALetter */],
            [/*start*/ 0x1D551, 0 /* Other */],
            [/*start*/ 0x1D552, 11 /* ALetter */],
            [/*start*/ 0x1D6A6, 0 /* Other */],
            [/*start*/ 0x1D6A8, 11 /* ALetter */],
            [/*start*/ 0x1D6C1, 0 /* Other */],
            [/*start*/ 0x1D6C2, 11 /* ALetter */],
            [/*start*/ 0x1D6DB, 0 /* Other */],
            [/*start*/ 0x1D6DC, 11 /* ALetter */],
            [/*start*/ 0x1D6FB, 0 /* Other */],
            [/*start*/ 0x1D6FC, 11 /* ALetter */],
            [/*start*/ 0x1D715, 0 /* Other */],
            [/*start*/ 0x1D716, 11 /* ALetter */],
            [/*start*/ 0x1D735, 0 /* Other */],
            [/*start*/ 0x1D736, 11 /* ALetter */],
            [/*start*/ 0x1D74F, 0 /* Other */],
            [/*start*/ 0x1D750, 11 /* ALetter */],
            [/*start*/ 0x1D76F, 0 /* Other */],
            [/*start*/ 0x1D770, 11 /* ALetter */],
            [/*start*/ 0x1D789, 0 /* Other */],
            [/*start*/ 0x1D78A, 11 /* ALetter */],
            [/*start*/ 0x1D7A9, 0 /* Other */],
            [/*start*/ 0x1D7AA, 11 /* ALetter */],
            [/*start*/ 0x1D7C3, 0 /* Other */],
            [/*start*/ 0x1D7C4, 11 /* ALetter */],
            [/*start*/ 0x1D7CC, 0 /* Other */],
            [/*start*/ 0x1D7CE, 9 /* Numeric */],
            [/*start*/ 0x1D800, 0 /* Other */],
            [/*start*/ 0x1DA00, 14 /* Extend */],
            [/*start*/ 0x1DA37, 0 /* Other */],
            [/*start*/ 0x1DA3B, 14 /* Extend */],
            [/*start*/ 0x1DA6D, 0 /* Other */],
            [/*start*/ 0x1DA75, 14 /* Extend */],
            [/*start*/ 0x1DA76, 0 /* Other */],
            [/*start*/ 0x1DA84, 14 /* Extend */],
            [/*start*/ 0x1DA85, 0 /* Other */],
            [/*start*/ 0x1DA9B, 14 /* Extend */],
            [/*start*/ 0x1DAA0, 0 /* Other */],
            [/*start*/ 0x1DAA1, 14 /* Extend */],
            [/*start*/ 0x1DAB0, 0 /* Other */],
            [/*start*/ 0x1E000, 14 /* Extend */],
            [/*start*/ 0x1E007, 0 /* Other */],
            [/*start*/ 0x1E008, 14 /* Extend */],
            [/*start*/ 0x1E019, 0 /* Other */],
            [/*start*/ 0x1E01B, 14 /* Extend */],
            [/*start*/ 0x1E022, 0 /* Other */],
            [/*start*/ 0x1E023, 14 /* Extend */],
            [/*start*/ 0x1E025, 0 /* Other */],
            [/*start*/ 0x1E026, 14 /* Extend */],
            [/*start*/ 0x1E02B, 0 /* Other */],
            [/*start*/ 0x1E100, 11 /* ALetter */],
            [/*start*/ 0x1E12D, 0 /* Other */],
            [/*start*/ 0x1E130, 14 /* Extend */],
            [/*start*/ 0x1E137, 11 /* ALetter */],
            [/*start*/ 0x1E13E, 0 /* Other */],
            [/*start*/ 0x1E140, 9 /* Numeric */],
            [/*start*/ 0x1E14A, 0 /* Other */],
            [/*start*/ 0x1E14E, 11 /* ALetter */],
            [/*start*/ 0x1E14F, 0 /* Other */],
            [/*start*/ 0x1E2C0, 11 /* ALetter */],
            [/*start*/ 0x1E2EC, 14 /* Extend */],
            [/*start*/ 0x1E2F0, 9 /* Numeric */],
            [/*start*/ 0x1E2FA, 0 /* Other */],
            [/*start*/ 0x1E800, 11 /* ALetter */],
            [/*start*/ 0x1E8C5, 0 /* Other */],
            [/*start*/ 0x1E8D0, 14 /* Extend */],
            [/*start*/ 0x1E8D7, 0 /* Other */],
            [/*start*/ 0x1E900, 11 /* ALetter */],
            [/*start*/ 0x1E944, 14 /* Extend */],
            [/*start*/ 0x1E94B, 11 /* ALetter */],
            [/*start*/ 0x1E94C, 0 /* Other */],
            [/*start*/ 0x1E950, 9 /* Numeric */],
            [/*start*/ 0x1E95A, 0 /* Other */],
            [/*start*/ 0x1EE00, 11 /* ALetter */],
            [/*start*/ 0x1EE04, 0 /* Other */],
            [/*start*/ 0x1EE05, 11 /* ALetter */],
            [/*start*/ 0x1EE20, 0 /* Other */],
            [/*start*/ 0x1EE21, 11 /* ALetter */],
            [/*start*/ 0x1EE23, 0 /* Other */],
            [/*start*/ 0x1EE24, 11 /* ALetter */],
            [/*start*/ 0x1EE25, 0 /* Other */],
            [/*start*/ 0x1EE27, 11 /* ALetter */],
            [/*start*/ 0x1EE28, 0 /* Other */],
            [/*start*/ 0x1EE29, 11 /* ALetter */],
            [/*start*/ 0x1EE33, 0 /* Other */],
            [/*start*/ 0x1EE34, 11 /* ALetter */],
            [/*start*/ 0x1EE38, 0 /* Other */],
            [/*start*/ 0x1EE39, 11 /* ALetter */],
            [/*start*/ 0x1EE3A, 0 /* Other */],
            [/*start*/ 0x1EE3B, 11 /* ALetter */],
            [/*start*/ 0x1EE3C, 0 /* Other */],
            [/*start*/ 0x1EE42, 11 /* ALetter */],
            [/*start*/ 0x1EE43, 0 /* Other */],
            [/*start*/ 0x1EE47, 11 /* ALetter */],
            [/*start*/ 0x1EE48, 0 /* Other */],
            [/*start*/ 0x1EE49, 11 /* ALetter */],
            [/*start*/ 0x1EE4A, 0 /* Other */],
            [/*start*/ 0x1EE4B, 11 /* ALetter */],
            [/*start*/ 0x1EE4C, 0 /* Other */],
            [/*start*/ 0x1EE4D, 11 /* ALetter */],
            [/*start*/ 0x1EE50, 0 /* Other */],
            [/*start*/ 0x1EE51, 11 /* ALetter */],
            [/*start*/ 0x1EE53, 0 /* Other */],
            [/*start*/ 0x1EE54, 11 /* ALetter */],
            [/*start*/ 0x1EE55, 0 /* Other */],
            [/*start*/ 0x1EE57, 11 /* ALetter */],
            [/*start*/ 0x1EE58, 0 /* Other */],
            [/*start*/ 0x1EE59, 11 /* ALetter */],
            [/*start*/ 0x1EE5A, 0 /* Other */],
            [/*start*/ 0x1EE5B, 11 /* ALetter */],
            [/*start*/ 0x1EE5C, 0 /* Other */],
            [/*start*/ 0x1EE5D, 11 /* ALetter */],
            [/*start*/ 0x1EE5E, 0 /* Other */],
            [/*start*/ 0x1EE5F, 11 /* ALetter */],
            [/*start*/ 0x1EE60, 0 /* Other */],
            [/*start*/ 0x1EE61, 11 /* ALetter */],
            [/*start*/ 0x1EE63, 0 /* Other */],
            [/*start*/ 0x1EE64, 11 /* ALetter */],
            [/*start*/ 0x1EE65, 0 /* Other */],
            [/*start*/ 0x1EE67, 11 /* ALetter */],
            [/*start*/ 0x1EE6B, 0 /* Other */],
            [/*start*/ 0x1EE6C, 11 /* ALetter */],
            [/*start*/ 0x1EE73, 0 /* Other */],
            [/*start*/ 0x1EE74, 11 /* ALetter */],
            [/*start*/ 0x1EE78, 0 /* Other */],
            [/*start*/ 0x1EE79, 11 /* ALetter */],
            [/*start*/ 0x1EE7D, 0 /* Other */],
            [/*start*/ 0x1EE7E, 11 /* ALetter */],
            [/*start*/ 0x1EE7F, 0 /* Other */],
            [/*start*/ 0x1EE80, 11 /* ALetter */],
            [/*start*/ 0x1EE8A, 0 /* Other */],
            [/*start*/ 0x1EE8B, 11 /* ALetter */],
            [/*start*/ 0x1EE9C, 0 /* Other */],
            [/*start*/ 0x1EEA1, 11 /* ALetter */],
            [/*start*/ 0x1EEA4, 0 /* Other */],
            [/*start*/ 0x1EEA5, 11 /* ALetter */],
            [/*start*/ 0x1EEAA, 0 /* Other */],
            [/*start*/ 0x1EEAB, 11 /* ALetter */],
            [/*start*/ 0x1EEBC, 0 /* Other */],
            [/*start*/ 0x1F130, 11 /* ALetter */],
            [/*start*/ 0x1F14A, 0 /* Other */],
            [/*start*/ 0x1F150, 11 /* ALetter */],
            [/*start*/ 0x1F16A, 0 /* Other */],
            [/*start*/ 0x1F170, 11 /* ALetter */],
            [/*start*/ 0x1F18A, 0 /* Other */],
            [/*start*/ 0x1F1E6, 18 /* Regional_Indicator */],
            [/*start*/ 0x1F200, 0 /* Other */],
            [/*start*/ 0x1F3FB, 14 /* Extend */],
            [/*start*/ 0x1F400, 0 /* Other */],
            [/*start*/ 0x1FBF0, 9 /* Numeric */],
            [/*start*/ 0x1FBFA, 0 /* Other */],
            [/*start*/ 0xE0001, 13 /* Format */],
            [/*start*/ 0xE0002, 0 /* Other */],
            [/*start*/ 0xE0020, 14 /* Extend */],
            [/*start*/ 0xE0080, 0 /* Other */],
            [/*start*/ 0xE0100, 14 /* Extend */],
            [/*start*/ 0xE01F0, 0 /* Other */],
        ];
    })(data = wordBreakers.data || (wordBreakers.data = {}));
})(wordBreakers || (wordBreakers = {}));
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Include the word-breaking data here:
/// <reference path="./data.ts" />
var wordBreakers;
(function (wordBreakers) {
    /**
     * Word breaker based on Unicode Standard Annex #29, Section 4.1:
     * Default Word Boundary Specification.
     *
     * @see http://unicode.org/reports/tr29/#Word_Boundaries
     * @see https://github.com/eddieantonio/unicode-default-word-boundary/tree/v12.0.0
     */
    function default_(text, options) {
        var boundaries = findBoundaries(text, options);
        if (boundaries.length == 0) {
            return [];
        }
        // All non-empty strings have at least TWO boundaries: at the start and at the end of
        // the string.
        var spans = [];
        for (var i = 0; i < boundaries.length - 1; i++) {
            var start = boundaries[i];
            var end = boundaries[i + 1];
            var span = new LazySpan(text, start, end);
            if (isNonSpace(span.text, options)) {
                spans.push(span);
                // Preserve a sequence-final space if it exists.  Needed to signal "end of word".
            }
            else if (i == boundaries.length - 2) { // if "we just checked the final boundary"...
                // We don't want to return the whitespace itself; the correct token is simply ''.
                span = new LazySpan(text, end, end);
                spans.push(span);
            }
        }
        return spans;
    }
    wordBreakers.default_ = default_;
    var WORD_BREAK_PROPERTY = wordBreakers.data.WORD_BREAK_PROPERTY;
    /**
     * A span that does not cut out the substring until it absolutely has to!
     */
    var LazySpan = /** @class */ (function () {
        function LazySpan(source, start, end) {
            this._source = source;
            this.start = start;
            this.end = end;
        }
        Object.defineProperty(LazySpan.prototype, "text", {
            get: function () {
                return this._source.substring(this.start, this.end);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LazySpan.prototype, "length", {
            get: function () {
                return this.end - this.start;
            },
            enumerable: false,
            configurable: true
        });
        return LazySpan;
    }());
    /**
     * Provides a useful presentation for wordbreaker's context for use in word-breaking rules.
     *
     * @see https://unicode.org/reports/tr29/#Word_Boundary_Rules
     */
    var BreakerContext = /** @class */ (function () {
        function BreakerContext(text, options, prop1, prop2, prop3, prop4) {
            /**
             * Represents the property of character immediately preceding `left`'s character.
             */
            this.lookbehind = 19 /* sot */;
            /**
             * Represents the property of the character immediately preceding the potential word boundary.
             */
            this.left = 19 /* sot */;
            /**
             * Represents the property of the character immediately following the potential word boundary.
             */
            this.right = 19 /* sot */;
            this.text = text;
            this.options = options;
            if (arguments.length == 3) {
                this.lookahead = this.wordbreakPropertyAt(prop1); // prop1;
            }
            else /*if(arguments.length == 6)*/ {
                this.lookbehind = prop1;
                this.left = prop2;
                this.right = prop3;
                this.lookahead = prop4;
            }
        }
        /**
         * The general use-case when shifting boundary-check position if WB4 is not active.
         * @param lookahead The WordBreakProperty for the character to become `lookahead`.
         * @returns
         */
        BreakerContext.prototype.next = function (lookaheadPos) {
            var newLookahead = this.wordbreakPropertyAt(lookaheadPos);
            return new BreakerContext(this.text, this.options, this.left, this.right, this.lookahead, newLookahead);
        };
        /**
         * Used for WB4:  when ignoring characters before an intervening linebreak, we
         * replace `right` with the current `lookahead`, without affecting `lookbehind`
         * or `left`.  A new `lookahead` is then needed.
         * @param lookahead
         * @returns
         */
        BreakerContext.prototype.ignoringRight = function (lookaheadPos) {
            var newLookahead = this.wordbreakPropertyAt(lookaheadPos);
            return new BreakerContext(this.text, this.options, this.lookbehind, this.left, this.lookahead, newLookahead);
        };
        /**
         * Used for WB4:  when ignoring characters after an intervening linebreak, it's
         * `lookahead` that gets replaced without shifting the other tracked properties.
         * @param lookahead
         * @returns
         */
        BreakerContext.prototype.ignoringLookahead = function (lookaheadPos) {
            var newLookahead = this.wordbreakPropertyAt(lookaheadPos);
            return new BreakerContext(this.text, this.options, this.lookbehind, this.left, this.right, newLookahead);
        };
        /**
         * Return the value of the Word_Break property at the given string index.
         * @param pos position in the text.
         */
        BreakerContext.prototype.wordbreakPropertyAt = function (pos) {
            if (pos < 0) {
                return 19 /* sot */; // Always "start of string" before the string starts!
            }
            else if (pos >= this.text.length) {
                return 20 /* eot */; // Always "end of string" after the string ends!
            }
            else if (isStartOfSurrogatePair(this.text[pos])) {
                // Surrogate pairs the next TWO items from the string!
                return property(this.text[pos] + this.text[pos + 1]);
            }
            return property(this.text[pos], this.options);
        };
        /**
         * Returns `true` if and only if each member of the context has a property included within
         * its corresponding set (when specified).  Any set may be replaced with null to disable
         * a check against its corresponding property.
         * @param lookbehindSet
         * @param leftSet
         * @param rightSet
         * @param lookaheadSet
         */
        BreakerContext.prototype.match = function (lookbehindSet, leftSet, rightSet, lookaheadSet) {
            var _a, _b, _c, _d;
            var result = (_a = lookbehindSet === null || lookbehindSet === void 0 ? void 0 : lookbehindSet.includes(this.lookbehind)) !== null && _a !== void 0 ? _a : true;
            result = result && ((_b = leftSet === null || leftSet === void 0 ? void 0 : leftSet.includes(this.left)) !== null && _b !== void 0 ? _b : true);
            result = result && ((_c = rightSet === null || rightSet === void 0 ? void 0 : rightSet.includes(this.right)) !== null && _c !== void 0 ? _c : true);
            return result && ((_d = lookaheadSet === null || lookaheadSet === void 0 ? void 0 : lookaheadSet.includes(this.lookahead)) !== null && _d !== void 0 ? _d : true);
        };
        /**
         * Returns `true` if and only if each member of the context has a property included within
         * its corresponding set (when specified).  Any set may be replaced with null to disable
         * a check against its corresponding property.
         *
         * Names should match those found at https://unicode.org/reports/tr29/#Word_Boundary_Rules
         * or defined in the word-breaker customization options; matching is case-insensitive.
         * Also includes two extra properties:
         * - `sot` - start of text
         * - `eot` - end of text
         * @param lookbehindSet
         * @param leftSet
         * @param rightSet
         * @param lookaheadSet
         */
        BreakerContext.prototype.propertyMatch = function (lookbehindSet, leftSet, rightSet, lookaheadSet) {
            var _this = this;
            var propMapper = function (name) { return propertyVal(name, _this.options); };
            return this.match(lookbehindSet === null || lookbehindSet === void 0 ? void 0 : lookbehindSet.map(propMapper), leftSet === null || leftSet === void 0 ? void 0 : leftSet.map(propMapper), rightSet === null || rightSet === void 0 ? void 0 : rightSet.map(propMapper), lookaheadSet === null || lookaheadSet === void 0 ? void 0 : lookaheadSet.map(propMapper));
        };
        return BreakerContext;
    }());
    wordBreakers.BreakerContext = BreakerContext;
    /**
     * Returns true when the chunk does not solely consist of whitespace.
     *
     * @param chunk a chunk of text. Starts and ends at word boundaries.
     */
    function isNonSpace(chunk, options) {
        return !Array.from(chunk).map(function (char) { return property(char, options); }).every(function (wb) { return (wb === 3 /* CR */ ||
            wb === 1 /* LF */ ||
            wb === 2 /* Newline */ ||
            wb === 4 /* WSegSpace */); });
    }
    /**
     * Yields a series of string indices where a word break should
     * occur. That is, there should be a break BEFORE each string
     * index yielded by this generator.
     *
     * @param text Text to find word boundaries in.
     */
    function findBoundaries(text, options) {
        var _a;
        // WB1 and WB2: no boundaries if given an empty string.
        if (text.length === 0) {
            // There are no boundaries in an empty string!
            return [];
        }
        if (options && !options.rules) {
            options.rules = [];
        }
        // This algorithm works by maintaining a sliding window of four SCALAR VALUES.
        //
        //  - Scalar values? JavaScript strings are NOT actually a string of
        //    Unicode code points; some characters are made up of TWO
        //    JavaScript indices. e.g.,
        //        "💩".length === 2;
        //        "💩"[0] === '\uD83D';
        //        "💩"[1] === '\uDCA9';
        //
        //    These characters that are represented by TWO indices are
        //    called "surrogate pairs". Since we don't want to be in the
        //    "middle" of a character, make sure we're always advancing
        //    by scalar values, and NOT indices. That means, we sometimes
        //    need to advance by TWO indices, not just one.
        //  - Four values? Some rules look at what's to the left of
        //    left, and some look at what's to the right of right. So
        //    keep track of this!
        var boundaries = [];
        var rightPos;
        var lookaheadPos = 0; // lookahead, one scalar value to the right of right.
        // Before the start of the string is also the start of the string.
        var state = new BreakerContext(text, options, lookaheadPos);
        // Count RIs to make sure we're not splitting emoji flags:
        var nConsecutiveRegionalIndicators = 0;
        do {
            // Shift all positions, one scalar value to the right.
            rightPos = lookaheadPos;
            lookaheadPos = positionAfter(lookaheadPos);
            // Shift all properties, one scalar value to the right.
            state = state.next(lookaheadPos);
            // Break at the start and end of text, unless the text is empty.
            // WB1: Break at start of text...
            if (state.match(null, [19 /* sot */], null, null)) {
                boundaries.push(rightPos);
                continue;
            }
            // WB2: Break at the end of text...
            if (state.match(null, null, [20 /* eot */], null)) {
                boundaries.push(rightPos);
                break; // Reached the end of the string. We're done!
            }
            // WB3: Do not break within CRLF:
            if (state.match(null, [3 /* CR */], [1 /* LF */], null)) {
                continue;
            }
            // WB3b: Otherwise, break after...
            var NEWLINE_SET = [2 /* Newline */, 3 /* CR */, 1 /* LF */];
            if (state.match(null, NEWLINE_SET, null, null)) {
                boundaries.push(rightPos);
                continue;
            }
            // WB3a: ...and before newlines
            if (state.match(null, null, NEWLINE_SET, null)) {
                boundaries.push(rightPos);
                continue;
            }
            // TODO: WB3c is not implemented, due to its complex, error-prone
            // implementation, requiring a ginormous regexp, and the fact that
            // the only thing it does is prevent big emoji sequences from being
            // split up, like 🧚🏼‍♂️
            // https://www.unicode.org/Public/emoji/12.0/emoji-zwj-sequences.txt
            // WB3d: Keep horizontal whitespace together
            if (state.match(null, [4 /* WSegSpace */], [4 /* WSegSpace */], null)) {
                continue;
            }
            // WB4: Ignore format and extend characters
            // This is to keep grapheme clusters together!
            // See: Section 6.2: https://unicode.org/reports/tr29/#Grapheme_Cluster_and_Format_Rules
            // N.B.: The rule about "except after sot, CR, LF, and
            // Newline" already been by WB1, WB2, WB3a, and WB3b above.
            var SET_WB4_IGNORE = [13 /* Format */, 14 /* Extend */, 16 /* ZWJ */];
            while (state.match(null, null, SET_WB4_IGNORE, null)) {
                // Continue advancing in the string, as if these
                // characters do not exist. DO NOT update left and
                // lookbehind however!
                _a = [lookaheadPos, positionAfter(lookaheadPos)], rightPos = _a[0], lookaheadPos = _a[1];
                state = state.ignoringRight(lookaheadPos);
            }
            // In ignoring the characters in the previous loop, we could
            // have fallen off the end of the string, so end the loop
            // prematurely if that happens!
            if (state.right === 20 /* eot */) {
                boundaries.push(rightPos);
                break;
            }
            // WB4 (continued): Lookahead must ALSO ignore these format,
            // extend, ZWJ characters!
            while (state.match(null, null, null, SET_WB4_IGNORE)) {
                // Continue advancing in the string, as if these
                // characters do not exist. DO NOT update left and right,
                // however!
                lookaheadPos = positionAfter(lookaheadPos);
                state = state.ignoringLookahead(lookaheadPos);
            }
            // See: https://unicode.org/reports/tr29/#WB_Rule_Macros
            var SET_AHLETTER = [11 /* ALetter */, 15 /* Hebrew_Letter */];
            var SET_MIDNUMLETQ = [8 /* MidNumLet */, 6 /* Single_Quote */];
            // Custom rules may override the base ruleset aside from the first few fundamental ones.
            if (options === null || options === void 0 ? void 0 : options.rules) {
                var customMatch = false;
                for (var _i = 0, _b = options.rules; _i < _b.length; _i++) {
                    var rule = _b[_i];
                    customMatch = rule.match(state);
                    if (customMatch) {
                        if (rule.breakIfMatch) {
                            boundaries.push(rightPos);
                        }
                        break; // as customMatch == true here, this will trigger the `continue` that follows.
                    }
                }
                if (customMatch) {
                    continue;
                }
            }
            // WB5: Do not break between most letters.
            // if (isAHLetter(state.left) && isAHLetter(state.right))
            if (state.match(null, SET_AHLETTER, SET_AHLETTER, null)) {
                continue;
            }
            // Do not break across certain punctuation
            // WB6: (Don't break before apostrophes in contractions)
            var SET_ALL_MIDLETTER = __spreadArray([10 /* MidLetter */], SET_MIDNUMLETQ, true);
            if (state.match(null, SET_AHLETTER, SET_ALL_MIDLETTER, SET_AHLETTER)) {
                continue;
            }
            // WB7: (Don't break after apostrophes in contractions)
            if (state.match(SET_AHLETTER, SET_ALL_MIDLETTER, SET_AHLETTER, null)) {
                continue;
            }
            // WB7a
            if (state.match(null, [15 /* Hebrew_Letter */], [6 /* Single_Quote */], null)) {
                continue;
            }
            // WB7b
            if (state.match(null, [15 /* Hebrew_Letter */], [5 /* Double_Quote */], [15 /* Hebrew_Letter */])) {
                continue;
            }
            // WB7c
            if (state.match([15 /* Hebrew_Letter */], [5 /* Double_Quote */], [15 /* Hebrew_Letter */], null)) {
                continue;
            }
            // Do not break within sequences of digits, or digits adjacent to letters.
            // e.g., "3a" or "A3"
            // WB8
            if (state.match(null, [9 /* Numeric */], [9 /* Numeric */], null)) {
                continue;
            }
            // WB9
            if (state.match(null, SET_AHLETTER, [9 /* Numeric */], null)) {
                continue;
            }
            // WB10
            if (state.match(null, [9 /* Numeric */], SET_AHLETTER, null)) {
                continue;
            }
            // Do not break within sequences, such as 3.2, 3,456.789
            // WB11
            var SET_ALL_MIDNUM = __spreadArray([7 /* MidNum */], SET_MIDNUMLETQ, true);
            if (state.match([9 /* Numeric */], SET_ALL_MIDNUM, [9 /* Numeric */], null)) {
                continue;
            }
            // WB12
            if (state.match(null, [9 /* Numeric */], SET_ALL_MIDNUM, [9 /* Numeric */])) {
                continue;
            }
            // WB13: Do not break between Katakana
            if (state.match(null, [17 /* Katakana */], [17 /* Katakana */], null)) {
                continue;
            }
            // Do not break from extenders (e.g., U+202F NARROW NO-BREAK SPACE)
            // WB13a
            var SET_NUM_KAT_LET = __spreadArray([17 /* Katakana */,
                9 /* Numeric */], SET_AHLETTER, true);
            if (state.match(null, SET_NUM_KAT_LET, [12 /* ExtendNumLet */], null)) {
                continue;
            }
            if (state.match(null, [12 /* ExtendNumLet */], [12 /* ExtendNumLet */], null)) {
                continue;
            }
            // WB13b
            if (state.match(null, [12 /* ExtendNumLet */], SET_NUM_KAT_LET, null)) {
                continue;
            }
            // WB15 & WB16:
            // Do not break within emoji flag sequences. That is, do not break between
            // regional indicator (RI) symbols if there is an odd number of RI
            // characters before the break point.
            if (state.right === 18 /* Regional_Indicator */) {
                // Emoji flags are actually composed of TWO scalar values, each being a
                // "regional indicator". These indicators correspond to Latin letters. Put
                // two of them together, and they spell out an ISO 3166-1-alpha-2 country
                // code. Since these always come in pairs, NEVER split the pairs! So, if
                // we happen to be inside the middle of an odd numbered of
                // Regional_Indicators, DON'T SPLIT IT!
                nConsecutiveRegionalIndicators += 1;
                if ((nConsecutiveRegionalIndicators % 2) == 1) {
                    continue;
                }
            }
            else {
                nConsecutiveRegionalIndicators = 0;
            }
            // WB999: Otherwise, break EVERYWHERE (including around ideographs)
            boundaries.push(rightPos);
        } while (rightPos < text.length);
        return boundaries;
        ///// Internal utility functions /////
        /**
         * Returns the position of the start of the next scalar value. This jumps
         * over surrogate pairs.
         *
         * If asked for the character AFTER the end of the string, this always
         * returns the length of the string.
         */
        function positionAfter(pos) {
            if (pos >= text.length) {
                return text.length;
            }
            else if (isStartOfSurrogatePair(text[pos])) {
                return pos + 2;
            }
            return pos + 1;
        }
    }
    function isStartOfSurrogatePair(character) {
        var codeUnit = character.charCodeAt(0);
        return codeUnit >= 0xD800 && codeUnit <= 0xDBFF;
    }
    /**
     * Return the Word_Break property value for a character.
     * Note that
     * @param character a scalar value
     */
    function property(character, options) {
        // If there is a customized mapping for the character, prioritize that.
        if (options === null || options === void 0 ? void 0 : options.propertyMapping) {
            var propName = options.propertyMapping(character);
            if (propName) {
                return propertyVal(propName, options);
            }
        }
        // This MUST be a scalar value.
        // TODO: remove dependence on character.codepointAt()?
        var codepoint = character.codePointAt(0);
        return searchForProperty(codepoint, 0, WORD_BREAK_PROPERTY.length - 1);
    }
    function propertyVal(propName, options) {
        var _a, _b;
        var matcher = function (name) { return name.toLowerCase() == propName.toLowerCase(); };
        var customIndex = (_b = (_a = options === null || options === void 0 ? void 0 : options.customProperties) === null || _a === void 0 ? void 0 : _a.findIndex(matcher)) !== null && _b !== void 0 ? _b : -1;
        return customIndex != -1 ? -customIndex - 1 : wordBreakers.data.propertyMap.findIndex(matcher);
    }
    /**
     * Binary search for the word break property of a given CODE POINT.
     *
     * The auto-generated data.ts master array defines a **character range**
     * lookup table.  If a character's codepoint is equal to or greater than
     * the I.Start value for an entry and exclusively less than the next entry,
     * it falls in the first entry's range bucket and is classified accordingly
     * by this method.
     */
    function searchForProperty(codePoint, left, right) {
        // All items that are not found in the array are assigned the 'Other' property.
        if (right < left) {
            return 0 /* Other */;
        }
        var midpoint = left + ~~((right - left) / 2);
        var candidate = WORD_BREAK_PROPERTY[midpoint];
        var nextRange = WORD_BREAK_PROPERTY[midpoint + 1];
        var startOfNextRange = nextRange ? nextRange[0 /* Start */] : Infinity;
        if (codePoint < candidate[0 /* Start */]) {
            return searchForProperty(codePoint, left, midpoint - 1);
        }
        else if (codePoint >= startOfNextRange) {
            return searchForProperty(codePoint, midpoint + 1, right);
        }
        // We found it!
        return candidate[1 /* Value */];
    }
})(wordBreakers || (wordBreakers = {}));
// We cannot export a member whose name is a reserved word when
// implementing a namespace, BUT we can manually make the
// assignment and **declare** it as part of the namespace.
wordBreakers['default'] = wordBreakers.default_;
var wordBreakers;
(function (wordBreakers) {
    /**
     * A **VERY** dumb word breaker that simply splits at words. Do not use this
     * word breaker!
     *
     * @param phrase The phrase in which to break words.
     * @deprecated Use a word breaker tailored to your language instead!
     */
    function placeholder(phrase) {
        var nextStart = 0;
        return phrase.split(/\s+/).map(function (utterance) {
            // XXX: The indices are NOT accurate to the original phrase!
            var span = {
                start: nextStart,
                end: nextStart + utterance.length,
                text: utterance,
                length: utterance.length
            };
            nextStart = span.end;
            return span;
        });
    }
    wordBreakers.placeholder = placeholder;
})(wordBreakers || (wordBreakers = {}));
/// <reference path="./ascii.ts" />
/// <reference path="./default/index.ts" />
/// <reference path="./placeholder.ts" />
// Let the word breakers be available both in the browser and in Node.
if (typeof module !== "undefined" && module.exports) {
    module.exports['wordBreakers'] = wordBreakers;
}
/*
 * Copyright (c) 2018 National Research Council Canada (author: Eddie A. Santos)
 * Copyright (c) 2018 SIL International
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var models;
(function (models) {
    /**
     * @file dummy-model.ts
     *
     * Defines the Dummy model, which is used for testing the
     * prediction API exclusively.
     */
    /**
     * The Dummy Model that returns nonsensical, but predictable results.
     */
    var DummyModel = /** @class */ (function () {
        function DummyModel(options) {
            options = options || {};
            // Create a shallow copy of the suggestions;
            // this class mutates the array.
            this._futureSuggestions = options.futureSuggestions
                ? options.futureSuggestions.slice() : [];
            if (options.punctuation) {
                this.punctuation = options.punctuation;
            }
        }
        DummyModel.prototype.configure = function (capabilities) {
            this.configuration = {
                leftContextCodePoints: capabilities.maxLeftContextCodePoints,
                rightContextCodePoints: capabilities.maxRightContextCodePoints
            };
            return this.configuration;
        };
        DummyModel.prototype.predict = function (transform, context, injectedSuggestions) {
            var makeUniformDistribution = function (suggestions) {
                var e_1, _a;
                var distribution = [];
                var n = suggestions.length;
                try {
                    for (var suggestions_1 = __values(suggestions), suggestions_1_1 = suggestions_1.next(); !suggestions_1_1.done; suggestions_1_1 = suggestions_1.next()) {
                        var s = suggestions_1_1.value;
                        distribution.push({ sample: s, p: 1 }); // For a dummy model, this is sufficient.  The uniformness is all that matters.
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (suggestions_1_1 && !suggestions_1_1.done && (_a = suggestions_1.return)) _a.call(suggestions_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return distribution;
            };
            if (injectedSuggestions) {
                return makeUniformDistribution(injectedSuggestions);
            }
            var currentSet = this._futureSuggestions.shift();
            if (!currentSet) {
                return [];
            }
            else {
                return makeUniformDistribution(currentSet);
            }
        };
        return DummyModel;
    }());
    models.DummyModel = DummyModel;
    ;
})(models || (models = {}));
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var correction;
(function (correction) {
    // A semi-optimized 'online'/iterative Damerau-Levenshtein calculator with the following features:
    // - may add new character to the 'input' string or to the 'match' string, reusing all old calculations efficiently.
    // - allows a 'focused' evaluation that seeks if the edit distance is within a specific range.  Designed for use in match-searching,
    //   where we want to find the 'closest' matching strings in a lexicon.
    // - towards such a match-searching algorithm/heuristic: should nothing be found within that range, all prior calculations may be reused
    //   to search across the lexicon with an incremented edit distance.
    // - minimized memory footprint: O(m) memory footprint (where m = length of 'input' string), rather than O(mn) (where n = length of 'match' string)
    //   - guaranteed to use a smaller footprint than DiagonalizedIterativeDamerauLevenshteinCalculation.
    //
    // In short:  Used to optimize calculations for low edit-distance checks, then expanded if/as necessary
    //            if a greater edit distance is requested.
    //
    // Reference: https://en.wikipedia.org/wiki/Wagner%E2%80%93Fischer_algorithm#Possible_modifications
    //    - Motivating statement:  "if we are only interested in the distance if it is smaller than a threshold..."  
    var ClassicalDistanceCalculation = /** @class */ (function () {
        function ClassicalDistanceCalculation(other) {
            /**
             * Specifies how far off-diagonal calculations should be performed.  A value of 0 only evaluates cells with matching
             * row and column indicies.
             *
             * The resulting value from .getFinalCost() is only guaranteed correct if it is less than or equal to this value.
             * Otherwise, this object represents a heuristic that _may_ overestimate the true edit distance.  Note that it will
             * never underestimate.
             */
            this.diagonalWidth = 2; // TODO: Ideally, should start at 1... but we'll start at 2 for now
            // as a naive workaround for multi-char transform limitations.
            // The sequence of characters input so far.
            this.inputSequence = [];
            this.matchSequence = [];
            if (other) {
                // Clone class properties.
                var rowCount = other.resolvedDistances.length;
                this.resolvedDistances = Array(rowCount);
                for (var r = 0; r < rowCount; r++) {
                    this.resolvedDistances[r] = Array.from(other.resolvedDistances[r]);
                }
                this.inputSequence = Array.from(other.inputSequence);
                this.matchSequence = Array.from(other.matchSequence);
                this.diagonalWidth = other.diagonalWidth;
            }
            else {
                this.resolvedDistances = [];
            }
        }
        ClassicalDistanceCalculation.prototype.getTrueIndex = function (r, c, width) {
            var retVal = {
                row: r,
                col: c - r + width,
                sparse: false
            };
            if (retVal.col < 0 || retVal.col > 2 * width) {
                retVal.sparse = true;
            }
            return retVal;
        };
        ClassicalDistanceCalculation.prototype.getCostAt = function (i, j, width) {
            if (width === void 0) { width = this.diagonalWidth; }
            // Check for and handle the set of fixed-value virtualized indices.
            if (i < 0 || j < 0) {
                if (i == -1 && j >= -1) {
                    return j + 1;
                }
                else if (j == -1 && i >= -1) {
                    return i + 1;
                }
                return Number.MAX_VALUE;
            }
            var index = this.getTrueIndex(i, j, width);
            return index.sparse ? Number.MAX_VALUE : this.resolvedDistances[index.row][index.col];
        };
        /**
         * Noting the above link's statement prefixed "By examining diagonals instead of rows, and by using lazy evaluation...",
         * this function will return the actual edit distance between the strings, temporarily increasing the computed
         * diagonal's size if necessary.
         *
         * Does not actually mutate the instance.
         */
        ClassicalDistanceCalculation.prototype.getFinalCost = function () {
            var buffer = this;
            var val = buffer.getHeuristicFinalCost();
            while (val > buffer.diagonalWidth) {
                // A consequence of treating this class as immutable.
                buffer = buffer.increaseMaxDistance();
                val = buffer.getHeuristicFinalCost();
            }
            return val;
        };
        /**
         * Returns this instance's computed edit distance.  If greater than the diagonal's width value, note that it may be an overestimate.
         */
        ClassicalDistanceCalculation.prototype.getHeuristicFinalCost = function () {
            return this.getCostAt(this.inputSequence.length - 1, this.matchSequence.length - 1);
        };
        /**
         * Returns `true` if the represented edit distance is less than or equal to the specified threshold, minimizing the amount of calculations
         * needed to meet the specified limit.
         *
         * Does not mutate the instance.
         * @param threshold
         */
        ClassicalDistanceCalculation.prototype.hasFinalCostWithin = function (threshold) {
            var buffer = this;
            var val = buffer.getHeuristicFinalCost();
            var guaranteedBound = this.diagonalWidth;
            do {
                // val will never exceed the length of the longer string, no matter how large the threshold.
                if (val <= threshold) {
                    return true;
                }
                else if (guaranteedBound < threshold) {
                    buffer = buffer.increaseMaxDistance();
                    guaranteedBound++;
                    val = buffer.getHeuristicFinalCost();
                }
                else {
                    break;
                }
            } while (true);
            return false;
        };
        /**
         * Determines the edit path used to obtain the optimal cost, distinguishing between zero-cost
         * substitutions ('match' operations) and actual substitutions.
         * @param row
         * @param col
         */
        ClassicalDistanceCalculation.prototype.editPath = function (row, col) {
            if (row === void 0) { row = this.inputSequence.length - 1; }
            if (col === void 0) { col = this.matchSequence.length - 1; }
            var currentCost = this.getCostAt(row, col);
            var ops = null;
            var parent = null;
            var insertParentCost = this.getCostAt(row, col - 1);
            var deleteParentCost = this.getCostAt(row - 1, col);
            var substitutionParentCost = this.getCostAt(row - 1, col - 1);
            var _a = __read(ClassicalDistanceCalculation.getTransposeParent(this, row, col), 2), lastInputIndex = _a[0], lastMatchIndex = _a[1];
            if (lastInputIndex >= 0 && lastMatchIndex >= 0) {
                // OK, a transposition source is quite possible.  Still need to do more vetting, to be sure.
                var expectedCost = 1;
                // This transposition includes either 'transpose-insert' or 'transpose-delete' operations.
                ops = ['transpose-start']; // always needs a 'start'.
                if (lastInputIndex != row - 1) {
                    var count = row - lastInputIndex - 1;
                    ops = ops.concat(Array(count).fill('transpose-delete'));
                    expectedCost += count;
                }
                else {
                    var count = col - lastMatchIndex - 1;
                    ops = ops.concat(Array(count).fill('transpose-insert'));
                    expectedCost += count;
                }
                ops.push('transpose-end');
                // Double-check our expectations.
                if (this.getCostAt(lastInputIndex - 1, lastMatchIndex - 1) != currentCost - expectedCost) {
                    ops = null;
                }
                parent = [lastInputIndex - 1, lastMatchIndex - 1];
            }
            if (ops) {
                // bypass the ladder.
            }
            else if (substitutionParentCost == currentCost - 1) {
                ops = ['substitute'];
                parent = [row - 1, col - 1];
            }
            else if (insertParentCost == currentCost - 1) {
                ops = ['insert'];
                parent = [row, col - 1];
            }
            else if (deleteParentCost == currentCost - 1) {
                ops = ['delete'];
                parent = [row - 1, col];
            }
            else { //if(substitutionParentCost == currentCost) {
                ops = ['match'];
                parent = [row - 1, col - 1];
            }
            // Recursively build the edit path.
            if (parent[0] >= 0 && parent[1] >= 0) {
                return this.editPath(parent[0], parent[1]).concat(ops);
            }
            else {
                if (parent[0] > -1) {
                    // There are initial deletions.
                    return Array(parent[0] + 1).fill('delete').concat(ops);
                }
                else if (parent[1] > -1) {
                    // There are initial insertions.
                    return Array(parent[1] + 1).fill('insert').concat(ops);
                }
                else {
                    return ops;
                }
            }
        };
        ClassicalDistanceCalculation.getTransposeParent = function (buffer, r, c) {
            // Block any transpositions where the tokens are identical.
            // Other operations will be cheaper.  Also, block cases where 'parents' are impossible.
            if (r < 0 || c < 0 || buffer.inputSequence[r].key == buffer.matchSequence[c].key) {
                return [-1, -1];
            }
            // Transposition checks
            var lastInputIndex = -1;
            for (var i = r - 1; i >= 0; i--) {
                if (buffer.inputSequence[i].key == buffer.matchSequence[c].key) {
                    lastInputIndex = i;
                    break;
                }
            }
            var lastMatchIndex = -1;
            for (var i = c - 1; i >= 0; i--) {
                if (buffer.matchSequence[i].key == buffer.inputSequence[r].key) {
                    lastMatchIndex = i;
                    break;
                }
            }
            return [lastInputIndex, lastMatchIndex];
        };
        ClassicalDistanceCalculation.initialCostAt = function (buffer, r, c, insertCost, deleteCost) {
            var baseSubstitutionCost = buffer.inputSequence[r].key == buffer.matchSequence[c].key ? 0 : 1;
            var substitutionCost = buffer.getCostAt(r - 1, c - 1) + baseSubstitutionCost;
            var insertionCost = insertCost || buffer.getCostAt(r, c - 1) + 1; // If set meaningfully, will never equal zero.
            var deletionCost = deleteCost || buffer.getCostAt(r - 1, c) + 1; // If set meaningfully, will never equal zero.
            var transpositionCost = Number.MAX_VALUE;
            if (r > 0 && c > 0) { // bypass when transpositions are known to be impossible.
                var _a = __read(ClassicalDistanceCalculation.getTransposeParent(buffer, r, c), 2), lastInputIndex = _a[0], lastMatchIndex = _a[1];
                transpositionCost = buffer.getCostAt(lastInputIndex - 1, lastMatchIndex - 1) + (r - lastInputIndex - 1) + 1 + (c - lastMatchIndex - 1);
            }
            return Math.min(substitutionCost, deletionCost, insertionCost, transpositionCost);
        };
        ClassicalDistanceCalculation.prototype.getSubset = function (inputLength, matchLength) {
            var trimmedInstance = new ClassicalDistanceCalculation(this);
            if (inputLength > this.inputSequence.length || matchLength > this.matchSequence.length) {
                throw "Invalid dimensions specified for trim operation";
            }
            // Trim our tracked input & match sequences.
            trimmedInstance.inputSequence.splice(inputLength);
            trimmedInstance.matchSequence.splice(matchLength);
            // Major index corresponds to input length.
            trimmedInstance.resolvedDistances.splice(inputLength);
            // The real fun:  trimming off columns. (Minor index, corresponds to match length)
            var finalTrueIndex = this.getTrueIndex(inputLength - 1, matchLength - 1, this.diagonalWidth);
            // The diagonal index increases as the row index decreases.
            for (var diagonalIndex = finalTrueIndex.col; diagonalIndex <= 2 * this.diagonalWidth; diagonalIndex++) {
                var row = finalTrueIndex.row - (diagonalIndex - finalTrueIndex.col);
                if (row < 0) {
                    break;
                }
                if (diagonalIndex < 0) {
                    trimmedInstance.resolvedDistances[row] = Array(2 * trimmedInstance.diagonalWidth + 1).fill(Number.MAX_VALUE);
                }
                else {
                    var newCount = 2 * this.diagonalWidth - diagonalIndex;
                    var keptEntries = trimmedInstance.resolvedDistances[row].splice(0, diagonalIndex + 1);
                    var newEntries = Array(newCount).fill(Number.MAX_VALUE);
                    trimmedInstance.resolvedDistances[row] = keptEntries.concat(newEntries);
                }
            }
            return trimmedInstance;
        };
        ClassicalDistanceCalculation.forDiagonalOfAxis = function (diagonalWidth, centerIndex, axisCap, closure) {
            var diagonalCap = axisCap - centerIndex < diagonalWidth ? axisCap - centerIndex + diagonalWidth : 2 * diagonalWidth;
            var startOffset = centerIndex - diagonalWidth; // The axis's index for diagonal entry 0.  May be negative.
            var diagonalStart = startOffset < 0 ? 0 : startOffset;
            for (var diagonalIndex = diagonalStart - startOffset; diagonalIndex <= diagonalCap; diagonalIndex++) {
                closure(startOffset + diagonalIndex, diagonalIndex);
            }
        };
        // Inputs add an extra row / first index entry.
        ClassicalDistanceCalculation.prototype.addInputChar = function (token) {
            var returnBuffer = new ClassicalDistanceCalculation(this);
            var r = returnBuffer.inputSequence.length;
            returnBuffer.inputSequence.push(token);
            // Insert a row, even if we don't actually do anything with it yet.
            // Initialize all entries with Number.MAX_VALUE, as `undefined` use leads to JS math issues.
            var row = Array(2 * returnBuffer.diagonalWidth + 1).fill(Number.MAX_VALUE);
            returnBuffer.resolvedDistances[r] = row;
            // If there isn't a 'match' entry yet, there are no values to compute.  Exit immediately.
            if (returnBuffer.matchSequence.length == 0) {
                return returnBuffer;
            }
            ClassicalDistanceCalculation.forDiagonalOfAxis(returnBuffer.diagonalWidth, r, returnBuffer.matchSequence.length - 1, function (c, diagIndex) {
                row[diagIndex] = ClassicalDistanceCalculation.initialCostAt(returnBuffer, r, c);
            });
            return returnBuffer;
        };
        ClassicalDistanceCalculation.prototype.addMatchChar = function (token) {
            var returnBuffer = new ClassicalDistanceCalculation(this);
            var c = returnBuffer.matchSequence.length;
            returnBuffer.matchSequence.push(token);
            // If there isn't a 'match' entry yet, there are no values to compute.  Exit immediately.
            if (returnBuffer.inputSequence.length == 0) {
                return returnBuffer;
            }
            ClassicalDistanceCalculation.forDiagonalOfAxis(returnBuffer.diagonalWidth, c, returnBuffer.inputSequence.length - 1, function (r, diagIndex) {
                var row = returnBuffer.resolvedDistances[r];
                // Since diagIndex is from the perspective of the row, it must be inverted to properly index the column.
                row[2 * returnBuffer.diagonalWidth - diagIndex] = ClassicalDistanceCalculation.initialCostAt(returnBuffer, r, c);
            });
            return returnBuffer;
        };
        ClassicalDistanceCalculation.prototype.increaseMaxDistance = function () {
            var returnBuffer = new ClassicalDistanceCalculation(this);
            returnBuffer.diagonalWidth++;
            if (returnBuffer.inputSequence.length < 1 || returnBuffer.matchSequence.length < 1) {
                return returnBuffer;
            }
            // An abstraction of the common aspects of transposition handling during diagonal extensions.
            function forPossibleTranspositionsInDiagonal(startPos, fixedChar, lookupString, closure) {
                var diagonalCap = 2 * (returnBuffer.diagonalWidth - 1); // The maximum diagonal index permitted
                var axisCap = lookupString.length - 1; // The maximum index supported by the axis of iteration
                // Ensures that diagonal iteration only occurs within the axis's supported range
                diagonalCap = diagonalCap < axisCap - startPos ? diagonalCap : axisCap - startPos;
                // Iterate within the diagonal and call our closure for any potential transpositions.
                for (var diagonalIndex = 0; diagonalIndex <= diagonalCap; diagonalIndex++) {
                    if (fixedChar == lookupString[startPos + diagonalIndex].key) {
                        closure(startPos + diagonalIndex, diagonalIndex);
                    }
                }
            }
            var _loop_1 = function (r) {
                var leftCell = Number.MAX_VALUE;
                var c = r - returnBuffer.diagonalWidth; // External index of the left-most entry, which we will now calculate.
                if (c >= 0) {
                    // If c == 0, cell is at edge, thus a known value for insertions exists.
                    // Base cost: r+1, +1 for inserting.
                    var insertionCost_1 = c == 0 ? r + 2 : Number.MAX_VALUE;
                    // compute new left cell
                    leftCell = ClassicalDistanceCalculation.initialCostAt(returnBuffer, r, c, insertionCost_1, undefined);
                    var addedCost_1 = leftCell;
                    // daisy-chain possible updates
                    // cell (r, c+1):  new insertion source
                    if (c < returnBuffer.matchSequence.length - 1) {
                        // We propagate the new added cost (via insertion) to the old left-most cell, which is one to our right.
                        ClassicalDistanceCalculation.propagateUpdateFrom(returnBuffer, r, c + 1, addedCost_1 + 1, 0);
                        // Only possible if insertions are also possible AND more conditions are met.
                        // cells (r+2, * > c+2):  new transposition source
                        var transposeRow_1 = r + 2;
                        if (r + 2 < this_1.inputSequence.length) { // Row to check for transposes must exist.
                            var rowChar = returnBuffer.inputSequence[r + 1].key;
                            // First possible match in input could be at index c + 2, which adjusts col c+2's cost.  Except that entry in r+2
                            // doesn't exist yet - so we start with c+3 instead.
                            forPossibleTranspositionsInDiagonal(c + 3, rowChar, returnBuffer.matchSequence, function (axisIndex, diagIndex) {
                                // Because (r+2, c+3) is root, not (r+2, c+2).  Min cost of 2.
                                ClassicalDistanceCalculation.propagateUpdateFrom(returnBuffer, transposeRow_1, axisIndex, addedCost_1 + diagIndex + 2, diagIndex);
                            });
                        }
                    }
                }
                var rightCell = Number.MAX_VALUE;
                c = r + returnBuffer.diagonalWidth;
                if (c < returnBuffer.matchSequence.length) {
                    // If r == 0, cell is at edge, thus a known value for insertions exists.
                    // Base cost: c+1, +1 for inserting.
                    var deletionCost = r == 0 ? c + 2 : Number.MAX_VALUE;
                    // the current row wants to use adjusted diagonal width; we must specify use of the old width & its mapping instead.
                    insertionCost = returnBuffer.getCostAt(r, c - 1, this_1.diagonalWidth) + 1;
                    // compute new right cell
                    rightCell = ClassicalDistanceCalculation.initialCostAt(returnBuffer, r, c, insertionCost, deletionCost);
                    var addedCost_2 = rightCell;
                    // daisy-chain possible updates
                    // cell (r+1, c):  new deletion source
                    if (r < returnBuffer.inputSequence.length - 1) {
                        // We propagate the new added cost (via deletion) to the old right-most cell, which is one to our right.
                        ClassicalDistanceCalculation.propagateUpdateFrom(returnBuffer, r + 1, c, addedCost_2 + 1, 2 * this_1.diagonalWidth);
                        // Only possible if deletions are also possible AND more conditions are met.
                        // cells(* > r+2, c+2): new transposition source
                        var transposeCol_1 = c + 2;
                        if (c + 2 < this_1.matchSequence.length) { // Row to check for transposes must exist.
                            var colChar = returnBuffer.matchSequence[r + 1].key;
                            // First possible match in input could be at index r + 2, which adjusts row r+2's cost.  Except that entry in c+2
                            // doesn't exist yet - so we start with r+3 instead.
                            forPossibleTranspositionsInDiagonal(r + 3, colChar, returnBuffer.inputSequence, function (axisIndex, diagIndex) {
                                var diagColIndex = 2 * (returnBuffer.diagonalWidth - 1) - diagIndex;
                                // Because (r+3, c+2) is root, not (r+2, c+2).  Min cost of 2.
                                ClassicalDistanceCalculation.propagateUpdateFrom(returnBuffer, axisIndex, transposeCol_1, addedCost_2 + diagIndex + 2, diagColIndex);
                            });
                        }
                    }
                }
                // Constructs the final expanded diagonal for the row.
                returnBuffer.resolvedDistances[r] = [leftCell].concat(returnBuffer.resolvedDistances[r], rightCell);
            };
            var this_1 = this, insertionCost;
            for (var r = 0; r < returnBuffer.inputSequence.length; r++) {
                _loop_1(r);
            }
            return returnBuffer;
        };
        ClassicalDistanceCalculation.propagateUpdateFrom = function (buffer, r, c, value, diagonalIndex) {
            // Note:  this function does not actually need the `c` parameter!
            //        That said, it's very useful when tracing stack traces & debugging.
            if (value < buffer.resolvedDistances[r][diagonalIndex]) {
                buffer.resolvedDistances[r][diagonalIndex] = value;
            }
            else {
                return;
            }
            var internalRow = r < buffer.inputSequence.length - 1;
            var internalCol = c < buffer.matchSequence.length - 1;
            // We have to compensate for the current & following rows not having been expanded yet.
            if (diagonalIndex < 2 * (buffer.diagonalWidth - 1) && internalCol) {
                // We've inserted to the left of an existing calculation - check for propagation via insertion.
                var updateCost = value + 1;
                this.propagateUpdateFrom(buffer, r, c + 1, updateCost, diagonalIndex + 1);
            }
            if (diagonalIndex > 0 && internalRow) {
                // We've inserted above an existing calculation - check for propagation via deletion
                var updateCost = value + 1;
                this.propagateUpdateFrom(buffer, r + 1, c, updateCost, diagonalIndex - 1);
            }
            // If both, check for propagation via substitution and possible transpositions
            if (internalRow && internalCol) {
                var updateCost = value + (buffer.inputSequence[r + 1].key == buffer.matchSequence[c + 1].key ? 0 : 1);
                this.propagateUpdateFrom(buffer, r + 1, c + 1, updateCost, diagonalIndex);
                // Propagating transpositions (only possible if 'internal'.)
                var nextInputIndex = -1;
                for (var i = r + 2; i < buffer.inputSequence.length; i++) {
                    if (buffer.inputSequence[i].key == buffer.matchSequence[c + 1].key) {
                        nextInputIndex = i;
                        break;
                    }
                }
                var nextMatchIndex = -1;
                for (var i = c + 2; i < buffer.matchSequence.length; i++) {
                    if (buffer.matchSequence[i].key == buffer.inputSequence[r + 1].key) {
                        nextMatchIndex = i;
                        break;
                    }
                }
                if (nextInputIndex > 0 && nextMatchIndex > 0) {
                    var transpositionCost = value + (nextInputIndex - r - 2) + 1 + (nextMatchIndex - c - 2);
                    this.propagateUpdateFrom(buffer, nextInputIndex, nextMatchIndex, transpositionCost, (buffer.diagonalWidth - 1) + nextMatchIndex - nextInputIndex);
                }
            }
        };
        Object.defineProperty(ClassicalDistanceCalculation.prototype, "mapKey", {
            get: function () {
                var inputString = this.inputSequence.map(function (value) { return value.key; }).join('');
                var matchString = this.matchSequence.map(function (value) { return value.key; }).join('');
                return inputString + models.SENTINEL_CODE_UNIT + matchString + models.SENTINEL_CODE_UNIT + this.diagonalWidth;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ClassicalDistanceCalculation.prototype, "lastInputEntry", {
            get: function () {
                return this.inputSequence[this.inputSequence.length - 1];
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ClassicalDistanceCalculation.prototype, "lastMatchEntry", {
            get: function () {
                return this.matchSequence[this.matchSequence.length - 1];
            },
            enumerable: false,
            configurable: true
        });
        ClassicalDistanceCalculation.computeDistance = function (input, match, bandSize) {
            if (bandSize === void 0) { bandSize = 1; }
            // Initialize the calculation buffer, setting the diagonal width (as appropriate) in advance.
            var buffer = new ClassicalDistanceCalculation();
            bandSize = bandSize || 1;
            buffer.diagonalWidth = bandSize;
            for (var i = 0; i < input.length; i++) {
                buffer = buffer.addInputChar(input[i]);
            }
            for (var j = 0; j < match.length; j++) {
                buffer = buffer.addMatchChar(match[j]);
            }
            return buffer;
        };
        return ClassicalDistanceCalculation;
    }());
    correction.ClassicalDistanceCalculation = ClassicalDistanceCalculation;
})(correction || (correction = {}));
/// <reference path="classical-calculation.ts" />
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var correction;
(function (correction) {
    correction.QUEUE_NODE_COMPARATOR = function (arg1, arg2) {
        return arg1.currentCost - arg2.currentCost;
    };
    // Represents a processed node for the correction-search's search-space's tree-like graph.  May represent
    // internal and 'leaf' nodes on said graph, as well as the overall root of the search.  Also used to represent
    // edges on the graph TO said nodes - there's a bit of overloading here.  Either way, it stores the cost of the
    // optimum path used to reach the ndoe.
    //
    // The stored path cost may be an overestimate when the edit distance is greater than the current search threshold.  The
    // first version of the node to be dequeued from SearchSpace's priority queue hierarchy 'wins' and is taken as the absolute
    // minimum; subsequent versions are ignored as suboptimal.
    //
    // Provides functions usable to enumerate across the node's outward edges to new nodes for continued search.
    // Most of the actual calculations occur as part of this process.
    //
    // For nodes with raw edit-distance cost within the current threshold for correction searches, we do have admissibility.
    // If not enough nodes are available within that threshold, however, admissibility may be lost, leaving our search as a
    // heuristic.
    //
    var SearchNode = /** @class */ (function () {
        function SearchNode(rootTraversal, toKey) {
            this.toKey = function (str) { return str; };
            toKey = toKey || (function (x) { return x; });
            if (rootTraversal instanceof SearchNode) {
                var priorNode = rootTraversal;
                this.calculation = priorNode.calculation;
                this.currentTraversal = priorNode.currentTraversal;
                this.priorInput = priorNode.priorInput;
                this.toKey = priorNode.toKey;
            }
            else {
                this.calculation = new correction.ClassicalDistanceCalculation();
                this.currentTraversal = rootTraversal;
                this.priorInput = [];
                this.toKey = toKey;
            }
        }
        Object.defineProperty(SearchNode.prototype, "knownCost", {
            get: function () {
                return this.calculation.getHeuristicFinalCost();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SearchNode.prototype, "inputSamplingCost", {
            get: function () {
                if (this._inputCost !== undefined) {
                    return this._inputCost;
                }
                else {
                    var MIN_P_1 = SearchSpace.MIN_KEYSTROKE_PROBABILITY;
                    // Should technically re-normalize the sampling distribution.
                    // -ln(p) is smaller for larger probabilities, as ln(p) is always <= 0.  Approaches infinity as p => 0.
                    // TODO:  probably more efficient to instead use actual 'probability space'... but that'll involve extra changes.
                    this._inputCost = this.priorInput.map(function (mass) { return mass.p > MIN_P_1 ? mass.p : MIN_P_1; }).reduce(function (previous, current) { return previous - Math.log(current); }, 0);
                    return this._inputCost;
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SearchNode.prototype, "currentCost", {
            // The part used to prioritize our search.
            get: function () {
                // - We reintrepret 'known cost' as a psuedo-probability.
                //   - Noting that 1/e = 0.367879441, an edit-distance cost of 1 may be intepreted as -ln(1/e) - a log-space 'likelihood'.
                //     - Not exactly normalized, though.
                // That's a really, really high likelihood, thoough.
                //
                // At any rate, we can linearly scale the known-cost to have about whatever probability we want.
                // If we can state it as p = 1 / (c * e), note then that ln(c * e) = ln(c) + 1.  So, scale * (ln(c) + 1).
                // If we can state it as e^x, note that ln(e^x) = x * ln(e) = x - just scale by 'x'!
                // p = 1 / (e^4) = 0.01831563888.  This still exceeds many neighboring keys!
                // p = 1 / (e^5) = 0.00673794699.  Strikes a good balance.
                // Should easily give priority to neighboring keys before edit-distance kicks in (when keys are a bit ambiguous)
                return SearchSpace.EDIT_DISTANCE_COST_SCALE * this.knownCost + this.inputSamplingCost;
            },
            enumerable: false,
            configurable: true
        });
        SearchNode.prototype.buildInsertionEdges = function () {
            var e_2, _a;
            var edges = [];
            try {
                for (var _b = __values(this.currentTraversal.children()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var lexicalChild = _c.value;
                    var traversal = lexicalChild.traversal();
                    var matchToken = {
                        key: lexicalChild.char,
                        traversal: traversal
                    };
                    var childCalc = this.calculation.addMatchChar(matchToken);
                    var searchChild = new SearchNode(this);
                    searchChild.calculation = childCalc;
                    searchChild.priorInput = this.priorInput;
                    searchChild.currentTraversal = traversal;
                    edges.push(searchChild);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return edges;
        };
        SearchNode.prototype.buildDeletionEdges = function (inputDistribution) {
            var e_3, _a;
            var edges = [];
            try {
                /*
                 * If the probability of an input is less than the highest probability * the base edit-distance likelihood,
                 * don't build an edge for it; just rely on edits from the highest-probability edge.
                 *
                 * We may be able to be stricter, but this should be a decent start.
                 *
                 * Note:  thanks to ModelCompositor.predict, we know the distribution is pre-sorted.
                 */
                for (var inputDistribution_1 = __values(inputDistribution), inputDistribution_1_1 = inputDistribution_1.next(); !inputDistribution_1_1.done; inputDistribution_1_1 = inputDistribution_1.next()) {
                    var probMass = inputDistribution_1_1.value;
                    if (probMass.p < inputDistribution[0].p * Math.exp(-SearchSpace.EDIT_DISTANCE_COST_SCALE)) {
                        // Again, we're pre-sorted.  All further entries will be too low-cost to consider.
                        break;
                    }
                    var edgeCalc = this.calculation;
                    var transform = probMass.sample;
                    if (transform.deleteLeft) {
                        edgeCalc = edgeCalc.getSubset(edgeCalc.inputSequence.length - transform.deleteLeft, edgeCalc.matchSequence.length);
                    }
                    // TODO:  transform.deleteRight currently not supported.
                    var inputPath = Array.from(this.priorInput);
                    inputPath.push(probMass);
                    // Tokenize and iterate over input chars, adding them into the calc.
                    for (var i = 0; i < transform.insert.length; i++) {
                        var char = transform.insert[i];
                        if (models.isHighSurrogate(char)) {
                            i++;
                            char = char + transform.insert[i];
                        }
                        // In case of NFD input, filter out any empty-strings that may arise
                        // when 'keying' raw diacritics.
                        var keyedChar = this.toKey(char);
                        if (keyedChar) {
                            edgeCalc = edgeCalc.addInputChar({ key: keyedChar });
                        }
                    }
                    var childEdge = new SearchNode(this);
                    childEdge.calculation = edgeCalc;
                    childEdge.priorInput = inputPath;
                    edges.push(childEdge);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (inputDistribution_1_1 && !inputDistribution_1_1.done && (_a = inputDistribution_1.return)) _a.call(inputDistribution_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return edges;
        };
        // While this may SEEM to be unnecessary, note that sometimes substitutions (which are computed
        // via insert + delete) may be lower cost than both just-insert and just-delete.
        SearchNode.prototype.buildSubstitutionEdges = function (inputDistribution) {
            var e_4, _a, e_5, _b;
            // Handles the 'input' component.
            var intermediateEdges = this.buildDeletionEdges(inputDistribution);
            var edges = [];
            try {
                for (var _c = __values(this.currentTraversal.children()), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var lexicalChild = _d.value;
                    try {
                        for (var intermediateEdges_1 = (e_5 = void 0, __values(intermediateEdges)), intermediateEdges_1_1 = intermediateEdges_1.next(); !intermediateEdges_1_1.done; intermediateEdges_1_1 = intermediateEdges_1.next()) {
                            var edge = intermediateEdges_1_1.value;
                            var traversal = lexicalChild.traversal();
                            var matchToken = {
                                key: lexicalChild.char,
                                traversal: traversal
                            };
                            var childCalc = edge.calculation.addMatchChar(matchToken);
                            var searchChild = new SearchNode(this);
                            searchChild.calculation = childCalc;
                            searchChild.priorInput = edge.priorInput;
                            searchChild.currentTraversal = traversal;
                            edges.push(searchChild);
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (intermediateEdges_1_1 && !intermediateEdges_1_1.done && (_b = intermediateEdges_1.return)) _b.call(intermediateEdges_1);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return edges;
        };
        Object.defineProperty(SearchNode.prototype, "mapKey", {
            get: function () {
                var inputString = this.priorInput.map(function (value) { return '+' + value.sample.insert + '-' + value.sample.deleteLeft; }).join('');
                var matchString = this.calculation.matchSequence.map(function (value) { return value.key; }).join('');
                // TODO:  might should also track diagonalWidth.
                return inputString + models.SENTINEL_CODE_UNIT + matchString;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SearchNode.prototype, "isFullReplacement", {
            get: function () {
                // If the known edit-distance cost is equal to the input length, this means
                // that literally every input has been full-on replaced.  Thus, this is
                // likely not a good 'root' to use for predictions.
                //
                // Logic exception:  0 cost, 0 length != a "replacement".
                return this.knownCost && this.knownCost == this.priorInput.length;
            },
            enumerable: false,
            configurable: true
        });
        return SearchNode;
    }());
    correction.SearchNode = SearchNode;
    var SearchSpaceTier = /** @class */ (function () {
        function SearchSpaceTier(index, initialEdges) {
            this.processed = [];
            this.index = index;
            this.correctionQueue = new models.PriorityQueue(correction.QUEUE_NODE_COMPARATOR, initialEdges);
        }
        SearchSpaceTier.prototype.increaseMaxEditDistance = function () {
            // By extracting the entries from the priority queue and increasing distance outside of it as a batch job,
            // we get an O(N) implementation, rather than the O(N log N) that would result from maintaining the original queue.
            var entries = this.correctionQueue.toArray();
            entries.forEach(function (edge) { edge.calculation = edge.calculation.increaseMaxDistance(); });
            // Since we just modified the stored instances, and the costs may have shifted, we need to re-heapify.
            this.correctionQueue = new models.PriorityQueue(correction.QUEUE_NODE_COMPARATOR, entries);
        };
        return SearchSpaceTier;
    }());
    var SearchResult = /** @class */ (function () {
        function SearchResult(node) {
            this.resultNode = node;
        }
        Object.defineProperty(SearchResult.prototype, "inputSequence", {
            get: function () {
                return this.resultNode.priorInput;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SearchResult.prototype, "matchSequence", {
            get: function () {
                return this.resultNode.calculation.matchSequence;
            },
            enumerable: false,
            configurable: true
        });
        ;
        Object.defineProperty(SearchResult.prototype, "matchString", {
            get: function () {
                return this.matchSequence.map(function (value) { return value.key; }).join('');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SearchResult.prototype, "knownCost", {
            get: function () {
                return this.resultNode.knownCost;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SearchResult.prototype, "inputSamplingCost", {
            get: function () {
                return this.resultNode.inputSamplingCost;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SearchResult.prototype, "totalCost", {
            get: function () {
                return this.resultNode.currentCost;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SearchResult.prototype, "finalTraversal", {
            get: function () {
                return this.resultNode.currentTraversal;
            },
            enumerable: false,
            configurable: true
        });
        return SearchResult;
    }());
    correction.SearchResult = SearchResult;
    // The set of search spaces corresponding to the same 'context' for search.
    // Whenever a wordbreak boundary is crossed, a new instance should be made.
    var SearchSpace = /** @class */ (function () {
        function SearchSpace(model) {
            this.tierOrdering = [];
            this.inputSequence = [];
            this.minInputCost = [];
            // Marks all results that have already been returned since the last input was received.
            this.returnedValues = {};
            // Signals that the edge has already been processed.
            this.processedEdgeSet = {};
            if (!model) {
                throw "The LexicalModel parameter must not be null / undefined.";
            }
            else if (!model.traverseFromRoot) {
                throw "The provided model does not implement the `traverseFromRoot` function, which is needed to support robust correction searching.";
            }
            // Constructs the comparator needed for the following line.
            this.buildQueueSpaceComparator();
            this.selectionQueue = new models.PriorityQueue(this.QUEUE_SPACE_COMPARATOR);
            this.rootNode = new SearchNode(model.traverseFromRoot(), model.toKey ? model.toKey.bind(model) : null);
            this.completedPaths = [this.rootNode];
            // Adds a base level queue to handle initial insertions.
            // Start with _just_ the root node.  Necessary for proper empty-token, empty-input handling!
            var baseTier = new SearchSpaceTier(0, [this.rootNode]);
            this.tierOrdering.push(baseTier);
            this.selectionQueue.enqueue(baseTier);
        }
        SearchSpace.prototype.buildQueueSpaceComparator = function () {
            var searchSpace = this;
            this.QUEUE_SPACE_COMPARATOR = function (space1, space2) {
                var node1 = space1.correctionQueue.peek();
                var node2 = space2.correctionQueue.peek();
                var index1 = space1.index;
                var index2 = space2.index;
                var tierMinCost = 0;
                var sign = 1;
                if (index2 < index1) {
                    var temp = index2;
                    index2 = index1;
                    index1 = temp;
                    sign = -1;
                }
                // Boost the cost of the lower tier by the minimum cost possible for the missing inputs between them.
                // In essence, compare the nodes as if the lower tier had the most likely input appended for each such
                // input missing at the lower tier.
                //
                // A 100% admissible heuristic to favor a deeper search, since the added cost is guaranteed if the path
                // is traversed further.
                //
                // Remember, tier index i's last used input was from input index i-1.
                // As a result, i is the first needed input index, with index2 - 1 the last entry needed to match them.
                for (var i = index1; i < index2; i++) {
                    tierMinCost = tierMinCost + searchSpace.minInputCost[i];
                }
                // Guards, just in case one of the search spaces ever has an empty node.
                if (node1 && node2) {
                    // If node1 is lower-tier, node1 is the one in need of boosted cost.
                    // `sign` flips it when node2 is lower tier.
                    return node1.currentCost - node2.currentCost + sign * tierMinCost;
                }
                else if (node2) {
                    return 1;
                }
                else {
                    return -1;
                }
            };
        };
        SearchSpace.prototype.increaseMaxEditDistance = function () {
            this.tierOrdering.forEach(function (tier) { tier.increaseMaxEditDistance(); });
        };
        SearchSpace.prototype.addInput = function (inputDistribution) {
            this.inputSequence.push(inputDistribution);
            // Assumes that `inputDistribution` is already sorted.
            this.minInputCost.push(-Math.log(inputDistribution[0].p));
            // With a newly-available input, we can extend new input-dependent paths from
            // our previously-reached 'extractedResults' nodes.
            var newlyAvailableEdges = [];
            var batches = this.completedPaths.map(function (node) {
                var deletions = node.buildDeletionEdges(inputDistribution);
                var substitutions = node.buildSubstitutionEdges(inputDistribution);
                return deletions.concat(substitutions);
            });
            // Don't forget to reset the array; the contained nodes no longer reach the search's end.
            this.completedPaths = [];
            this.returnedValues = {};
            batches.forEach(function (batch) {
                newlyAvailableEdges = newlyAvailableEdges.concat(batch);
            });
            // Now that we've built the new edges, we can efficiently construct the new search tier.
            var tier = new SearchSpaceTier(this.tierOrdering.length, newlyAvailableEdges);
            this.tierOrdering.push(tier);
            this.selectionQueue.enqueue(tier);
        };
        // TODO: will want eventually for reversions and/or backspaces
        SearchSpace.prototype.removeLastInput = function () {
            // 1.  truncate all entries from that search tier; we need to 'restore' extractedResults to match
            //     the state that would have existed without the last search tier.
            // 2.  remove the last search tier.  Which may necessitate reconstructing the tier queue, but oh well.
        };
        SearchSpace.prototype.hasNextMatchEntry = function () {
            var topQueue = this.selectionQueue.peek();
            if (topQueue) {
                return topQueue.correctionQueue.count > 0;
            }
            else {
                return false;
            }
        };
        SearchSpace.prototype.handleNextNode = function () {
            if (!this.hasNextMatchEntry()) {
                return { type: 'none' };
            }
            var bestTier = this.selectionQueue.dequeue();
            var currentNode = bestTier.correctionQueue.dequeue();
            var unmatchedResult = {
                type: 'intermediate',
                cost: currentNode.currentCost
            };
            // Have we already processed a matching edge?  If so, skip it.
            // We already know the previous edge is of lower cost.
            if (this.processedEdgeSet[currentNode.mapKey]) {
                this.selectionQueue.enqueue(bestTier);
                return unmatchedResult;
            }
            else {
                this.processedEdgeSet[currentNode.mapKey] = true;
            }
            // Stage 1:  filter out nodes/edges we want to prune
            // Forbid a raw edit-distance of greater than 2.
            // Note:  .knownCost is not scaled, while its contribution to .currentCost _is_ scaled.
            var substitutionsOnly = false;
            if (currentNode.knownCost > 2) {
                return unmatchedResult;
            }
            else if (currentNode.knownCost == 2) {
                // Hard restriction:  no further edits will be supported.  This helps keep the search
                // more narrowly focused.
                substitutionsOnly = true;
            }
            var tierMinCost = 0;
            for (var i = 0; i <= bestTier.index; i++) {
                tierMinCost += this.minInputCost[i];
            }
            // Thresholds _any_ path, partially based on currently-traversed distance.
            // Allows a little 'wiggle room' + 2 "hard" edits.
            // Can be important if needed characters don't actually exist on the keyboard
            // ... or even just not the then-current layer of the keyboard.
            if (currentNode.currentCost > tierMinCost + 2.5 * SearchSpace.EDIT_DISTANCE_COST_SCALE) {
                return unmatchedResult;
            }
            // Stage 2:  build remaining edges
            // Always possible, as this does not require any new input.
            if (!substitutionsOnly) {
                var insertionEdges = currentNode.buildInsertionEdges();
                bestTier.correctionQueue.enqueueAll(insertionEdges);
            }
            if (bestTier.index == this.tierOrdering.length - 1) {
                // It was the final tier - store the node for future reference.
                this.completedPaths.push(currentNode);
                // Since we don't modify any other tier, we may simply reinsert the removed tier.
                this.selectionQueue.enqueue(bestTier);
                return {
                    type: 'complete',
                    cost: currentNode.currentCost,
                    finalNode: currentNode
                };
            }
            else {
                // Time to construct new edges for the next tier!
                var nextTier = this.tierOrdering[bestTier.index + 1];
                var inputIndex = nextTier.index;
                var deletionEdges = [];
                if (!substitutionsOnly) {
                    deletionEdges = currentNode.buildDeletionEdges(this.inputSequence[inputIndex - 1]);
                }
                var substitutionEdges = currentNode.buildSubstitutionEdges(this.inputSequence[inputIndex - 1]);
                // Note:  we're live-modifying the tier's cost here!  The priority queue loses its guarantees as a result.
                nextTier.correctionQueue.enqueueAll(deletionEdges.concat(substitutionEdges));
                // So, we simply rebuild the selection queue.
                this.selectionQueue = new models.PriorityQueue(this.QUEUE_SPACE_COMPARATOR, this.tierOrdering);
                // We didn't reach an end-node, so we just end the iteration and continue the search.
            }
            // If we've somehow fully exhausted all search options, indicate that none remain.
            return unmatchedResult;
        };
        // Current best guesstimate of how compositor will retrieve ideal corrections.
        SearchSpace.prototype.getBestMatches = function (waitMillis) {
            var searchSpace, currentReturns, maxTime, ExecutionTimer, BatchingAssistant, batcher, timer, returnedValues, preprocessedQueue, entry, batch_1, batch_2, timedOut, newResult, batch_3, batch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        searchSpace = this;
                        currentReturns = {};
                        if (waitMillis == 0) {
                            maxTime = Infinity;
                        }
                        else if (waitMillis == undefined || Number.isNaN(waitMillis)) { // also covers null.
                            maxTime = SearchSpace.DEFAULT_ALLOTTED_CORRECTION_TIME_INTERVAL;
                        }
                        else {
                            maxTime = waitMillis;
                        }
                        ExecutionTimer = /** @class */ (function () {
                            function ExecutionTimer(maxExecutionTime, maxTrueTime) {
                                /**
                                 * Used to track intervals in which potential context swaps by the OS may
                                 * have occurred.  Context switches generally seem to pause threads for
                                 * at least 16 ms, while we expect each loop iteration to complete
                                 * within just 1 ms.  So, any possible context switch should have the
                                 * longest observed change in system time.
                                 *
                                 * See `updateOutliers` for more details.
                                 */
                                this.largestIntervals = [0];
                                // JS measures time by the number of milliseconds since Jan 1, 1970.
                                this.loopStart = this.start = Date.now();
                                this.maxExecutionTime = maxExecutionTime;
                                this.maxTrueTime = maxTrueTime;
                            }
                            ExecutionTimer.prototype.startLoop = function () {
                                this.loopStart = Date.now();
                            };
                            ExecutionTimer.prototype.markIteration = function () {
                                var now = Date.now();
                                var delta = now - this.loopStart;
                                this.executionTime += delta;
                                /**
                                 * Update the list of the three longest system-time intervals observed
                                 * for execution of a single loop iteration.
                                 *
                                 * Ignore any zero-ms length intervals; they'd make the logic much
                                 * messier than necessary otherwise.
                                 */
                                if (delta) {
                                    // If the currently-observed interval is longer than the shortest of the 3
                                    // previously-observed longest intervals, replace it.
                                    if (this.largestIntervals.length > 2 && delta > this.largestIntervals[0]) {
                                        this.largestIntervals[0] = delta;
                                    }
                                    else {
                                        this.largestIntervals.push(delta);
                                    }
                                    // Puts the list in ascending order.  Shortest of the list becomes the head,
                                    // longest one the tail.
                                    this.largestIntervals.sort();
                                    // Then, determine if we need to update our outlier-based tweaks.
                                    this.updateOutliers();
                                }
                            };
                            ExecutionTimer.prototype.updateOutliers = function () {
                                /* Base assumption:  since each loop of the search should evaluate within ~1ms,
                                 *                   notably longer execution times are probably context switches.
                                 *
                                 * Base assumption:  OS context switches generally last at least 16ms.  (Based on
                                 *                   a window.setTimeout() usually not evaluating for at least
                                 *                   that long, even if set to 1ms.)
                                 *
                                 * To mitigate these assumptions:  we'll track the execution time of every loop
                                 * iteration.  If the longest observation somehow matches or exceeds the length of
                                 * the next two almost-longest observations twice over... we have a very strong
                                 * 'context switch' candidate.
                                 *
                                 * Or, in near-formal math/stats:  we expect a very low variance in execution
                                 * time among the iterations of the search's loops.  With a very low variance,
                                 * ANY significant proportional spikes in execution time are outliers - outliers
                                 * likely caused by an OS context switch.
                                 *
                                 * Rather than do intensive math, we use a somewhat lazy approach below that
                                 * achieves the same net results given our assumptions, even when relaxed somewhat.
                                 *
                                 * The logic below relaxes the base assumptions a bit to be safe:
                                 * - [2ms, 2ms, 8ms]  will cause 8ms to be seen as an outlier.
                                 * - [2ms, 3ms, 10ms] will cause 10ms to be seen as an outlier.
                                 *
                                 * Ideally:
                                 * - [1ms, 1ms, 4ms] will view 4ms as an outlier.
                                 *
                                 * So we can safely handle slightly longer average intervals and slightly shorter
                                 * OS context-switch time intervals.
                                 */
                                if (this.largestIntervals.length > 2) {
                                    // Precondition:  the `largestIntervals` array is sorted in ascending order.
                                    // Shortest entry is at the head, longest at the tail.
                                    if (this.largestIntervals[2] >= 2 * (this.largestIntervals[0] + this.largestIntervals[1])) {
                                        this.executionTime -= this.largestIntervals[2];
                                        this.largestIntervals.pop();
                                    }
                                }
                            };
                            ExecutionTimer.prototype.shouldTimeout = function () {
                                var now = Date.now();
                                if (now - this.start > this.maxTrueTime) {
                                    return true;
                                }
                                return this.executionTime > this.maxExecutionTime;
                            };
                            ExecutionTimer.prototype.resetOutlierCheck = function () {
                                this.largestIntervals = [];
                            };
                            return ExecutionTimer;
                        }());
                        BatchingAssistant = /** @class */ (function () {
                            function BatchingAssistant() {
                                this.currentCost = Number.MIN_SAFE_INTEGER;
                                this.entries = [];
                            }
                            BatchingAssistant.prototype.checkAndAdd = function (entry) {
                                var result = null;
                                if (entry.currentCost > this.currentCost) {
                                    result = this.tryFinalize();
                                    this.currentCost = entry.currentCost;
                                }
                                // Filter out any duplicated match sequences.  The same match sequence may be reached via
                                // different input sequences, after all.
                                var outputMapKey = entry.calculation.matchSequence.map(function (value) { return value.key; }).join('');
                                // First, ensure the edge has an existing 'shared' cache entry.
                                if (!searchSpace.returnedValues[outputMapKey]) {
                                    searchSpace.returnedValues[outputMapKey] = entry;
                                }
                                // Check the generator's local returned-value cache - this determines whether or not we
                                // need to add a new 'return' to the batch.
                                if (!currentReturns[outputMapKey]) {
                                    this.entries.push(new SearchResult(entry));
                                    currentReturns[outputMapKey] = entry;
                                }
                                return result;
                            };
                            BatchingAssistant.prototype.tryFinalize = function () {
                                var result = null;
                                if (this.entries.length > 0) {
                                    result = this.entries;
                                    this.entries = [];
                                }
                                return result;
                            };
                            return BatchingAssistant;
                        }());
                        batcher = new BatchingAssistant();
                        timer = new ExecutionTimer(maxTime * 1.5, maxTime);
                        returnedValues = Object.values(this.returnedValues);
                        if (!(returnedValues.length > 0)) return [3 /*break*/, 6];
                        preprocessedQueue = new models.PriorityQueue(correction.QUEUE_NODE_COMPARATOR, returnedValues);
                        // Build batches of same-cost entries.
                        timer.startLoop();
                        _a.label = 1;
                    case 1:
                        if (!(preprocessedQueue.count > 0)) return [3 /*break*/, 4];
                        entry = preprocessedQueue.dequeue();
                        // Is the entry a reasonable result?
                        if (entry.isFullReplacement) {
                            // If the entry's 'match' fully replaces the input string, we consider it
                            // unreasonable and ignore it.
                            return [3 /*break*/, 1];
                        }
                        batch_1 = batcher.checkAndAdd(entry);
                        timer.markIteration();
                        if (!batch_1) return [3 /*break*/, 3];
                        // Do not track yielded time.
                        return [4 /*yield*/, batch_1];
                    case 2:
                        // Do not track yielded time.
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 1];
                    case 4:
                        batch_2 = batcher.tryFinalize();
                        if (!batch_2) return [3 /*break*/, 6];
                        // Do not track yielded time.
                        return [4 /*yield*/, batch_2];
                    case 5:
                        // Do not track yielded time.
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        // Stage 2:  the fun part; actually searching!
                        timer.resetOutlierCheck();
                        timer.startLoop();
                        timedOut = false;
                        _a.label = 7;
                    case 7:
                        newResult = void 0;
                        // Search for a 'complete' path, skipping all partial paths as long as time remains.
                        do {
                            newResult = this.handleNextNode();
                            timer.markIteration();
                            if (timer.shouldTimeout()) {
                                timedOut = true;
                            }
                        } while (!timedOut && newResult.type == 'intermediate');
                        batch_3 = void 0;
                        if (newResult.type == 'none') {
                            return [3 /*break*/, 10];
                        }
                        else if (newResult.type == 'complete') {
                            // Is the entry a reasonable result?
                            if (newResult.finalNode.isFullReplacement) {
                                // If the entry's 'match' fully replaces the input string, we consider it
                                // unreasonable and ignore it.  Also, if we've reached this point...
                                // we can(?) assume that everything thereafter is as well.
                                return [3 /*break*/, 10];
                            }
                            batch_3 = batcher.checkAndAdd(newResult.finalNode);
                        }
                        if (!batch_3) return [3 /*break*/, 9];
                        return [4 /*yield*/, batch_3];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        if (!timedOut && this.hasNextMatchEntry()) return [3 /*break*/, 7];
                        _a.label = 10;
                    case 10:
                        batch = batcher.tryFinalize();
                        if (!batch) return [3 /*break*/, 12];
                        return [4 /*yield*/, batch];
                    case 11:
                        _a.sent();
                        _a.label = 12;
                    case 12: return [2 /*return*/, null];
                }
            });
        };
        // p = 1 / (e^4) = 0.01831563888.  This still exceeds many neighboring keys!
        // p = 1 / (e^5) = 0.00673794699.  Strikes a good balance.
        // Should easily give priority to neighboring keys before edit-distance kicks in (when keys are a bit ambiguous)
        SearchSpace.EDIT_DISTANCE_COST_SCALE = 5;
        SearchSpace.MIN_KEYSTROKE_PROBABILITY = 0.0001;
        SearchSpace.DEFAULT_ALLOTTED_CORRECTION_TIME_INTERVAL = 33; // in milliseconds.
        return SearchSpace;
    }());
    correction.SearchSpace = SearchSpace;
})(correction || (correction = {}));
/// <reference path="distance-modeler.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var correction;
(function (correction) {
    function textToCharTransforms(text, transformId) {
        var perCharTransforms = [];
        for (var i = 0; i < text.kmwLength(); i++) {
            var char = text.kmwCharAt(i); // is SMP-aware
            var transform = {
                insert: char,
                deleteLeft: 0,
                id: transformId
            };
            perCharTransforms.push(transform);
        }
        return perCharTransforms;
    }
    var TrackedContextSuggestion = /** @class */ (function () {
        function TrackedContextSuggestion() {
        }
        return TrackedContextSuggestion;
    }());
    correction.TrackedContextSuggestion = TrackedContextSuggestion;
    var TrackedContextToken = /** @class */ (function () {
        function TrackedContextToken() {
            this.transformDistributions = [];
            this.activeReplacementId = -1;
        }
        Object.defineProperty(TrackedContextToken.prototype, "currentText", {
            get: function () {
                if (this.replacementText === undefined || this.replacementText === null) {
                    return this.raw;
                }
                else {
                    return this.replacementText;
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TrackedContextToken.prototype, "replacement", {
            get: function () {
                var replacementId = this.activeReplacementId;
                return this.replacements.find(function (replacement) {
                    return replacement.suggestion.id == replacementId;
                });
            },
            enumerable: false,
            configurable: true
        });
        TrackedContextToken.prototype.revert = function () {
            delete this.activeReplacementId;
        };
        return TrackedContextToken;
    }());
    correction.TrackedContextToken = TrackedContextToken;
    var TrackedContextState = /** @class */ (function () {
        function TrackedContextState(obj) {
            // Tracks all search spaces starting at the current token.
            // In the lm-layer's current form, this should only ever have one entry.
            // Leaves 'design space' for if/when we add support for phrase-level corrections/predictions.
            this.searchSpace = [];
            if (obj instanceof TrackedContextState) {
                var source = obj;
                // Be sure to deep-copy the tokens!  Pointer-aliasing is bad here.
                this.tokens = source.tokens.map(function (token) {
                    var copy = new TrackedContextToken();
                    copy.raw = token.raw;
                    copy.replacements = token.replacements;
                    copy.activeReplacementId = token.activeReplacementId;
                    copy.transformDistributions = token.transformDistributions;
                    if (token.replacementText) {
                        copy.replacementText = token.replacementText;
                    }
                    return copy;
                });
                this.searchSpace = obj.searchSpace;
                this.indexOffset = 0;
                this.model = obj.model;
            }
            else {
                var lexicalModel = obj;
                this.tokens = [];
                this.indexOffset = Number.MIN_SAFE_INTEGER;
                this.model = lexicalModel;
                if (lexicalModel && lexicalModel.traverseFromRoot) {
                    this.searchSpace = [new correction.SearchSpace(lexicalModel)];
                }
            }
        }
        Object.defineProperty(TrackedContextState.prototype, "head", {
            get: function () {
                return this.tokens[0];
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TrackedContextState.prototype, "tail", {
            get: function () {
                return this.tokens[this.tokens.length - 1];
            },
            enumerable: false,
            configurable: true
        });
        TrackedContextState.prototype.popHead = function () {
            this.tokens.splice(0, 2);
            this.indexOffset -= 1;
        };
        TrackedContextState.prototype.pushTail = function (token) {
            if (this.model && this.model.traverseFromRoot) {
                this.searchSpace = [new correction.SearchSpace(this.model)]; // yeah, need to update SearchSpace for compatibility
            }
            else {
                this.searchSpace = [];
            }
            this.tokens.push(token);
            var state = this;
            if (state.searchSpace.length > 0) {
                token.transformDistributions.forEach(function (distrib) { return state.searchSpace[0].addInput(distrib); });
            }
        };
        TrackedContextState.prototype.pushWhitespaceToTail = function (transformDistribution) {
            if (transformDistribution === void 0) { transformDistribution = null; }
            var whitespaceToken = new TrackedContextToken();
            // Track the Transform that resulted in the whitespace 'token'.
            // Will be needed for phrase-level correction/prediction.
            whitespaceToken.transformDistributions = transformDistribution ? [transformDistribution] : [];
            whitespaceToken.raw = null;
            this.tokens.push(whitespaceToken);
        };
        /**
         * Used for 14.0's backspace workaround, which flattens all previous Distribution<Transform>
         * entries because of limitations with direct use of backspace transforms.
         * @param tokenText
         * @param transformId
         */
        TrackedContextState.prototype.replaceTailForBackspace = function (tokenText, transformId) {
            this.tokens.pop();
            // It's a backspace transform; time for special handling!
            //
            // For now, with 14.0, we simply compress all remaining Transforms for the token into
            // multiple single-char transforms.  Probabalistically modeling BKSP is quite complex,
            // so we simplify by assuming everything remaining after a BKSP is 'true' and 'intended' text.
            //
            // Note that we cannot just use a single, monolithic transform at this point b/c
            // of our current edit-distance optimization strategy; diagonalization is currently...
            // not very compatible with that.
            var backspacedTokenContext = textToCharTransforms(tokenText, transformId).map(function (transform) {
                return [{ sample: transform, p: 1.0 }];
            });
            var compactedToken = new TrackedContextToken();
            compactedToken.raw = tokenText;
            compactedToken.transformDistributions = backspacedTokenContext;
            this.pushTail(compactedToken);
        };
        TrackedContextState.prototype.updateTail = function (transformDistribution, tokenText) {
            var editedToken = this.tail;
            // Preserve existing text if new text isn't specified.
            tokenText = tokenText || (tokenText === '' ? '' : editedToken.raw);
            if (transformDistribution && transformDistribution.length > 0) {
                editedToken.transformDistributions.push(transformDistribution);
                if (this.searchSpace) {
                    this.searchSpace.forEach(function (space) { return space.addInput(transformDistribution); });
                }
            }
            // Replace old token's raw-text with new token's raw-text.
            editedToken.raw = tokenText;
        };
        TrackedContextState.prototype.toRawTokenization = function () {
            var e_6, _a;
            var sequence = [];
            try {
                for (var _b = __values(this.tokens), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var token = _c.value;
                    // Hide any tokens representing wordbreaks.  (Thinking ahead to phrase-level possibilities)
                    if (token.currentText !== null) {
                        sequence.push(token.currentText);
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
            return sequence;
        };
        return TrackedContextState;
    }());
    correction.TrackedContextState = TrackedContextState;
    var CircularArray = /** @class */ (function () {
        function CircularArray(size) {
            if (size === void 0) { size = CircularArray.DEFAULT_ARRAY_SIZE; }
            this.currentHead = 0;
            this.currentTail = 0;
            this.circle = Array(size);
        }
        Object.defineProperty(CircularArray.prototype, "count", {
            get: function () {
                var diff = this.currentHead - this.currentTail;
                if (diff < 0) {
                    diff = diff + this.circle.length;
                }
                return diff;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CircularArray.prototype, "maxCount", {
            get: function () {
                return this.circle.length;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CircularArray.prototype, "oldest", {
            get: function () {
                if (this.count == 0) {
                    return undefined;
                }
                return this.item(0);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CircularArray.prototype, "newest", {
            get: function () {
                if (this.count == 0) {
                    return undefined;
                }
                return this.item(this.count - 1);
            },
            enumerable: false,
            configurable: true
        });
        CircularArray.prototype.enqueue = function (item) {
            var prevItem = null;
            var nextHead = (this.currentHead + 1) % this.maxCount;
            if (nextHead == this.currentTail) {
                prevItem = this.circle[this.currentTail];
                this.currentTail = (this.currentTail + 1) % this.maxCount;
            }
            this.circle[this.currentHead] = item;
            this.currentHead = nextHead;
            return prevItem;
        };
        CircularArray.prototype.dequeue = function () {
            if (this.currentTail == this.currentHead) {
                return null;
            }
            else {
                var item = this.circle[this.currentTail];
                this.currentTail = (this.currentTail + 1) % this.maxCount;
                return item;
            }
        };
        CircularArray.prototype.popNewest = function () {
            if (this.currentTail == this.currentHead) {
                return null;
            }
            else {
                var item = this.circle[this.currentHead];
                this.currentHead = (this.currentHead - 1 + this.maxCount) % this.maxCount;
                return item;
            }
        };
        /**
         * Returns items contained within the circular array, ordered from 'oldest' to 'newest' -
         * the same order in which the items will be dequeued.
         * @param index
         */
        CircularArray.prototype.item = function (index) {
            if (index >= this.count) {
                throw "Invalid array index";
            }
            var mappedIndex = (this.currentTail + index) % this.maxCount;
            return this.circle[mappedIndex];
        };
        CircularArray.DEFAULT_ARRAY_SIZE = 5;
        return CircularArray;
    }());
    var ContextTracker = /** @class */ (function (_super) {
        __extends(ContextTracker, _super);
        function ContextTracker() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ContextTracker.attemptMatchContext = function (tokenizedContext, matchState, transformDistribution) {
            // Map the previous tokenized state to an edit-distance friendly version.
            var matchContext = matchState.toRawTokenization();
            // Inverted order, since 'match' existed before our new context.
            var mapping = correction.ClassicalDistanceCalculation.computeDistance(matchContext.map(function (value) { return ({ key: value }); }), tokenizedContext.map(function (value) { return ({ key: value }); }), 1);
            var editPath = mapping.editPath();
            var poppedHead = false;
            var pushedTail = false;
            // Matters greatly when starting from a nil context.
            if (editPath.length > 1) {
                // First entry:  may not be an 'insert' or a 'transpose' op.
                // 'insert' allowed if the next token is 'substitute', as this may occur with an edit path of length 2.
                if ((editPath[0] == 'insert' && !(editPath[1] == 'substitute' && editPath.length == 2)) || editPath[0].indexOf('transpose') >= 0) {
                    return null;
                }
                else if (editPath[0] == 'delete') {
                    poppedHead = true; // a token from the previous state has been wholly removed.
                }
            }
            // Last entry:  may not be a 'delete' or a 'transpose' op.
            var tailIndex = editPath.length - 1;
            var ignorePenultimateMatch = false;
            if (editPath[tailIndex] == 'delete' || editPath[0].indexOf('transpose') >= 0) {
                return null;
            }
            else if (editPath[tailIndex] == 'insert') {
                pushedTail = true;
            }
            else if (tailIndex > 0 && editPath[tailIndex - 1] == 'insert' && editPath[tailIndex] == 'substitute') {
                // Tends to happen when accepting suggestions.
                pushedTail = true;
                ignorePenultimateMatch = true;
            }
            // Can happen for the first text input after backspace deletes a wordbreaking character,
            // thus the new input continues a previous word while dropping the empty word after
            // that prior wordbreaking character.
            //
            // We can't handle it reliably from this match state, but a previous entry (without the empty token)
            // should still be in the cache and will be reliable for this example case.
            if (tailIndex > 0 && editPath[tailIndex - 1] == 'delete' && editPath[tailIndex] == 'substitute') {
                return null;
            }
            // Now to check everything in-between:  should be exclusively 'match'es.
            for (var index = 1; index < editPath.length - (ignorePenultimateMatch ? 2 : 1); index++) {
                if (editPath[index] != 'match') {
                    return null;
                }
            }
            // If we've made it here... success!  We have a context match!
            var state;
            if (pushedTail) {
                // On suggestion acceptance, we should update the previous final token.
                // We do it first so that the acceptance is replicated in the new TrackedContextState
                // as well.
                if (ignorePenultimateMatch) {
                    // For this case, we were likely called by ModelCompositor.acceptSuggestion(), which
                    // would have marked the accepted suggestion.
                    matchState.tail.replacementText = tokenizedContext[tokenizedContext.length - 2];
                }
                state = new TrackedContextState(matchState);
            }
            else {
                // Since we're continuing a previously-cached context, we can reuse the same SearchSpace
                // to continue making predictions.
                state = matchState;
            }
            var hasDistribution = transformDistribution && Array.isArray(transformDistribution);
            var primaryInput = hasDistribution ? transformDistribution[0].sample : null;
            if (primaryInput && primaryInput.insert == "" && primaryInput.deleteLeft == 0 && !primaryInput.deleteRight) {
                primaryInput = null;
            }
            var isWhitespace = primaryInput && TransformUtils.isWhitespace(primaryInput);
            var isBackspace = primaryInput && TransformUtils.isBackspace(primaryInput);
            var finalToken = tokenizedContext[tokenizedContext.length - 1];
            /* Assumption:  This is an adequate check for its two sub-branches.
             *
             * Basis:
             * - Assumption: one keystroke may only cause a single token to rotate out of context.
             *   - That is, no "reasonable" keystroke would emit enough code points to 'bump' two words simultaneously.
             *   - ... This one may need to be loosened a bit... but it should be enough for initial correction testing as-is.
             * - Assumption:  one keystroke may only cause a single token to be appended to the context
             *   - That is, no "reasonable" keystroke would emit a Transform adding two separate word tokens
             *     - For languages using whitespace to word-break, said keystroke would have to include said whitespace to break the assumption.
             */
            // If there is/was more than one context token available...
            if (editPath.length > 1) {
                // We're removing a context token, but at least one remains.
                if (poppedHead) {
                    state.popHead();
                }
                // We're adding an additional context token.
                if (pushedTail) {
                    var tokenizedTail = tokenizedContext[tokenizedContext.length - 1];
                    /*
                     * Common-case:  most transforms that trigger this case are from pure-whitespace Transforms.  MOST.
                     *
                     * Less-common, but noteworthy:  some wordbreaks may occur without whitespace.  Example:
                     * `"o` => ['"', 'o'].  Make sure to double-check against `tokenizedContext`!
                     */
                    var pushedToken = new TrackedContextToken();
                    pushedToken.raw = tokenizedTail;
                    if (isWhitespace || !primaryInput) {
                        state.pushWhitespaceToTail(transformDistribution !== null && transformDistribution !== void 0 ? transformDistribution : []);
                        // Continuing the earlier assumption, that 'pure-whitespace Transform' does not emit any initial characters
                        // for the new word (token), so the input keystrokes do not correspond to the new text token.
                        pushedToken.transformDistributions = [];
                    }
                    else {
                        state.pushWhitespaceToTail();
                        // Assumption: Since we only allow one-transform-at-a-time changes between states, we shouldn't be missing
                        // any metadata used to construct the new context state token.
                        pushedToken.transformDistributions = transformDistribution ? [transformDistribution] : [];
                    }
                    state.pushTail(pushedToken);
                }
                else { // We're editing the final context token.
                    // TODO:  Assumption:  we didn't 'miss' any inputs somehow.
                    //        As is, may be prone to fragility should the lm-layer's tracked context 'desync' from its host's.
                    if (isBackspace) {
                        state.replaceTailForBackspace(finalToken, primaryInput.id);
                    }
                    else {
                        state.updateTail(primaryInput ? transformDistribution : null, finalToken);
                    }
                }
                // There is only one word in the context.
            }
            else {
                // TODO:  Assumption:  we didn't 'miss' any inputs somehow.
                //        As is, may be prone to fragility should the lm-layer's tracked context 'desync' from its host's.
                if (editPath[tailIndex] == 'insert') {
                    // Construct appropriate initial token.
                    var token = new TrackedContextToken();
                    token.raw = tokenizedContext[0];
                    token.transformDistributions = [transformDistribution];
                    state.pushTail(token);
                }
                else { // Edit the lone context token.
                    // Consider backspace entry for this case?
                    if (isBackspace) {
                        state.replaceTailForBackspace(finalToken, primaryInput.id);
                    }
                    else {
                        state.updateTail(primaryInput ? transformDistribution : null, finalToken);
                    }
                }
            }
            return state;
        };
        ContextTracker.modelContextState = function (tokenizedContext, transformDistribution, lexicalModel) {
            var baseTokens = tokenizedContext.map(function (entry) {
                var token = new TrackedContextToken();
                token.raw = entry;
                if (token.raw) {
                    token.transformDistributions = textToCharTransforms(token.raw).map(function (transform) {
                        return [{ sample: transform, p: 1.0 }];
                    });
                }
                else {
                    // Helps model context-final wordbreaks.
                    token.transformDistributions = [];
                }
                return token;
            });
            // And now build the final context state object, which includes whitespace 'tokens'.
            var state = new TrackedContextState(lexicalModel);
            if (baseTokens.length > 0) {
                state.pushTail(baseTokens.splice(0, 1)[0]);
            }
            while (baseTokens.length > 0) {
                state.pushWhitespaceToTail();
                state.pushTail(baseTokens.splice(0, 1)[0]);
            }
            if (state.tokens.length == 0) {
                var token = new TrackedContextToken();
                token.raw = '';
                state.pushTail(token);
            }
            return state;
        };
        /**
         * Compares the current, post-input context against the most recently-seen contexts from previous prediction calls, returning
         * the most information-rich `TrackedContextState` possible.  If a match is found, the state will be annotated with the
         * input information provided to previous prediction calls and persisted correction-search calculations for re-use.
         *
         * @param model
         * @param context
         * @param transformDistribution
         */
        ContextTracker.prototype.analyzeState = function (model, context, transformDistribution) {
            if (!model.traverseFromRoot) {
                // Assumption:  LexicalModel provides a valid traverseFromRoot function.  (Is technically optional)
                // Without it, no 'corrections' may be made; the model can only be used to predict, not correct.
                throw "This lexical model does not provide adequate data for correction algorithms and context reuse";
            }
            var tokenizedContext = models.tokenize(model.wordbreaker || wordBreakers.default, context);
            if (tokenizedContext.left.length > 0) {
                for (var i = this.count - 1; i >= 0; i--) {
                    var resultState = ContextTracker.attemptMatchContext(tokenizedContext.left, this.item(i), transformDistribution);
                    if (resultState) {
                        resultState.taggedContext = context;
                        if (resultState != this.item(i)) {
                            this.enqueue(resultState);
                        }
                        return resultState;
                    }
                }
            }
            // Else:  either empty OR we've detected a 'new context'.  Initialize from scratch; no prior input information is
            // available.  Only the results of the prior inputs are known.
            //
            // Assumption:  as a caret needs to move to context before any actual transform distributions occur,
            // this state is only reached on caret moves; thus, transformDistribution is actually just a single null transform.
            var state = ContextTracker.modelContextState(tokenizedContext.left, transformDistribution, model);
            state.taggedContext = context;
            this.enqueue(state);
            return state;
        };
        return ContextTracker;
    }(CircularArray));
    correction.ContextTracker = ContextTracker;
})(correction || (correction = {}));
/// <reference path="correction/context-tracker.ts" />
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ModelCompositor = /** @class */ (function () {
    function ModelCompositor(lexicalModel, testMode) {
        this.SUGGESTION_ID_SEED = 0;
        this.testMode = false;
        this.lexicalModel = lexicalModel;
        if (lexicalModel.traverseFromRoot) {
            this.contextTracker = new correction.ContextTracker();
        }
        this.punctuation = ModelCompositor.determinePunctuationFromModel(lexicalModel);
        this.testMode = !!testMode;
    }
    ModelCompositor.prototype.predictFromCorrections = function (corrections, context) {
        var e_7, _a;
        var returnedPredictions = [];
        var _loop_2 = function (correction_1) {
            var predictions = this_2.lexicalModel.predict(correction_1.sample, context);
            var predictionSet = predictions.map(function (pair) {
                var transform = correction_1.sample;
                var inputProb = correction_1.p;
                // Let's not rely on the model to copy transform IDs.
                // Only bother is there IS an ID to copy.
                if (transform.id !== undefined) {
                    pair.sample.transformId = transform.id;
                }
                var prediction = { sample: pair.sample, p: pair.p * inputProb };
                return prediction;
            }, this_2);
            returnedPredictions = returnedPredictions.concat(predictionSet);
        };
        var this_2 = this;
        try {
            for (var corrections_1 = __values(corrections), corrections_1_1 = corrections_1.next(); !corrections_1_1.done; corrections_1_1 = corrections_1.next()) {
                var correction_1 = corrections_1_1.value;
                _loop_2(correction_1);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (corrections_1_1 && !corrections_1_1.done && (_a = corrections_1.return)) _a.call(corrections_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
        return returnedPredictions;
    };
    ModelCompositor.prototype.predict = function (transformDistribution, context) {
        var e_8, _a, e_9, _b;
        var suggestionDistribution = [];
        var lexicalModel = this.lexicalModel;
        var punctuation = this.punctuation;
        if (!(transformDistribution instanceof Array)) {
            transformDistribution = [{ sample: transformDistribution, p: 1.0 }];
        }
        else if (transformDistribution.length == 0) {
            /*
               Robust stop-gap: if our other filters somehow fail, this fixes the
               zero-length array by making it match the form of the array that
               would result if it were instead called with the other legal
               parameter type - a single Transform.
      
               Unfortunately, the method will lack all data about even
               the original keystroke that resulted in the call... but this way,
               we can at least get some predictions rather than shortcutting
               and producing none whatsoever.
            */
            transformDistribution.push({
                sample: {
                    insert: '',
                    deleteLeft: 0
                },
                p: 1.0
            });
        }
        var inputTransform = transformDistribution.sort(function (a, b) {
            return b.p - a.p;
        })[0].sample;
        // Only allow new-word suggestions if space was the most likely keypress.
        var allowSpace = TransformUtils.isWhitespace(inputTransform);
        var allowBksp = TransformUtils.isBackspace(inputTransform);
        var postContext = models.applyTransform(inputTransform, context);
        var keepOptionText = this.wordbreak(postContext);
        var keepOption = null;
        var rawPredictions = [];
        // Used to restore whitespaces if operations would remove them.
        var prefixTransform;
        var postContextState = null;
        // Section 1:  determining 'prediction roots'.
        if (!this.contextTracker) {
            var predictionRoots = void 0;
            // Generates raw prediction distributions for each valid input.  Can only 'correct'
            // against the final input.
            //
            // This is the old, 12.0-13.0 'correction' style.
            if (allowSpace) {
                // Detect start of new word; prevent whitespace loss here.
                predictionRoots = [{ sample: inputTransform, p: 1.0 }];
                prefixTransform = inputTransform;
            }
            else {
                predictionRoots = transformDistribution.map(function (alt) {
                    var transform = alt.sample;
                    // Filter out special keys unless they're expected.
                    if (TransformUtils.isWhitespace(transform) && !allowSpace) {
                        return null;
                    }
                    else if (TransformUtils.isBackspace(transform) && !allowBksp) {
                        return null;
                    }
                    return alt;
                });
            }
            // Remove `null` entries.
            predictionRoots = predictionRoots.filter(function (tuple) { return !!tuple; });
            // Running in bulk over all suggestions, duplicate entries may be possible.
            rawPredictions = this.predictFromCorrections(predictionRoots, context);
        }
        else {
            // Token replacement benefits greatly from knowledge of the prior context state.
            var contextState = this.contextTracker.analyzeState(this.lexicalModel, context, null);
            // Corrections and predictions are based upon the post-context state, though.
            postContextState = this.contextTracker.analyzeState(this.lexicalModel, postContext, !TransformUtils.isEmpty(inputTransform) ?
                transformDistribution :
                null);
            // TODO:  Should we filter backspaces & whitespaces out of the transform distribution?
            //        Ideally, the answer (in the future) will be no, but leaving it in right now may pose an issue.
            // Rather than go "full hog" and make a priority queue out of the eventual, future competing search spaces...
            // let's just note that right now, there will only ever be one.
            //
            // The 'eventual' logic will be significantly more complex, though still manageable.
            var searchSpace = postContextState.searchSpace[0];
            // No matter the prediction, once we know the root of the prediction, we'll always 'replace' the
            // same amount of text.  We can handle this before the big 'prediction root' loop.
            var deleteLeft_1 = 0;
            // The amount of text to 'replace' depends upon whatever sort of context change occurs
            // from the received input.
            var postContextTokens = postContextState.tokens;
            var postContextLength = postContextTokens.length;
            var contextLengthDelta = postContextTokens.length - contextState.tokens.length;
            // If the context now has more tokens, the token we'll be 'predicting' didn't originally exist.
            if (postContextLength == 0 || contextLengthDelta > 0) {
                // As the word/token being corrected/predicted didn't originally exist, there's no
                // part of it to 'replace'.
                deleteLeft_1 = 0;
                // If the new token is due to whitespace or due to a different input type that would
                // likely imply a tokenization boundary...
                if (TransformUtils.isWhitespace(inputTransform)) {
                    /* TODO:  consider/implement:  the second half of the comment above.
                     * For example:  on input of a `'`, predict new words instead of replacing the `'`.
                     * (since after a letter, the `'` will be ignored, anyway)
                     *
                     * Idea:  if the model's most likely prediction (with no root) would make a new
                     * token if appended to the current token, that's probably a good case.
                     * Keeps the check simple & quick.
                     *
                     * Might need a mixed mode, though:  ';' is close enough that `l` is a reasonable
                     * fat-finger guess.   So yeah, we're not addressing this idea right now.
                     * - so... consider multiple context behavior angles when building prediction roots?
                     *
                     * May need something similar to help handle contractions during their construction,
                     * but that'd be within `ContextTracker`.
                     * can' => [`can`, `'`]
                     * can't => [`can't`]  (WB6, 7 of https://unicode.org/reports/tr29/#Word_Boundary_Rules)
                     *
                     * (Would also helps WB7b+c for Hebrew text)
                     */
                    // Infer 'new word' mode, even if we received new text when reaching
                    // this position.  That new text didn't exist before, so still - nothing
                    // to 'replace'.
                    prefixTransform = inputTransform;
                    context = postContext; // As far as predictions are concerned, the post-context state
                    // should not be replaced.  Predictions are to be rooted on
                    // text "up for correction" - so we want a null root for this
                    // branch.
                    contextState = postContextState;
                }
                // If the tokenized context length is shorter... sounds like a backspace (or similar).
            }
            else if (contextLengthDelta < 0) {
                /* Ooh, we've dropped context here.  Almost certainly from a backspace.
                 * Even if we drop multiple tokens... well, we know exactly how many chars
                 * were actually deleted - `inputTransform.deleteLeft`.
                 * Since we replace a word being corrected/predicted, we take length of the remaining
                 * context's tail token in addition to however far was deleted to reach that state.
                 */
                deleteLeft_1 = this.wordbreak(postContext).kmwLength() + inputTransform.deleteLeft;
            }
            else {
                // Suggestions are applied to the pre-input context, so get the token's original length.
                // We're on the same token, so just delete its text for the replacement op.
                deleteLeft_1 = this.wordbreak(context).kmwLength();
            }
            // Is the token under construction newly-constructed / is there no pre-existing root?
            // If so, we want to strongly avoid overcorrection, even for 'nearby' keys.
            // (Strong lexical frequency differences can easily cause overcorrection when only
            // one key's available.)
            //
            // NOTE:  we only want this applied word-initially, when any corrections 'correct'
            // 100% of the word.  Things are generally fine once it's not "all or nothing."
            var tailToken = postContextTokens[postContextTokens.length - 1];
            var isTokenStart_1 = tailToken.transformDistributions.length <= 1;
            // TODO:  whitespace, backspace filtering.  Do it here.
            //        Whitespace is probably fine, actually.  Less sure about backspace.
            var bestCorrectionCost = void 0;
            var SEARCH_TIMEOUT = this.testMode ? 0 : correction.SearchSpace.DEFAULT_ALLOTTED_CORRECTION_TIME_INTERVAL;
            try {
                for (var _c = __values(searchSpace.getBestMatches(SEARCH_TIMEOUT)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var matches = _d.value;
                    // Corrections obtained:  now to predict from them!
                    var predictionRoots = matches.map(function (match) {
                        var correction = match.matchString;
                        // Worth considering:  extend Traversal to allow direct prediction lookups?
                        // let traversal = match.finalTraversal;
                        // Find a proper Transform ID to map the correction to.
                        // Without it, we can't apply the suggestion.
                        var finalInput;
                        if (match.inputSequence.length > 0) {
                            finalInput = match.inputSequence[match.inputSequence.length - 1].sample;
                        }
                        else {
                            finalInput = inputTransform; // A fallback measure.  Greatly matters for empty contexts.
                        }
                        // Replace the existing context with the correction.
                        var correctionTransform = {
                            insert: correction,
                            deleteLeft: deleteLeft_1,
                            id: inputTransform.id // The correction should always be based on the most recent external transform/transcription ID.
                        };
                        var rootCost = match.totalCost;
                        /* If we're dealing with the FIRST keystroke of a new sequence, we'll **dramatically** boost
                         * the exponent to ensure only VERY nearby corrections have a chance of winning, and only if
                         * there are significantly more likely words.  We only need this to allow very minor fat-finger
                         * adjustments for 100% keystroke-sequence corrections in order to prevent finickiness on
                         * key borders.
                         *
                         * Technically, the probabilities this produces won't be normalized as-is... but there's no
                         * true NEED to do so for it, even if it'd be 'nice to have'.  Consistently tracking when
                         * to apply it could become tricky, so it's simpler to leave out.
                         *
                         * Worst-case, it's possible to temporarily add normalization if a code deep-dive
                         * is needed in the future.
                         */
                        if (isTokenStart_1) {
                            /* Suppose a key distribution:  most likely with p=0.5, second-most with 0.4 - a pretty
                             * ambiguous case that would only arise very near the center of the boundary between two keys.
                             * Raising (0.5/0.4)^16 ~= 35.53.  (At time of writing, SINGLE_CHAR_KEY_PROB_EXPONENT = 16.)
                             * That seems 'within reason' for correction very near boundaries.
                             *
                             * So, with the second-most-likely key being that close in probability, its best suggestion
                             * must be ~ 35.5x more likely than that of the truly-most-likely key to "win".  So, it's not
                             * a HARD cutoff, but more of a 'soft' one.  Keeping the principles in mind documented above,
                             * it's possible to tweak this to a more harsh or lenient setting if desired, rather than
                             * being totally "all or nothing" on which key is taken for highly-ambiguous keypresses.
                             */
                            rootCost *= ModelCompositor.SINGLE_CHAR_KEY_PROB_EXPONENT; // note the `Math.exp` below.
                        }
                        return {
                            sample: correctionTransform,
                            p: Math.exp(-rootCost)
                        };
                    }, this);
                    // Running in bulk over all suggestions, duplicate entries may be possible.
                    var predictions = this.predictFromCorrections(predictionRoots, context);
                    // Only set 'best correction' cost when a correction ACTUALLY YIELDS predictions.
                    if (predictions.length > 0 && bestCorrectionCost === undefined) {
                        bestCorrectionCost = -Math.log(predictionRoots[0].p);
                    }
                    rawPredictions = rawPredictions.concat(predictions);
                    // TODO:  We don't currently de-duplicate predictions at this point quite yet, so
                    // it's technically possible that we return too few.
                    var correctionCost = matches[0].totalCost;
                    // Searching a bit longer is permitted when no predictions have been found.
                    if (correctionCost >= bestCorrectionCost + 8) {
                        break;
                        // If enough have been found, we're safe to terminate earlier.
                    }
                    else if (rawPredictions.length >= ModelCompositor.MAX_SUGGESTIONS) {
                        if (correctionCost >= bestCorrectionCost + 4) { // e^-4 = 0.0183156388.  Allows "80%" of an extra edit.
                            // Very useful for stopping 'sooner' when words reach a sufficient length.
                            break;
                        }
                        else {
                            // Sort the prediction list; we need them in descending order for the next check.
                            rawPredictions.sort(function (a, b) {
                                return b.p - a.p;
                            });
                            // If the best suggestion from the search's current tier fails to beat the worst
                            // pending suggestion from previous tiers, assume all further corrections will
                            // similarly fail to win; terminate the search-loop.
                            if (rawPredictions[ModelCompositor.MAX_SUGGESTIONS - 1].p > Math.exp(-correctionCost)) {
                                break;
                            }
                        }
                    }
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_8) throw e_8.error; }
            }
        }
        // Section 2 - post-analysis for our generated predictions, managing 'keep'.
        // Assumption:  Duplicated 'displayAs' properties indicate duplicated Suggestions.
        // When true, we can use an 'associative array' to de-duplicate everything.
        var suggestionDistribMap = {};
        var currentCasing = null;
        if (lexicalModel.languageUsesCasing) {
            currentCasing = this.detectCurrentCasing(postContext);
        }
        var baseWord = this.wordbreak(context);
        try {
            // Deduplicator + annotator of 'keep' suggestions.
            for (var rawPredictions_1 = __values(rawPredictions), rawPredictions_1_1 = rawPredictions_1.next(); !rawPredictions_1_1.done; rawPredictions_1_1 = rawPredictions_1.next()) {
                var prediction = rawPredictions_1_1.value;
                // Combine duplicate samples.
                var displayText = prediction.sample.displayAs;
                var preserveAsKeep = displayText == keepOptionText;
                // De-duplication should be case-insensitive, but NOT
                // diacritic-insensitive.
                if (this.lexicalModel.languageUsesCasing) {
                    preserveAsKeep = preserveAsKeep || displayText == this.lexicalModel.applyCasing('lower', keepOptionText);
                }
                if (preserveAsKeep) {
                    // Preserve the original, pre-keyed version of the text.
                    if (!keepOption) {
                        var baseTransform = prediction.sample.transform;
                        var keepTransform = {
                            insert: keepOptionText,
                            deleteLeft: baseTransform.deleteLeft,
                            deleteRight: baseTransform.deleteRight,
                            id: baseTransform.id
                        };
                        var intermediateKeep = models.transformToSuggestion(keepTransform, prediction.p);
                        keepOption = this.toAnnotatedSuggestion(intermediateKeep, 'keep', models.QuoteBehavior.noQuotes);
                        keepOption.matchesModel = true;
                        // Since we replaced the original Suggestion with a keep-annotated one,
                        // we must manually preserve the transform ID.
                        keepOption.transformId = prediction.sample.transformId;
                    }
                    else if (keepOption.p && prediction.p) {
                        keepOption.p += prediction.p;
                    }
                }
                else {
                    // Apply capitalization rules now; facilitates de-duplication of suggestions
                    // that may be caused as a result.
                    //
                    // Example:  "apple" and "Apple" are separate when 'lower', but identical for 'initial' and 'upper'.
                    if (currentCasing && currentCasing != 'lower') {
                        this.applySuggestionCasing(prediction.sample, baseWord, currentCasing);
                        // update the mapping string, too.
                        displayText = prediction.sample.displayAs;
                    }
                    var existingSuggestion = suggestionDistribMap[displayText];
                    if (existingSuggestion) {
                        existingSuggestion.p += prediction.p;
                    }
                    else {
                        suggestionDistribMap[displayText] = prediction;
                    }
                }
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (rawPredictions_1_1 && !rawPredictions_1_1.done && (_b = rawPredictions_1.return)) _b.call(rawPredictions_1);
            }
            finally { if (e_9) throw e_9.error; }
        }
        // Generate a default 'keep' option if one was not otherwise produced.
        if (!keepOption && keepOptionText != '') {
            // IMPORTANT:  duplicate the original transform.  Causes nasty side-effects
            // for context-tracking otherwise!
            var keepTransform = __assign({}, inputTransform);
            // 1 is a filler value; goes unused b/c is for a 'keep'.
            var keepSuggestion = models.transformToSuggestion(keepTransform, 1);
            // This is the one case where the transform doesn't insert the full word; we need to override the displayAs param.
            keepSuggestion.displayAs = keepOptionText;
            keepOption = this.toAnnotatedSuggestion(keepSuggestion, 'keep');
            keepOption.matchesModel = false;
        }
        // Section 3:  Finalize suggestions, truncate list to the N (MAX_SUGGESTIONS) most optimal, return.
        // Now that we've calculated a unique set of probability masses, time to make them into a proper
        // distribution and prep for return.
        for (var key in suggestionDistribMap) {
            var pair = suggestionDistribMap[key];
            suggestionDistribution.push(pair);
        }
        suggestionDistribution = suggestionDistribution.sort(function (a, b) {
            return b.p - a.p; // Use descending order - we want the largest probabilty suggestions first!
        });
        var suggestions = suggestionDistribution.splice(0, ModelCompositor.MAX_SUGGESTIONS).map(function (value) {
            if (value.sample['p']) {
                // For analysis / debugging
                value.sample['lexical-p'] = value.sample['p'];
                value.sample['correction-p'] = value.p / value.sample['p'];
                // Use of the Trie model always exposed the lexical model's probability for a word to KMW.
                // It's useful for debugging right now, so may as well repurpose it as the posterior.
                //
                // We still condition on 'p' existing so that test cases aren't broken.
                value.sample['p'] = value.p;
            }
            //
            return value.sample;
        });
        if (keepOption) {
            suggestions = [keepOption].concat(suggestions);
        }
        // Apply 'after word' punctuation and casing (when applicable).  Also, set suggestion IDs.
        // We delay until now so that utility functions relying on the unmodified Transform may execute properly.
        var compositor = this;
        suggestions.forEach(function (suggestion) {
            // Valid 'keep' suggestions may have zero length; we still need to evaluate the following code
            // for such cases.
            // Do we need to manipulate the suggestion's transform based on the current state of the context?
            if (!context.right) {
                suggestion.transform.insert += punctuation.insertAfterWord;
            }
            else {
                // If we're mid-word, delete its original post-caret text.
                var tokenization = compositor.tokenize(context);
                if (tokenization && tokenization.caretSplitsToken) {
                    // While we wait on the ability to provide a more 'ideal' solution, let's at least
                    // go with a more stable, if slightly less ideal, solution for now.
                    //
                    // A predictive text default (on iOS, at least) - immediately wordbreak
                    // on suggestions accepted mid-word.
                    suggestion.transform.insert += punctuation.insertAfterWord;
                }
            }
            // If this is a suggestion after wordbreak input, make sure we preserve the wordbreak transform!
            if (prefixTransform) {
                var mergedTransform = models.buildMergedTransform(prefixTransform, suggestion.transform);
                mergedTransform.id = suggestion.transformId;
                // Temporarily and locally drops 'readonly' semantics so that we can reassign the transform.
                // See https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-8.html#improved-control-over-mapped-type-modifiers
                var mutableSuggestion = suggestion;
                // Assignment via by-reference behavior, as suggestion is an object
                mutableSuggestion.transform = mergedTransform;
            }
            suggestion.id = compositor.SUGGESTION_ID_SEED;
            compositor.SUGGESTION_ID_SEED++;
        });
        // Store the suggestions on the final token of the current context state (if it exists).
        // Or, once phrase-level suggestions are possible, on whichever token serves as each prediction's root.
        if (postContextState) {
            postContextState.tail.replacements = suggestions.map(function (suggestion) {
                return {
                    suggestion: suggestion,
                    tokenWidth: 1
                };
            });
        }
        return suggestions;
    };
    // Responsible for applying casing rules to suggestions.
    ModelCompositor.prototype.applySuggestionCasing = function (suggestion, baseWord, casingForm) {
        // Step 1:  does the suggestion replace the whole word?  If not, we should extend the suggestion to do so.
        var unchangedLength = baseWord.kmwLength() - suggestion.transform.deleteLeft;
        if (unchangedLength > 0) {
            suggestion.transform.deleteLeft += unchangedLength;
            suggestion.transform.insert = baseWord.kmwSubstr(0, unchangedLength) + suggestion.transform.insert;
        }
        // Step 2: Now that the transform affects the whole word, we may safely apply casing rules.
        suggestion.transform.insert = this.lexicalModel.applyCasing(casingForm, suggestion.transform.insert);
        suggestion.displayAs = this.lexicalModel.applyCasing(casingForm, suggestion.displayAs);
    };
    ModelCompositor.prototype.toAnnotatedSuggestion = function (suggestion, annotationType, quoteBehavior) {
        if (quoteBehavior === void 0) { quoteBehavior = models.QuoteBehavior.default; }
        // A method-internal 'import' of the enum.
        var QuoteBehavior = models.QuoteBehavior;
        var defaultQuoteBehavior = QuoteBehavior.noQuotes;
        if (annotationType == 'keep' || annotationType == 'revert') {
            defaultQuoteBehavior = QuoteBehavior.useQuotes;
        }
        return {
            transform: suggestion.transform,
            transformId: suggestion.transformId,
            displayAs: QuoteBehavior.apply(quoteBehavior, suggestion.displayAs, this.punctuation, defaultQuoteBehavior),
            tag: annotationType,
            p: suggestion.p
        };
    };
    /**
     * Returns the punctuation used for this model, filling out unspecified fields
     */
    ModelCompositor.determinePunctuationFromModel = function (model) {
        var defaults = DEFAULT_PUNCTUATION;
        // Use the defaults of the model does not provide any punctuation at all.
        if (!model.punctuation)
            return defaults;
        var specifiedPunctuation = model.punctuation;
        var insertAfterWord = specifiedPunctuation.insertAfterWord;
        if (insertAfterWord !== '' && !insertAfterWord) {
            insertAfterWord = defaults.insertAfterWord;
        }
        var quotesForKeepSuggestion = specifiedPunctuation.quotesForKeepSuggestion;
        if (!quotesForKeepSuggestion) {
            quotesForKeepSuggestion = defaults.quotesForKeepSuggestion;
        }
        var isRTL = specifiedPunctuation.isRTL;
        // Default:  false / undefined, so no need to directly specify it.
        return {
            insertAfterWord: insertAfterWord,
            quotesForKeepSuggestion: quotesForKeepSuggestion,
            isRTL: isRTL
        };
    };
    ModelCompositor.prototype.acceptSuggestion = function (suggestion, context, postTransform) {
        // Step 1:  generate and save the reversion's Transform.
        var sourceTransform = suggestion.transform;
        var deletedLeftChars = context.left.kmwSubstr(-sourceTransform.deleteLeft, sourceTransform.deleteLeft);
        var insertedLength = sourceTransform.insert.kmwLength();
        var reversionTransform = {
            insert: deletedLeftChars,
            deleteLeft: insertedLength
        };
        // Step 2:  building the proper 'displayAs' string for the Reversion
        var postContext = context;
        if (postTransform) {
            // The code above restores the state to the context at the time the `Suggestion` was created.
            // `postTransform` handles any missing context that came later.
            reversionTransform = models.buildMergedTransform(reversionTransform, postTransform);
            // Now that we've built the reversion based upon the Suggestion's original context,
            // we manipulate it in order to get a proper 'displayAs' string.
            postContext = models.applyTransform(postTransform, postContext);
        }
        var revertedPrefix;
        var postContextTokenization = this.tokenize(postContext);
        if (postContextTokenization) {
            // Handles display string for reversions triggered by accepting a suggestion mid-token.
            if (postContextTokenization.left.length > 0) {
                revertedPrefix = postContextTokenization.left[postContextTokenization.left.length - 1];
            }
            else {
                revertedPrefix = '';
            }
            revertedPrefix += postContextTokenization.caretSplitsToken ? postContextTokenization.right[0] : '';
        }
        else {
            revertedPrefix = this.wordbreak(postContext);
        }
        var firstConversion = models.transformToSuggestion(reversionTransform);
        firstConversion.displayAs = revertedPrefix;
        // Build the actual Reversion, which is technically an annotated Suggestion.
        // Since we're outside of the standard `predict` control path, we'll need to
        // set the Reversion's ID directly.
        var reversion = this.toAnnotatedSuggestion(firstConversion, 'revert');
        if (suggestion.transformId != null) {
            reversion.transformId = -suggestion.transformId;
        }
        if (suggestion.id != null) {
            // Since a reversion inverts its source suggestion, we set its ID to be the
            // additive inverse of the source suggestion's ID.  Makes easy mapping /
            // verification later.
            reversion.id = -suggestion.id;
        }
        else {
            reversion.id = -this.SUGGESTION_ID_SEED;
            this.SUGGESTION_ID_SEED++;
        }
        // Step 3:  if we track Contexts, update the tracking data as appropriate.
        if (this.contextTracker) {
            var contextState = this.contextTracker.newest;
            if (!contextState) {
                contextState = this.contextTracker.analyzeState(this.lexicalModel, context);
            }
            contextState.tail.activeReplacementId = suggestion.id;
            var acceptedContext = models.applyTransform(suggestion.transform, context);
            this.contextTracker.analyzeState(this.lexicalModel, acceptedContext);
        }
        return reversion;
    };
    ModelCompositor.prototype.applyReversion = function (reversion, context) {
        // If we are unable to track context (because the model does not support LexiconTraversal),
        // we need a "fallback" strategy.
        var compositor = this;
        var fallbackSuggestions = function () {
            var revertedContext = models.applyTransform(reversion.transform, context);
            var suggestions = compositor.predict({ insert: '', deleteLeft: 0 }, revertedContext);
            suggestions.forEach(function (suggestion) {
                // A reversion's transform ID is the additive inverse of its original suggestion;
                // we revert to the state of said original suggestion.
                suggestion.transformId = -reversion.transformId;
            });
            return suggestions;
        };
        if (!this.contextTracker) {
            return fallbackSuggestions();
        }
        // When the context is tracked, we prefer the tracked information.
        var contextMatchFound = false;
        for (var c = this.contextTracker.count - 1; c >= 0; c--) {
            var contextState = this.contextTracker.item(c);
            if (contextState.tail.activeReplacementId == -reversion.id) {
                contextMatchFound = true;
                break;
            }
        }
        if (!contextMatchFound) {
            return fallbackSuggestions();
        }
        // Remove all contexts more recent than the one we're reverting to.
        while (this.contextTracker.newest.tail.activeReplacementId != -reversion.id) {
            this.contextTracker.popNewest();
        }
        this.contextTracker.newest.tail.revert();
        // Will need to be modified a bit if/when phrase-level suggestions are implemented.
        // Those will be tracked on the first token of the phrase, which won't be the tail
        // if they cover multiple tokens.
        var suggestions = this.contextTracker.newest.tail.replacements.map(function (trackedSuggestion) {
            return trackedSuggestion.suggestion;
        });
        suggestions.forEach(function (suggestion) {
            // A reversion's transform ID is the additive inverse of its original suggestion;
            // we revert to the state of said original suggestion.
            suggestion.transformId = -reversion.transformId;
        });
        return suggestions;
    };
    ModelCompositor.prototype.wordbreak = function (context) {
        var model = this.lexicalModel;
        if (model.wordbreaker || !model.wordbreak) {
            // We don't need a 12.0 / 13.0 compatibility mode here.
            // We're either relying on defaults or on the 14.0+ wordbreaker spec.
            var wordbreaker = model.wordbreaker || wordBreakers.default;
            return models.wordbreak(wordbreaker, context);
        }
        else {
            // 1.  This model does not provide a model following the 14.0+ wordbreaking spec
            // 2.  This model DOES define a custom wordbreaker following the 12.0-13.0 spec.
            // Since the model relies on custom wordbreaking behavior, we need to use the
            // old, deprecated wordbreaking pattern.
            return model.wordbreak(context);
        }
    };
    ModelCompositor.prototype.tokenize = function (context) {
        var model = this.lexicalModel;
        if (model.wordbreaker) {
            return models.tokenize(model.wordbreaker, context);
        }
        else {
            return null;
        }
    };
    ModelCompositor.prototype.resetContext = function (context) {
        // Force-resets the context, throwing out any previous fat-finger data, etc.
        // Designed for use when the caret has been directly moved and/or the context sourced from a different control
        // than before.
        if (this.contextTracker) {
            var tokenizedContext = models.tokenize(this.lexicalModel.wordbreaker || wordBreakers.default, context);
            var contextState = correction.ContextTracker.modelContextState(tokenizedContext.left, null, this.lexicalModel);
            this.contextTracker.enqueue(contextState);
        }
    };
    ModelCompositor.prototype.detectCurrentCasing = function (context) {
        var _a;
        var model = this.lexicalModel;
        var text = this.wordbreak(context);
        if (!model.languageUsesCasing) {
            throw "Invalid attempt to detect casing: languageUsesCasing is set to false";
        }
        if (!model.applyCasing) {
            // The worker should automatically 'sub in' default behavior during the model's load if that
            // function isn't defined explicitly as part of the model.
            throw "Invalid LMLayer state:  languageUsesCasing is set to true, but no applyCasing function exists";
        }
        // If the user has selected Shift or Caps layer, that overrides our
        // text analysis
        if (context.casingForm == 'upper' || context.casingForm == 'initial') {
            return context.casingForm;
        }
        if (model.applyCasing('lower', text) == text) {
            return 'lower';
        }
        else if (model.applyCasing('upper', text) == text) {
            // If only a single character has been input, assume we're in 'initial' mode.
            return text.kmwLength() > 1 ? 'upper' : 'initial';
        }
        else if (model.applyCasing('initial', text) == text) {
            // We check 'initial' last, as upper-case input is indistinguishable.
            return 'initial';
        }
        else {
            // If we do not have a casing form given to us by the keyboard, then
            // 'null' is returned when no casing pattern matches the input.
            return (_a = context.casingForm) !== null && _a !== void 0 ? _a : null;
        }
    };
    ModelCompositor.MAX_SUGGESTIONS = 12;
    /**
     * Controls the strength of anti-corrective measures for single-character scenarios.
     * The base key probability will be raised to this power for this specific case.
     *
     * Current selection's motivation:  (0.5 / 0.4) ^ 16 ~= 35.5.
     * - if the most likely has p=0.5 and second-most has p=0.4 - a highly-inaccurate key
     *   stroke - the net effect will apply a factor of 35.5 to the lexical probability of
     *   the best key's prediction roots, favoring it in this manner.
     * - less extreme edge cases will have a significantly stronger factor, acting as a
     *   "soft threshold".
     * - truly ambiguous, "coin flip" cases will have a lower factor and thus favor the
     *   more likely words from the pair.
     *   - Our OSK key-element borders aren't visible to the user, so the 'spot' where
     *     behavior changes might feel arbitrary to users if we used a hard threshold instead.
     */
    ModelCompositor.SINGLE_CHAR_KEY_PROB_EXPONENT = 16;
    return ModelCompositor;
}());
/**
 * The default punctuation and spacing produced by the model.
 */
var DEFAULT_PUNCTUATION = {
    quotesForKeepSuggestion: { open: "\u201C", close: "\u201D" },
    insertAfterWord: " ",
};
var TransformUtils = /** @class */ (function () {
    function TransformUtils() {
    }
    TransformUtils.isWhitespace = function (transform) {
        // Matches a string that is entirely one or more characters with Unicode general property Z* or the following: CR, LF, and Tab.
        var whitespaceRemover = /^[\u0009\u000A\u000D\u0020\u00a0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u202f\u205f\u3000]+$/i;
        return transform.insert.match(whitespaceRemover) != null;
    };
    TransformUtils.isBackspace = function (transform) {
        return transform.insert == "" && transform.deleteLeft > 0 && !transform.deleteRight;
    };
    TransformUtils.isEmpty = function (transform) {
        return transform.insert == '' && transform.deleteLeft == 0 && !transform.deleteRight;
    };
    return TransformUtils;
}());
/*
 * Copyright (c) 2018 National Research Council Canada (author: Eddie A. Santos)
 * Copyright (c) 2018 SIL International
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
/**
 * @file index.ts
 *
 * The main LMLayerWorker class, the top-level class within the Web Worker.
 * The LMLayerWorker handles the keyboard/worker communication
 * protocol, delegating prediction requests to the language
 * model implementations.
 */
/// <reference types="@keymanapp/lm-message-types" />
/// <reference path="./models/dummy-model.ts" />
/// <reference path="./model-compositor.ts" />
/// <reference path="./transformUtils.ts" />
/**
 * Encapsulates all the state required for the LMLayer's worker thread.
 *
 * Implements the state pattern. There are three states:
 *
 *  - `unconfigured`  (initial state before configuration)
 *  - `modelless`     (state without model loaded)
 *  - `ready`         (state with model loaded, accepts prediction requests)
 *
 * Transitions are initiated by valid messages. Invalid
 * messages are errors, and do not lead to transitions.
 *
 *          +-------------+    load    +---------+
 *   config |             |----------->|         |
 *  +------->  modelless  +            +  ready  +---+
 *          |             |<-----------|         |   |
 *          +-------------+   unload   +----^----+   | predict
 *                                          |        |
 *                                          +--------+
 *
 * The model and the configuration are ONLY relevant in the `ready` state;
 * as such, they are NOT direct properties of the LMLayerWorker.
 */
var LMLayerWorker = /** @class */ (function () {
    function LMLayerWorker(options) {
        if (options === void 0) { options = {
            importScripts: null,
            postMessage: null
        }; }
        this._testMode = false;
        this._postMessage = options.postMessage || postMessage;
        this._importScripts = options.importScripts || importScripts;
        this.setupConfigState();
    }
    LMLayerWorker.prototype.error = function (message, error) {
        // error isn't a fan of being cloned across the worker boundary.
        this.cast('error', {
            log: message,
            error: (error && error.stack) ? error.stack : undefined
        });
    };
    /**
     * A function that can be set as self.onmessage (the Worker
     * message handler).
     * NOTE! You must bind it to a specific instance, e.g.:
     *
     *   // Do this!
     *   self.onmessage = worker.onMessage.bind(worker);
     *
     * Incorrect:
     *
     *   // Don't do this!
     *   self.onmessage = worker.onMessage;
     *
     * See: .install();
     */
    LMLayerWorker.prototype.onMessage = function (event) {
        var message = event.data.message;
        // Ensure the message is tagged with a valid message tag.
        if (!message) {
            throw new Error("Missing required 'message' property: ".concat(event.data));
        }
        // If last load was for this exact model file, squash the message.
        // (Though not if we've had an unload since.)
        var im = event.data;
        if (im.message == 'load') {
            var data = im;
            var duplicated = false;
            if (this._currentModelSource && data.source.type == this._currentModelSource.type) {
                if (data.source.type == 'file' && data.source.file == this._currentModelSource.file) {
                    duplicated = true;
                }
                else if (data.source.type == 'raw' && data.source.code == this._currentModelSource.code) {
                    duplicated = true;
                }
            }
            if (duplicated) {
                // Some JS implementations don't allow web workers access to the console.
                if (typeof console !== 'undefined') {
                    console.warn("Duplicate model load message detected - squashing!");
                }
                return;
            }
            else {
                this._currentModelSource = data.source;
            }
        }
        else if (im.message == 'unload') {
            this._currentModelSource = null;
        }
        // We got a message! Delegate to the current state.
        this.state.handleMessage(im);
    };
    /**
     * Sends back a message structured according to the protocol.
     * @param message A message type.
     * @param payload The message's payload. Can have any properties, except 'message'.
     */
    LMLayerWorker.prototype.cast = function (message, payload) {
        // Chrome raises "TypeError: invalid invocation" if postMessage is called
        // with any non-default value for `this`, i.e., this won't work:
        //
        //  this._postMessage({ foo: 'bar' });
        //
        // Yank it postMessage() off of `this` so that it's called on the
        // "global" context, and everything works again.
        var postMessage = this._postMessage;
        postMessage(__assign({ message: message }, payload));
    };
    /**
     * Loads a model by executing the given source code, and
     * passing in the appropriate configuration.
     *
     * @param desc         Type of the model to instantiate and its parameters.
     * @param capabilities Capabilities on offer from the keyboard.
     */
    LMLayerWorker.prototype.loadModel = function (model) {
        // TODO:  pass _platformConfig to model so that it can self-configure to the platform,
        // returning a Configuration.
        /* Note that this function is typically called from within an `importScripts` call.
         * For meaningful error messages to be successfully logged, we must catch what we can here
         * and pass a message to outside the worker - otherwise a generic "Script error" occurs.
         */
        try {
            var configuration = model.configure(this._platformCapabilities);
            // Handle deprecations.
            if (!configuration.leftContextCodePoints) {
                configuration.leftContextCodePoints = configuration.leftContextCodeUnits;
            }
            if (!configuration.rightContextCodePoints) {
                configuration.rightContextCodePoints = configuration.rightContextCodeUnits;
            }
            // Set reasonable defaults for the configuration.
            if (!configuration.leftContextCodePoints) {
                configuration.leftContextCodePoints = this._platformCapabilities.maxLeftContextCodePoints;
            }
            if (!configuration.rightContextCodePoints) {
                configuration.rightContextCodePoints = this._platformCapabilities.maxRightContextCodePoints || 0;
            }
            // Ensures that default casing rules exist for custom models that request casing rules but don't define them.
            if (model.languageUsesCasing && !model.applyCasing) {
                model.applyCasing = models.defaultApplyCasing;
            }
            var compositor = this.transitionToReadyState(model);
            // This test allows models to directly specify the property without it being auto-overridden by
            // this default.
            if (configuration.wordbreaksAfterSuggestions === undefined) {
                configuration.wordbreaksAfterSuggestions = (compositor.punctuation.insertAfterWord != '');
            }
            this.cast('ready', { configuration: configuration });
        }
        catch (err) {
            this.error("loadModel failed!", err);
        }
    };
    LMLayerWorker.prototype.loadModelFile = function (url) {
        // The self/global WebWorker method, allowing us to directly import another script file into WebWorker scope.
        // If built correctly, the model's script file will auto-register the model with loadModel() above.
        try {
            this._importScripts(url);
        }
        catch (err) {
            this.error("Error occurred when attempting to load dictionary", err);
        }
    };
    LMLayerWorker.prototype.unloadModel = function () {
        // Right now, this seems sufficient to clear out the old model.
        // The only existing reference to a loaded model is held by
        // transitionToReadyState's `handleMessage` closure. (The `model` var)
        this.transitionToLoadingState();
    };
    /**
     * Sets the initial state, i.e., `unconfigured`.
     * This state only handles `config` messages, and will
     * transition to the `modelless` state once it receives
     * the config data from the host platform.
     */
    LMLayerWorker.prototype.setupConfigState = function () {
        var _this_1 = this;
        this.state = {
            name: 'unconfigured',
            handleMessage: function (payload) {
                // ... that message must have been 'config'!
                if (payload.message !== 'config') {
                    throw new Error("invalid message; expected 'config' but got ".concat(payload.message));
                }
                _this_1._platformCapabilities = payload.capabilities;
                _this_1._testMode = !!payload.testMode;
                _this_1.transitionToLoadingState();
            }
        };
    };
    /**
     * Sets the model-loading state, i.e., `modelless`.
     * This state only handles `load` messages, and will
     * transition to the `ready` state once it receives a model
     * description and capabilities.
     */
    LMLayerWorker.prototype.transitionToLoadingState = function () {
        var _this = this;
        this.state = {
            name: 'modelless',
            handleMessage: function (payload) {
                // ...that message must have been 'load'!
                if (payload.message !== 'load') {
                    throw new Error("invalid message; expected 'load' but got ".concat(payload.message));
                }
                // TODO: validate configuration?
                if (payload.source.type == 'file') {
                    _this.loadModelFile(payload.source.file);
                }
                else {
                    // Creates a closure capturing all top-level names that the model must be able to reference.
                    // `eval` runs by scope rules; our virtualized worker needs a special scope for this to work.
                    //
                    // Reference: https://stackoverflow.com/a/40108685
                    // Note that we don't need `this`, but we do need the namespaces seen below.
                    var code_1 = payload.source.code;
                    var evalInContext = function (LMLayerWorker, models, correction, wordBreakers) {
                        eval(code_1);
                    };
                    evalInContext(_this, models, correction, wordBreakers);
                }
            }
        };
    };
    /**
     * Sets the state to `ready`. This requires a
     * fully-instantiated model. The `ready` state only responds
     * to `predict` message, and is an accepting state.
     *
     * @param model The loaded language model.
     */
    LMLayerWorker.prototype.transitionToReadyState = function (model) {
        var _this_1 = this;
        var compositor = new ModelCompositor(model, this._testMode);
        this.state = {
            name: 'ready',
            handleMessage: function (payload) {
                switch (payload.message) {
                    case 'predict':
                        var transform = payload.transform, context = payload.context;
                        var suggestions = compositor.predict(transform, context);
                        // Now that the suggestions are ready, send them out!
                        _this_1.cast('suggestions', {
                            token: payload.token,
                            suggestions: suggestions
                        });
                        break;
                    case 'wordbreak':
                        var brokenWord = models.wordbreak(model.wordbreaker || wordBreakers.default, payload.context);
                        _this_1.cast('currentword', {
                            token: payload.token,
                            word: brokenWord
                        });
                        break;
                    case 'unload':
                        _this_1.unloadModel();
                        break;
                    case 'accept':
                        var suggestion = payload.suggestion, context = payload.context, postTransform = payload.postTransform;
                        var reversion = compositor.acceptSuggestion(suggestion, context, postTransform);
                        _this_1.cast('postaccept', {
                            token: payload.token,
                            reversion: reversion
                        });
                        break;
                    case 'revert':
                        var reversion = payload.reversion, context = payload.context;
                        var suggestions = compositor.applyReversion(reversion, context);
                        _this_1.cast('postrevert', {
                            token: payload.token,
                            suggestions: suggestions
                        });
                        break;
                    case 'reset-context':
                        var context = payload.context;
                        compositor.resetContext(context);
                        break;
                    default:
                        throw new Error("invalid message; expected one of {'predict', 'wordbreak', 'accept', 'revert', 'reset-context', 'unload'} but got ".concat(payload.message));
                }
            },
            compositor: compositor
        };
        return compositor;
    };
    /**
     * Creates a new instance of the LMLayerWorker, and installs all its
     * functions within the provided Worker global scope.
     *
     * In production, this is called within the Worker's scope as:
     *
     *    LMLayerWorker.install(self);
     *
     * ...and this will setup onmessage and postMessage() appropriately.
     *
     * During testing, this method is useful to mock an entire global scope,
     *
     *    var fakeScope = { postMessage: ... };
     *    LMLayerWorker.install(fakeScope);
     *    // now we can spy on methods in fakeScope!
     *
     * @param scope A global scope to install upon.
     */
    LMLayerWorker.install = function (scope) {
        var worker = new LMLayerWorker({ postMessage: scope.postMessage, importScripts: scope.importScripts.bind(scope) });
        scope.onmessage = worker.onMessage.bind(worker);
        worker.self = scope;
        // Ensures that the worker instance is accessible for loaded model scripts.
        // Assists unit-testing.
        scope['LMLayerWorker'] = worker;
        scope['models'] = models;
        scope['correction'] = correction;
        scope['wordBreakers'] = wordBreakers;
        return worker;
    };
    return LMLayerWorker;
}());
// Let LMLayerWorker be available both in the browser and in Node.
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = LMLayerWorker;
    module.exports['correction'] = correction;
    module.exports['models'] = models;
    module.exports['wordBreakers'] = wordBreakers;
    /// XXX: export the ModelCompositor for testing.
    module.exports['ModelCompositor'] = ModelCompositor;
    module.exports['TransformUtils'] = TransformUtils;
}
else if (typeof self !== 'undefined' && 'postMessage' in self && 'importScripts' in self) {
    // Automatically install if we're in a Web Worker.
    LMLayerWorker.install(self); // really, 'as typeof globalThis', but we're currently getting TS errors from use of that.
}
else {
    //@ts-ignore
    window.LMLayerWorker = LMLayerWorker;
}
/*
 * Copyright (c) 2018 National Research Council Canada (author: Eddie A. Santos)
 * Copyright (c) 2018 SIL International
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
/// <reference types="@keymanapp/lm-message-types" />
//# sourceMappingURL=index.js.map
}
// --END:LMLlayerWorkerCode
